/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AddMoreETH": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_AddMoreETH_AddMoreETH_js__WEBPACK_IMPORTED_MODULE_67__["default"]; },
/* harmony export */   "Agreements": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_Agreements_Agreements__WEBPACK_IMPORTED_MODULE_32__["default"]; },
/* harmony export */   "AuthorizeTransaction": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_AuthorizeTransaction_AuthorizeTransaction__WEBPACK_IMPORTED_MODULE_68__["default"]; },
/* harmony export */   "Benefit": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_Benefit_Benefit__WEBPACK_IMPORTED_MODULE_33__["default"]; },
/* harmony export */   "Button": function() { return /* reexport safe */ _components_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_6__["default"]; },
/* harmony export */   "CancelOrderConfirmation": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_CancelOrderConfirmation_CancelOrderConfirmation__WEBPACK_IMPORTED_MODULE_69__["default"]; },
/* harmony export */   "Checkbox": function() { return /* reexport safe */ _components_Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_7__["default"]; },
/* harmony export */   "CheckoutSteps": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_CheckoutSteps_CheckoutSteps__WEBPACK_IMPORTED_MODULE_70__["default"]; },
/* harmony export */   "CircleTimer": function() { return /* reexport safe */ _components_DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_0__["default"]; },
/* harmony export */   "ConfirmRecoveryPhrase": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_ConfirmRecoveryPhrase_ConfirmRecoveryPhrase__WEBPACK_IMPORTED_MODULE_56__["default"]; },
/* harmony export */   "Confirmation": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_Confirmation_Confirmation__WEBPACK_IMPORTED_MODULE_71__["default"]; },
/* harmony export */   "ConfirmationMessage": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_Confirmation_ConfirmationMessage_ConfirmationMessage__WEBPACK_IMPORTED_MODULE_72__["default"]; },
/* harmony export */   "CopyLicenseID": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_CopyLicenseID_CopyLicenseID__WEBPACK_IMPORTED_MODULE_57__["default"]; },
/* harmony export */   "CreatePasscode": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_CreatePasscode_CreatePasscode_js__WEBPACK_IMPORTED_MODULE_58__["default"]; },
/* harmony export */   "CreateWalletSteps": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_CreateWalletSteps_CreateWalletSteps__WEBPACK_IMPORTED_MODULE_59__["default"]; },
/* harmony export */   "DisplayRecoveryPhrase": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_DisplayRecoveryPhrase_DisplayRecoveryPhrase__WEBPACK_IMPORTED_MODULE_60__["default"]; },
/* harmony export */   "DownloadSoftware": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_DownloadSoftware_DownloadSoftware__WEBPACK_IMPORTED_MODULE_42__["default"]; },
/* harmony export */   "EmailSent": function() { return /* reexport safe */ _components_CompositeComponents_Account_ResetPassword_EmailSent__WEBPACK_IMPORTED_MODULE_27__["default"]; },
/* harmony export */   "ForgotPassword": function() { return /* reexport safe */ _components_CompositeComponents_Account_ResetPassword_ForgotPassword__WEBPACK_IMPORTED_MODULE_28__["default"]; },
/* harmony export */   "InfoIcon": function() { return /* reexport safe */ _components_DataDisplay_InfoIcon_infoIcon__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "InitialsAgreement": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_NodeTermsAndConditions_InitialsAgreement_InitialsAgreement__WEBPACK_IMPORTED_MODULE_73__["default"]; },
/* harmony export */   "Input": function() { return /* reexport safe */ _components_Inputs_Input_Input__WEBPACK_IMPORTED_MODULE_8__["default"]; },
/* harmony export */   "LockInPrice": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_LockInPrice_LockInPrice__WEBPACK_IMPORTED_MODULE_74__["default"]; },
/* harmony export */   "LogIn": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_LogIn_LogIn__WEBPACK_IMPORTED_MODULE_34__["default"]; },
/* harmony export */   "Menu": function() { return /* reexport safe */ _components_Navigation_Menu_Menu__WEBPACK_IMPORTED_MODULE_10__["default"]; },
/* harmony export */   "MintRewards": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_MintRewards_MintRewards__WEBPACK_IMPORTED_MODULE_43__["default"]; },
/* harmony export */   "MobileGroup": function() { return /* reexport safe */ _components_PageAndLayout_Table_MobileGroup__WEBPACK_IMPORTED_MODULE_13__["default"]; },
/* harmony export */   "Modal": function() { return /* reexport safe */ _components_PageAndLayout_Modal_Modal__WEBPACK_IMPORTED_MODULE_14__["default"]; },
/* harmony export */   "ModalWithTextAndButton": function() { return /* reexport safe */ _components_PageAndLayout_ModalWithTextAndButton_ModalWithTextAndButton__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   "Navbar": function() { return /* reexport safe */ _components_Navigation_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_12__["default"]; },
/* harmony export */   "NodeActions": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_NodeActions_NodeActions__WEBPACK_IMPORTED_MODULE_44__["default"]; },
/* harmony export */   "NodeAgreements": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_NodeTermsAndConditions_NodeAgreements__WEBPACK_IMPORTED_MODULE_75__["default"]; },
/* harmony export */   "NodeData": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_Nodes_NodeData_NodeData__WEBPACK_IMPORTED_MODULE_45__["default"]; },
/* harmony export */   "NodesDisplay": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_Nodes_NodesDisplay__WEBPACK_IMPORTED_MODULE_46__["default"]; },
/* harmony export */   "OrderSummary": function() { return /* reexport safe */ _components_Feedback_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   "OverlayMenu": function() { return /* reexport safe */ _components_PageAndLayout_OverlayMenu_OverlayMenu__WEBPACK_IMPORTED_MODULE_16__["default"]; },
/* harmony export */   "PaginationItems": function() { return /* reexport safe */ _components_PageAndLayout_Table_Pagination_PaginationItems__WEBPACK_IMPORTED_MODULE_17__["default"]; },
/* harmony export */   "PaginationMenu": function() { return /* reexport safe */ _components_PageAndLayout_Table_Pagination_PaginationMenu__WEBPACK_IMPORTED_MODULE_18__["default"]; },
/* harmony export */   "PaginationPages": function() { return /* reexport safe */ _components_PageAndLayout_Table_Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_19__["default"]; },
/* harmony export */   "PaginationRowsPerPage": function() { return /* reexport safe */ _components_PageAndLayout_Table_Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_20__["default"]; },
/* harmony export */   "PasswordChanged": function() { return /* reexport safe */ _components_CompositeComponents_Account_ResetPassword_PasswordChanged__WEBPACK_IMPORTED_MODULE_29__["default"]; },
/* harmony export */   "PasswordStrengthIndicator": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_PasswordStrengthIndicator_PasswordStrengthIndicator__WEBPACK_IMPORTED_MODULE_35__["default"]; },
/* harmony export */   "PasswordTag": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_PasswordTag_PasswordTag__WEBPACK_IMPORTED_MODULE_36__["default"]; },
/* harmony export */   "PasswordValidation": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_PasswordValidation_PasswordValidation__WEBPACK_IMPORTED_MODULE_37__["default"]; },
/* harmony export */   "PaymentOptions": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_PaymentOptions_PaymentOptions__WEBPACK_IMPORTED_MODULE_76__["default"]; },
/* harmony export */   "ProcessOrder": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ProcessOrder_ProcessOrder__WEBPACK_IMPORTED_MODULE_77__["default"]; },
/* harmony export */   "Product": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_Product_Product__WEBPACK_IMPORTED_MODULE_78__["default"]; },
/* harmony export */   "ProductCounter": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ProductCounter_ProductCounter__WEBPACK_IMPORTED_MODULE_79__["default"]; },
/* harmony export */   "ProductList": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ProductList_ProductList__WEBPACK_IMPORTED_MODULE_80__["default"]; },
/* harmony export */   "ProductSummary": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_81__["default"]; },
/* harmony export */   "ProductSummaryListing": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ProductSummary_ProductSummaryListing_ProductSummaryListing__WEBPACK_IMPORTED_MODULE_82__["default"]; },
/* harmony export */   "ProgressCircle": function() { return /* reexport safe */ _components_DataDisplay_ProgressCircle_ProgressCircle__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   "ProgressIndicator": function() { return /* reexport safe */ _components_Feedback_ProgressIndicator_ProgressIndicator__WEBPACK_IMPORTED_MODULE_5__["default"]; },
/* harmony export */   "ReadonlyAgreement": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_NodeTermsAndConditions_ReadonlyAgreement_ReadonlyAgreement__WEBPACK_IMPORTED_MODULE_83__["default"]; },
/* harmony export */   "ReceiveFromExternalWallet": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_ReceiveFromExternalWallet_ReceiveFromExternalWallet__WEBPACK_IMPORTED_MODULE_61__["default"]; },
/* harmony export */   "ReceiveTab": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletFunctionality_ReceiveTab_ReceiveTab__WEBPACK_IMPORTED_MODULE_47__["default"]; },
/* harmony export */   "RecoveryPhrase": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_RecoveryPhrase_RecoveryPhrase__WEBPACK_IMPORTED_MODULE_62__["default"]; },
/* harmony export */   "RecoveryPhraseTag": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_RecoveryPhraseTag_RecoveryPhraseTag__WEBPACK_IMPORTED_MODULE_63__["default"]; },
/* harmony export */   "ReferAFriend": function() { return /* reexport safe */ _components_CompositeComponents_Account_ReferAFriend_ReferAFriend__WEBPACK_IMPORTED_MODULE_30__["default"]; },
/* harmony export */   "ResetPasswordForm": function() { return /* reexport safe */ _components_CompositeComponents_Account_ResetPassword_ResetPasswordForm__WEBPACK_IMPORTED_MODULE_31__["default"]; },
/* harmony export */   "ReviewOrder": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_ReviewOrder_ReviewOrder__WEBPACK_IMPORTED_MODULE_84__["default"]; },
/* harmony export */   "RewardsHistory": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_RewardsHistory_RewardsHistory__WEBPACK_IMPORTED_MODULE_48__["default"]; },
/* harmony export */   "SendConfirmation": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletFunctionality_SendConfirmation_SendConfirmation__WEBPACK_IMPORTED_MODULE_49__["default"]; },
/* harmony export */   "SendTab": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletFunctionality_SendTab_SendTab__WEBPACK_IMPORTED_MODULE_50__["default"]; },
/* harmony export */   "SessionExpired": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_SessionExpired_SessionExpired_js__WEBPACK_IMPORTED_MODULE_38__["default"]; },
/* harmony export */   "SetupProcessing": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_SetupProcessing_SetupProcessing__WEBPACK_IMPORTED_MODULE_64__["default"]; },
/* harmony export */   "Shopping": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_Shopping_Shopping__WEBPACK_IMPORTED_MODULE_85__["default"]; },
/* harmony export */   "SideMenu": function() { return /* reexport safe */ _components_Navigation_SideMenu_SideMenu__WEBPACK_IMPORTED_MODULE_11__["default"]; },
/* harmony export */   "SignatureAgreement": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_NodeTermsAndConditions_SignatureAgreement_SignatureAgreement__WEBPACK_IMPORTED_MODULE_86__["default"]; },
/* harmony export */   "SignatureInput": function() { return /* reexport safe */ _components_Inputs_SignatureInput_SignatureInput__WEBPACK_IMPORTED_MODULE_9__["default"]; },
/* harmony export */   "Signup": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_Signup_Signup__WEBPACK_IMPORTED_MODULE_39__["default"]; },
/* harmony export */   "SubmitOrder": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_SubmitOrder_SubmitOrder__WEBPACK_IMPORTED_MODULE_87__["default"]; },
/* harmony export */   "SubmitOrderForm": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_SubmitOrderForm_SubmitOrderForm__WEBPACK_IMPORTED_MODULE_88__["default"]; },
/* harmony export */   "Table": function() { return /* reexport safe */ _components_PageAndLayout_Table_Table__WEBPACK_IMPORTED_MODULE_21__["default"]; },
/* harmony export */   "TableFooter": function() { return /* reexport safe */ _components_PageAndLayout_Table_TableFooter__WEBPACK_IMPORTED_MODULE_22__["default"]; },
/* harmony export */   "TableHeader": function() { return /* reexport safe */ _components_PageAndLayout_Table_TableHeader__WEBPACK_IMPORTED_MODULE_23__["default"]; },
/* harmony export */   "TableRow": function() { return /* reexport safe */ _components_PageAndLayout_Table_TableRow__WEBPACK_IMPORTED_MODULE_24__["default"]; },
/* harmony export */   "Tabs": function() { return /* reexport safe */ _components_PageAndLayout_Tabs_Tabs__WEBPACK_IMPORTED_MODULE_25__["default"]; },
/* harmony export */   "ThankYouForMintingRewards": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_MintRewards_ThankYouForMintingRewards__WEBPACK_IMPORTED_MODULE_51__["default"]; },
/* harmony export */   "ThemeProvider": function() { return /* reexport safe */ _components_Utility_ThemeProvider__WEBPACK_IMPORTED_MODULE_26__["default"]; },
/* harmony export */   "TimerEndedCancelModal": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_CheckoutSteps_TimerEndedCancelModal_TimerEndedCancelModal__WEBPACK_IMPORTED_MODULE_89__["default"]; },
/* harmony export */   "Tooltip": function() { return /* reexport safe */ _components_DataDisplay_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_3__["default"]; },
/* harmony export */   "TransactionHistoryTab": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletFunctionality_TransactionHistoryTab_TransactionHistoryTab__WEBPACK_IMPORTED_MODULE_52__["default"]; },
/* harmony export */   "VaultNode": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletVault_VaultNode_VaultNode__WEBPACK_IMPORTED_MODULE_53__["default"]; },
/* harmony export */   "VerifyEmail": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_VerifyEmail_VerifyEmail__WEBPACK_IMPORTED_MODULE_40__["default"]; },
/* harmony export */   "Wallet": function() { return /* reexport safe */ _components_CompositeComponents_Shopping_Wallet_Wallet__WEBPACK_IMPORTED_MODULE_90__["default"]; },
/* harmony export */   "WalletCoin": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_WalletSetup_WalletCoin_WalletCoin__WEBPACK_IMPORTED_MODULE_65__["default"]; },
/* harmony export */   "WalletFunctionality": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletFunctionality_WalletFunctionality__WEBPACK_IMPORTED_MODULE_54__["default"]; },
/* harmony export */   "WalletSetup": function() { return /* reexport safe */ _components_CompositeComponents_SetupWallet_WalletSetup_WalletSetup__WEBPACK_IMPORTED_MODULE_66__["default"]; },
/* harmony export */   "WalletVault": function() { return /* reexport safe */ _components_CompositeComponents_Dashboard_WalletVault_WalletVault_js__WEBPACK_IMPORTED_MODULE_55__["default"]; },
/* harmony export */   "Welcome": function() { return /* reexport safe */ _components_CompositeComponents_AuthenticationAndEnrollment_Welcome_Welcome__WEBPACK_IMPORTED_MODULE_41__["default"]; },
/* harmony export */   "getIsPasswordValid": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_91__.getIsPasswordValid; }
/* harmony export */ });
/* harmony import */ var _components_DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _components_DataDisplay_InfoIcon_infoIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/* harmony import */ var _components_DataDisplay_ProgressCircle_ProgressCircle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _components_DataDisplay_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
/* harmony import */ var _components_Feedback_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22);
/* harmony import */ var _components_Feedback_ProgressIndicator_ProgressIndicator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24);
/* harmony import */ var _components_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27);
/* harmony import */ var _components_Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30);
/* harmony import */ var _components_Inputs_Input_Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32);
/* harmony import */ var _components_Inputs_SignatureInput_SignatureInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37);
/* harmony import */ var _components_Navigation_Menu_Menu__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42);
/* harmony import */ var _components_Navigation_SideMenu_SideMenu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47);
/* harmony import */ var _components_Navigation_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49);
/* harmony import */ var _components_PageAndLayout_Table_MobileGroup__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51);
/* harmony import */ var _components_PageAndLayout_Modal_Modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57);
/* harmony import */ var _components_PageAndLayout_ModalWithTextAndButton_ModalWithTextAndButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59);
/* harmony import */ var _components_PageAndLayout_OverlayMenu_OverlayMenu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61);
/* harmony import */ var _components_PageAndLayout_Table_Pagination_PaginationItems__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64);
/* harmony import */ var _components_PageAndLayout_Table_Pagination_PaginationMenu__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53);
/* harmony import */ var _components_PageAndLayout_Table_Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(55);
/* harmony import */ var _components_PageAndLayout_Table_Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52);
/* harmony import */ var _components_PageAndLayout_Table_Table__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(65);
/* harmony import */ var _components_PageAndLayout_Table_TableFooter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69);
/* harmony import */ var _components_PageAndLayout_Table_TableHeader__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(66);
/* harmony import */ var _components_PageAndLayout_Table_TableRow__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(68);
/* harmony import */ var _components_PageAndLayout_Tabs_Tabs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(70);
/* harmony import */ var _components_Utility_ThemeProvider__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(19);
/* harmony import */ var _components_CompositeComponents_Account_ResetPassword_EmailSent__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(72);
/* harmony import */ var _components_CompositeComponents_Account_ResetPassword_ForgotPassword__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(74);
/* harmony import */ var _components_CompositeComponents_Account_ResetPassword_PasswordChanged__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(76);
/* harmony import */ var _components_CompositeComponents_Account_ReferAFriend_ReferAFriend__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(78);
/* harmony import */ var _components_CompositeComponents_Account_ResetPassword_ResetPasswordForm__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(85);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_Agreements_Agreements__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(86);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_Benefit_Benefit__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(88);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_LogIn_LogIn__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(90);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_PasswordStrengthIndicator_PasswordStrengthIndicator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(92);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_PasswordTag_PasswordTag__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(94);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_PasswordValidation_PasswordValidation__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(98);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_SessionExpired_SessionExpired_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(100);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_Signup_Signup__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(103);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_VerifyEmail_VerifyEmail__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(105);
/* harmony import */ var _components_CompositeComponents_AuthenticationAndEnrollment_Welcome_Welcome__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(107);
/* harmony import */ var _components_CompositeComponents_Dashboard_DownloadSoftware_DownloadSoftware__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(109);
/* harmony import */ var _components_CompositeComponents_Dashboard_MintRewards_MintRewards__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(115);
/* harmony import */ var _components_CompositeComponents_Dashboard_NodeActions_NodeActions__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(117);
/* harmony import */ var _components_CompositeComponents_Dashboard_Nodes_NodeData_NodeData__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(119);
/* harmony import */ var _components_CompositeComponents_Dashboard_Nodes_NodesDisplay__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(124);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletFunctionality_ReceiveTab_ReceiveTab__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(126);
/* harmony import */ var _components_CompositeComponents_Dashboard_RewardsHistory_RewardsHistory__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(157);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletFunctionality_SendConfirmation_SendConfirmation__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(159);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletFunctionality_SendTab_SendTab__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(161);
/* harmony import */ var _components_CompositeComponents_Dashboard_MintRewards_ThankYouForMintingRewards__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(163);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletFunctionality_TransactionHistoryTab_TransactionHistoryTab__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(165);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletVault_VaultNode_VaultNode__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(167);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletFunctionality_WalletFunctionality__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(169);
/* harmony import */ var _components_CompositeComponents_Dashboard_WalletVault_WalletVault_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(171);
/* harmony import */ var _components_CompositeComponents_SetupWallet_ConfirmRecoveryPhrase_ConfirmRecoveryPhrase__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(173);
/* harmony import */ var _components_CompositeComponents_SetupWallet_CopyLicenseID_CopyLicenseID__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(175);
/* harmony import */ var _components_CompositeComponents_SetupWallet_CreatePasscode_CreatePasscode_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(178);
/* harmony import */ var _components_CompositeComponents_SetupWallet_CreateWalletSteps_CreateWalletSteps__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(180);
/* harmony import */ var _components_CompositeComponents_SetupWallet_DisplayRecoveryPhrase_DisplayRecoveryPhrase__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(182);
/* harmony import */ var _components_CompositeComponents_SetupWallet_ReceiveFromExternalWallet_ReceiveFromExternalWallet__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(184);
/* harmony import */ var _components_CompositeComponents_SetupWallet_RecoveryPhrase_RecoveryPhrase__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(186);
/* harmony import */ var _components_CompositeComponents_SetupWallet_RecoveryPhraseTag_RecoveryPhraseTag__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(189);
/* harmony import */ var _components_CompositeComponents_SetupWallet_SetupProcessing_SetupProcessing__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(193);
/* harmony import */ var _components_CompositeComponents_SetupWallet_WalletSetup_WalletCoin_WalletCoin__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(196);
/* harmony import */ var _components_CompositeComponents_SetupWallet_WalletSetup_WalletSetup__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(200);
/* harmony import */ var _components_CompositeComponents_Shopping_AddMoreETH_AddMoreETH_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(202);
/* harmony import */ var _components_CompositeComponents_Shopping_AuthorizeTransaction_AuthorizeTransaction__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(204);
/* harmony import */ var _components_CompositeComponents_Shopping_CancelOrderConfirmation_CancelOrderConfirmation__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(205);
/* harmony import */ var _components_CompositeComponents_Shopping_CheckoutSteps_CheckoutSteps__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(214);
/* harmony import */ var _components_CompositeComponents_Shopping_Confirmation_Confirmation__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(217);
/* harmony import */ var _components_CompositeComponents_Shopping_Confirmation_ConfirmationMessage_ConfirmationMessage__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(218);
/* harmony import */ var _components_CompositeComponents_Shopping_NodeTermsAndConditions_InitialsAgreement_InitialsAgreement__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(222);
/* harmony import */ var _components_CompositeComponents_Shopping_LockInPrice_LockInPrice__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(224);
/* harmony import */ var _components_CompositeComponents_Shopping_NodeTermsAndConditions_NodeAgreements__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(227);
/* harmony import */ var _components_CompositeComponents_Shopping_PaymentOptions_PaymentOptions__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(234);
/* harmony import */ var _components_CompositeComponents_Shopping_ProcessOrder_ProcessOrder__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(237);
/* harmony import */ var _components_CompositeComponents_Shopping_Product_Product__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(240);
/* harmony import */ var _components_CompositeComponents_Shopping_ProductCounter_ProductCounter__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(242);
/* harmony import */ var _components_CompositeComponents_Shopping_ProductList_ProductList__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(245);
/* harmony import */ var _components_CompositeComponents_Shopping_ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(207);
/* harmony import */ var _components_CompositeComponents_Shopping_ProductSummary_ProductSummaryListing_ProductSummaryListing__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(209);
/* harmony import */ var _components_CompositeComponents_Shopping_NodeTermsAndConditions_ReadonlyAgreement_ReadonlyAgreement__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(230);
/* harmony import */ var _components_CompositeComponents_Shopping_ReviewOrder_ReviewOrder__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(247);
/* harmony import */ var _components_CompositeComponents_Shopping_Shopping_Shopping__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(249);
/* harmony import */ var _components_CompositeComponents_Shopping_NodeTermsAndConditions_SignatureAgreement_SignatureAgreement__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(228);
/* harmony import */ var _components_CompositeComponents_Shopping_SubmitOrder_SubmitOrder__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(252);
/* harmony import */ var _components_CompositeComponents_Shopping_SubmitOrderForm_SubmitOrderForm__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(253);
/* harmony import */ var _components_CompositeComponents_Shopping_CheckoutSteps_TimerEndedCancelModal_TimerEndedCancelModal__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(257);
/* harmony import */ var _components_CompositeComponents_Shopping_Wallet_Wallet__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(259);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(75);
// Load Components

// DATA DISPLAY







// FEEDBACK




// INPUTS






// NAGIVATION






// PAGE & LAYOUT















//UTILITY



// Composite Components
//ACCOUNT







// AUTHENTICATION












// DASHBOARD
















// SETUP WALLET













// SHOPPING




























/***/ }),
/* 1 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CircleTimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _circleTimer_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
var _excluded = ["timerStartDate", "timerEndDate", "radius", "baseColor", "percentCompleteColor", "message", "timerEndedCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function CircleTimer(_ref) {
  var timerStartDate = _ref.timerStartDate,
    timerEndDate = _ref.timerEndDate,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 100 : _ref$radius,
    baseColor = _ref.baseColor,
    percentCompleteColor = _ref.percentCompleteColor,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'Until your order expires' : _ref$message,
    _ref$timerEndedCallba = _ref.timerEndedCallback,
    timerEndedCallback = _ref$timerEndedCallba === void 0 ? function () {} : _ref$timerEndedCallba,
    rest = _objectWithoutProperties(_ref, _excluded);
  var timeInSeconds = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var timeInMs = timerEndDate.getTime() - timerStartDate.getTime();
    return Math.ceil(timeInMs / 1000);
  }, [timerStartDate, timerEndDate]);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__.getMinuteSecondDisplay)(timeInSeconds)),
    _useState2 = _slicedToArray(_useState, 2),
    displayTime = _useState2[0],
    setDisplayTime = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0.01),
    _useState4 = _slicedToArray(_useState3, 2),
    percentTimeElapsed = _useState4[0],
    setPercentTimeElapsed = _useState4[1];
  var countDownInterval;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function cleanUpInterval() {
      if (countDownInterval) {
        clearInterval(countDownInterval);
      }
    }
    function updateTimerDisplay() {
      var msLeft = timerEndDate.getTime() - Date.now();
      var secondsLeft = Math.ceil(msLeft / 1000);
      var minuteSecondDisplay = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__.getMinuteSecondDisplay)(secondsLeft);
      var percentTimeRemaining = secondsLeft / timeInSeconds * 100;
      var percentTimeElapsed = 100 - percentTimeRemaining || 0.01;
      setDisplayTime(minuteSecondDisplay);
      setPercentTimeElapsed(percentTimeElapsed);
      if (msLeft <= 0) {
        timerEndedCallback();
        cleanUpInterval();
      }
    }
    updateTimerDisplay();
    countDownInterval = setInterval(updateTimerDisplay, 1000);
    return cleanUpInterval;
  }, []);
  var dynamicCircleTimerStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      width: radius * 2,
      height: radius * 2,
      fontSize: radius * 0.17
    };
  }, [radius]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "circleTimer",
    style: dynamicCircleTimerStyles
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.ProgressCircle, {
    radius: radius,
    baseColor: baseColor,
    percentCompleteColor: percentCompleteColor,
    percentComplete: percentTimeElapsed,
    percentCompleteStyle: {
      transition: 'all 0.2s linear'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "timer",
    "data-care-qa": "circleTimerDisplayTime"
  }, displayTime), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "message",
    "data-care-qa": "circleTimerMessageText"
  }, message));
}
CircleTimer.propTypes = {
  timerStartDate: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Date).isRequired,
  timerEndDate: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Date).isRequired,
  /** The radius of the circle */
  radius: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
  /** The background color of the circle when there is no fill */
  baseColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** The color of the fill that shows what percentage complete the timer is */
  percentCompleteColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Customizeable text inside the circle underneath where the time remaining shows */
  message: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Called when the timer expires */
  timerEndedCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};

/***/ }),
/* 2 */
/***/ (function(module) {

"use strict";
module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ensureDisplayTimeHasTwoDigits": function() { return /* binding */ ensureDisplayTimeHasTwoDigits; },
/* harmony export */   "getMinuteSecondDisplay": function() { return /* binding */ getMinuteSecondDisplay; }
/* harmony export */ });
function getMinuteSecondDisplay(timeInSeconds) {
  if (timeInSeconds <= 0) {
    return "00:00";
  }
  var minutes = Math.floor(timeInSeconds / 60);
  var remainingSeconds = timeInSeconds % 60;
  var displayMinutes = ensureDisplayTimeHasTwoDigits(minutes);
  var displaySeconds = ensureDisplayTimeHasTwoDigits(remainingSeconds);
  return "".concat(displayMinutes, ":").concat(displaySeconds);
}
function ensureDisplayTimeHasTwoDigits(time) {
  if (time < 10) {
    return '0' + time;
  }
  return time;
}

/***/ }),
/* 4 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 5 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(6);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(9)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(14)();
}


/***/ }),
/* 6 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(7);
} else {
  module.exports = __webpack_require__(8);
}


/***/ }),
/* 7 */
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 8 */
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),
/* 9 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(6);
var assign = __webpack_require__(10);

var ReactPropTypesSecret = __webpack_require__(11);
var has = __webpack_require__(12);
var checkPropTypes = __webpack_require__(13);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 10 */
/***/ (function(module) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 12 */
/***/ (function(module) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 13 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(11);
  var loggedTypeFailures = {};
  var has = __webpack_require__(12);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 14 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(11);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 15 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InfoIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["tooltipText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function InfoIcon(_ref) {
  var _ref$tooltipText = _ref.tooltipText,
    tooltipText = _ref$tooltipText === void 0 ? '' : _ref$tooltipText,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-hidden": "true"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("title", null, tooltipText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
  }));
}
InfoIcon.propTypes = {
  tooltipText: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};

/***/ }),
/* 16 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProgressCircle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _progressCircle_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
var _excluded = ["radius", "percentComplete", "baseColor", "percentCompleteColor", "percentCompleteLineCap", "percentCompleteStyle"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





// https://www.fullstacklabs.co/blog/creating-an-svg-gauge-component-from-scratch
function ProgressCircle(_ref) {
  var _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 100 : _ref$radius,
    _ref$percentComplete = _ref.percentComplete,
    percentComplete = _ref$percentComplete === void 0 ? 25 : _ref$percentComplete,
    baseColor = _ref.baseColor,
    percentCompleteColor = _ref.percentCompleteColor,
    _ref$percentCompleteL = _ref.percentCompleteLineCap,
    percentCompleteLineCap = _ref$percentCompleteL === void 0 ? 'round' : _ref$percentCompleteL,
    _ref$percentCompleteS = _ref.percentCompleteStyle,
    percentCompleteStyle = _ref$percentCompleteS === void 0 ? {} : _ref$percentCompleteS,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__.useTheme)();
  if (!baseColor) {
    baseColor = (theme === null || theme === void 0 ? void 0 : theme.secondaryColor) || '#d6d6d6';
  }
  if (!percentCompleteColor) {
    percentCompleteColor = (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#226666';
  }
  var progressCircleWidth = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return radius * 0.14;
  }, [radius]);
  var innerRadius = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return radius - progressCircleWidth / 2;
  }, [radius, progressCircleWidth]);
  var circumference = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return innerRadius * 2 * Math.PI;
  }, [innerRadius]);
  var strokeDasharray = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return "".concat(circumference, " ").concat(circumference);
  }, [circumference]);
  var percentCompleteNormalized = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return Math.min(Math.max(percentComplete, 0), 100);
  }, [percentComplete]);
  var percentCompleteTransform = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return "rotate(270, ".concat(radius, ", ").concat(radius, ")");
  }, [radius]);
  var percentCompleteOffset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return circumference - percentCompleteNormalized / 100 * circumference;
  }, [circumference, percentCompleteNormalized]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    height: radius * 2,
    width: radius * 2,
    className: "progressCircle"
  }, rest), "\u200D", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
    className: "base",
    cx: radius,
    cy: radius,
    fill: "transparent",
    r: innerRadius,
    stroke: baseColor,
    strokeWidth: progressCircleWidth
  }), "\u200D", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
    className: "percentComplete",
    cx: radius,
    cy: radius,
    fill: "transparent",
    r: innerRadius,
    stroke: percentCompleteColor,
    strokeWidth: progressCircleWidth,
    strokeDasharray: strokeDasharray,
    strokeDashoffset: percentCompleteOffset,
    strokeLinecap: percentCompleteLineCap,
    style: percentCompleteStyle,
    transform: percentCompleteTransform
  }));
}
ProgressCircle.propTypes = {
  /** The radius of the circle */
  radius: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** What percentage of the circle should be filled up */
  percentComplete: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** The background color of the circle when there is no fill */
  baseColor: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The color of the fill that shows what percentage is complete */
  percentCompleteColor: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The shape of the line cap of the fill */
  percentCompleteLineCap: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['round', 'square', 'butt']),
  /** A style prop that will be applied to the percent complete fill area. This is useful for applying transitions or other custom styles */
  percentCompleteStyle: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};

/***/ }),
/* 17 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 18 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useTheme": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19);


function useTheme() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ThemeProvider__WEBPACK_IMPORTED_MODULE_1__.ThemeContext);
}

/***/ }),
/* 19 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ThemeContext": function() { return /* binding */ ThemeContext; },
/* harmony export */   "default": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var defaultTheme = {
  theme: {
    brandName: '',
    primaryColor: '',
    secondaryColor: ''
  }
};
var ThemeContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultTheme);
function ThemeProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(ThemeContext.Provider, {
    value: theme
  }, children);
}
ThemeProvider.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  theme: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
    brandName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    primaryColor: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    secondaryColor: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
  })
};
ThemeProvider.defaultProps = _objectSpread({}, defaultTheme);

/***/ }),
/* 20 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _tooltip_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
var _excluded = ["popupContent", "popupPosition", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function Tooltip(_ref) {
  var popupContent = _ref.popupContent,
    popupPosition = _ref.popupPosition,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var defaultPosition = {
    top: '0',
    left: '50%',
    transform: 'translate(-50%, calc(-100% - 10px))'
  };
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__.useTheme)();
  var popupRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(popupPosition || defaultPosition),
    _useState4 = _slicedToArray(_useState3, 2),
    popupStyles = _useState4[0],
    setPopupStyles = _useState4[1];

  // make sure the popup is positioned so that it's visible on the screen
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    try {
      // if popupPosition prop is provided, don't auto-position the popup
      if (popupPosition) {
        return;
      }

      // if we don't have the popup ref for some reason, end here
      if (!showPopup || !popupRef || !popupRef.current) {
        return;
      }
      var popup = popupRef.current;
      var popupRect = popup.getBoundingClientRect();

      // if the popup is already within the bounds of the screen, end here
      if (popupRect.top > 0 && popupRect.bottom < window.innerHeight && popupRect.left > 0 && popupRect.right < window.innerWidth) {
        return;
      }

      // default the new position to the current position
      var _popup$style = popup.style,
        left = _popup$style.left,
        right = _popup$style.right,
        top = _popup$style.top,
        bottom = _popup$style.bottom,
        transform = _popup$style.transform;
      var _transform$replace$sp = transform.replace(/translate\((.*)\)/, '$1').split(','),
        _transform$replace$sp2 = _slicedToArray(_transform$replace$sp, 2),
        currentTranslateX = _transform$replace$sp2[0],
        currentTranslateY = _transform$replace$sp2[1];
      var newPosition = {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        translateX: currentTranslateX,
        translateY: currentTranslateY
      };
      if (popupRect.top < 0) {
        newPosition.top = undefined;
        newPosition.bottom = '0';
        newPosition.translateY = 'calc(100% + 10px)';
      }
      if (popupRect.bottom > window.innerHeight) {
        newPosition.bottom = undefined;
        newPosition.top = '0';
        newPosition.translateY = 'calc(-100% - 10px)';
      }
      if (popupRect.left < 0) {
        newPosition.left = undefined;
        newPosition.right = '0';
        newPosition.translateX = 'calc(100% - 10px)';
      }
      if (popupRect.right > window.innerWidth) {
        newPosition.left = '0';
        newPosition.right = undefined;
        newPosition.translateX = 'calc(-100% + 10px)';
      }
      var newPopupStyles = _objectSpread(_objectSpread({}, popupStyles), {}, {
        left: newPosition.left,
        right: newPosition.right,
        top: newPosition.top,
        bottom: newPosition.bottom,
        transform: "translate(".concat(newPosition.translateX, ", ").concat(newPosition.translateY, ")")
      });
      setPopupStyles(newPopupStyles);
    } catch (e) {
      console.log('Error adjusting tooltip popup position: ', e);
    }
  }, [showPopup]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltipContainer ".concat(className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "tooltip"
  }, rest)), showPopup && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "popupContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "popup",
    ref: popupRef,
    style: popupStyles
  }, popupContent)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "childrenWrapper",
    onMouseOver: function onMouseOver() {
      return setShowPopup(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowPopup(false);
    }
  }, children));
}
Tooltip.propTypes = {
  /** The content inside the popup on hover. This can be a string, a jsx element, or a React component */
  popupContent: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** The defined position for the popup to appear at in relation to the children element(s) that trigger the popup */
  popupPosition: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    top: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    bottom: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    left: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    right: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    transform: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
  }),
  /** optional className to be applied to the outermost div */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The Tooltip component is used as a parent element of whatever element you would like to have an onHover popup. For Example: `<Tooltip popupContent='something'><p>hover on me</p></Tooltip>` */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().element)
};

/***/ }),
/* 21 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 22 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OrderSummary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _orderSummary_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
var _excluded = ["orderSummaryText", "orderDate", "paymentType", "walletLogo", "walletText", "orderNumber", "transactionHash", "transactionLink"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function OrderSummary(_ref) {
  var orderSummaryText = _ref.orderSummaryText,
    orderDate = _ref.orderDate,
    paymentType = _ref.paymentType,
    walletLogo = _ref.walletLogo,
    walletText = _ref.walletText,
    orderNumber = _ref.orderNumber,
    transactionHash = _ref.transactionHash,
    transactionLink = _ref.transactionLink,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "flexRow orderSummary"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading1"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.dateHeading) || 'Order Date'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryData",
    "data-core-qa": "orderSummaryContent1"
  }, orderDate)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading2"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.paymentHeading) || 'Payment Type'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryData",
    "data-core-qa": "orderSummaryContent2"
  }, paymentType)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading3"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.walletHeading) || 'Wallet'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "walletLogo",
    src: walletLogo,
    alt: "wallet"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryData",
    "data-core-qa": "orderSummaryContent3"
  }, walletText))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading4"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.orderHeading) || 'Order Number'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryData",
    "data-core-qa": "orderSummaryContent4"
  }, orderNumber)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading5"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.txnHashHeading) || 'Transaction Hash'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "txIcon"
  }, "Tx"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryData",
    "data-core-qa": "orderSummaryContent5"
  }, transactionHash))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn orderColumn"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "orderSummaryText orderSummaryHeader",
    "data-core-qa": "orderSummaryHeading6"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.etherscanHeading) || 'Etherscan'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    className: "transactionLink",
    onClick: transactionLink,
    "data-core-qa": "orderSummaryButtonViewTrans"
  }, (orderSummaryText === null || orderSummaryText === void 0 ? void 0 : orderSummaryText.etherscanLink) || 'View Transaction')));
}
OrderSummary.propTypes = {
  /** Customizable text for headings and link */
  orderSummaryText: {
    dateHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    paymentHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    walletHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    orderHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    txnHashHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    etherscanHeading: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    etherscanLink: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
  },
  /** Shows in the `Order Date` column */
  orderDate: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** Shows in the `Payment Type` column */
  paymentType: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** Shows in the `Wallet` column */
  walletLogo: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
  /** Shows in the `Wallet` column */
  walletText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** Shows in the `Order Number` column */
  orderNumber: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** Shows in the `Transaction Hash` column */
  transactionHash: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** The URL for the link in the `Etherscan` column */
  transactionLink: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)
};

/***/ }),
/* 23 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 24 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProgressIndicator; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_nerdCoreKit_CheckIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
/* harmony import */ var _progressIndicator_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26);
var _excluded = ["steps", "currentIndex", "stepIcons"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function ProgressIndicator(_ref) {
  var steps = _ref.steps,
    currentIndex = _ref.currentIndex,
    stepIcons = _ref.stepIcons,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__.useTheme)();
  function iconForStep(index) {
    if (currentIndex < index) {
      return (stepIcons === null || stepIcons === void 0 ? void 0 : stepIcons.uncompletedStepIcon) || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "icon uncompletedStepIcon",
        style: {
          borderColor: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
        }
      });
    }
    if (currentIndex === index) {
      return (stepIcons === null || stepIcons === void 0 ? void 0 : stepIcons.currentStepIcon) || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "icon currentStepIcon",
        style: {
          backgroundColor: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
        }
      });
    }
    if (currentIndex > index) {
      return (stepIcons === null || stepIcons === void 0 ? void 0 : stepIcons.completedStepIcon) || /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_CheckIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
        color: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260',
        className: "completedStepIcon"
      });
    }
  }
  var completePercent = 100 * (currentIndex + 1) / steps.length;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "progressIndicator"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "progressIndicatorBar"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "complete",
    style: {
      width: "".concat(completePercent, "%"),
      backgroundColor: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow steps"
  }, steps.map(function (step, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "flexRow progressStep",
      key: i
    }, iconForStep(i), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "stepLabel",
      style: {
        color: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
      },
      "data-core-qa": "progressIndStepText".concat(i)
    }, step.label));
  })));
}
ProgressIndicator.propTypes = {
  /** An array of objects, each object must contain a `label` attribute. This is the label that shows for each step */
  steps: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    label: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired)
  })).isRequired,
  /** The index of the current step */
  currentIndex: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
  /** Pass in 3 icons, one to be shown on steps that are incomplete, one to be shown on the current step, and one to be shown on completed steps */
  stepIcons: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    uncompletedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    currentStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    completedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
  })
};

/***/ }),
/* 25 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["color", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function CheckIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 30 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: size,
    height: size
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "checkIcon-a"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "checkIcon-b"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "checkIcon-c"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "checkIcon-d"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "checkIcon-e"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("polygon", {
    fill: color,
    points: "14 21.41 9 16.41 10.41 15 14 18.59 21.58 11 23 12.42 14 21.41"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: color,
    d: "M16,2c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14S23.73,2,16,2Zm0,26c-6.63,0-12-5.37-12-12S9.37,4,16,4s12,5.37,12,12-5.37,12-12,12Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("rect", {
    fill: "none",
    id: "checkIcon-f",
    width: "32",
    height: "32"
  })))))));
}
CheckIcon.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};

/***/ }),
/* 26 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 27 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
/* harmony import */ var _button_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29);
var _excluded = ["kind", "disabled", "loading", "className", "onClick", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Button = function Button(_ref) {
  var _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'solid' : _ref$kind,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__.useTheme)();
  var buttonCSSVariables = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var cssVariables = {
      '--backgroundColor': '#555',
      '--color': '#fff',
      '--borderColor': 'none',
      '--textDecoration': 'none'
    };
    if (!theme) {
      return cssVariables;
    }
    if (kind === 'solid') {
      cssVariables['--backgroundColor'] = theme.primaryColor || '#555';
    }
    if (kind === 'outlined') {
      cssVariables['--color'] = theme.primaryColor || '#555';
      cssVariables['--borderColor'] = theme.primaryColor || '#555';
    }
    if (kind === 'link') {
      cssVariables['--color'] = theme.primaryColor || '#555';
    }
    return cssVariables;
  }, [theme]);
  var loadingSpinnerCSSVariables = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (!loading) {
      return {};
    }
    if (kind === 'solid') {
      return {
        '--spinnerColor': (theme === null || theme === void 0 ? void 0 : theme.secondaryColor) || '#fff'
      };
    }
    if (kind === 'outlined') {
      return {
        '--spinnerColor': (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#555'
      };
    }
  }, [loading]);
  var buttonClassNames = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var classNames = "button ".concat(kind);
    if (className) classNames += " ".concat(className);
    if (disabled) classNames += " disabled";
    if (loading) classNames += ' disableCursor';
    return classNames;
  }, [disabled, loading]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", _extends({
    className: buttonClassNames,
    style: buttonCSSVariables,
    onClick: onClick,
    disabled: disabled || loading
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('buttonBackground', {
      loadingSpinner: loading
    }),
    style: loadingSpinnerCSSVariables
  }, children));
};
Button.propTypes = {
  /** The type of styling to be used. */
  kind: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf(['solid', 'outlined', 'link']),
  /** Whether the button is clickable. */
  disabled: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** If the button has the loading animation. */
  loading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** The name of the class used to style the button externally. */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** What happens when the button is clicked. */
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** the content of the button. */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
  /** What theme should be used. */
  theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    primaryColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    secondaryColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  })
};
/* harmony default export */ __webpack_exports__["default"] = (Button);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 29 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 30 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _checkbox_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31);
var _excluded = ["id", "checkboxClassName", "checked", "handleOnBlurCallback", "handleOnChangeCallback", "required", "title", "value", "labelText", "labelClassName"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function Checkbox(_ref) {
  var id = _ref.id,
    checkboxClassName = _ref.checkboxClassName,
    checked = _ref.checked,
    handleOnBlurCallback = _ref.handleOnBlurCallback,
    handleOnChangeCallback = _ref.handleOnChangeCallback,
    required = _ref.required,
    title = _ref.title,
    value = _ref.value,
    labelText = _ref.labelText,
    labelClassName = _ref.labelClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__.useTheme)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "checkbox-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    id: id,
    checked: checked,
    className: "checkbox-wrapper__input ".concat(checkboxClassName !== null && checkboxClassName !== void 0 ? checkboxClassName : ''),
    onBlur: handleOnBlurCallback,
    onChange: handleOnChangeCallback,
    style: {
      accentColor: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
    },
    required: required,
    title: title,
    type: "checkbox",
    value: value
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    htmlFor: id,
    className: "checkbox-wrapper__label ".concat(labelClassName !== null && labelClassName !== void 0 ? labelClassName : ''),
    "data-core-qa": "checkboxLabel".concat(id.split(' ')[0])
  }, labelText));
}
Checkbox.propTypes = {
  /** Required id that will be applied to the checkbox input */
  id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** Optional className that will be applied to the checkbox input */
  checkboxClassName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Boolean applied to the checkbox input */
  checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** Called when the input blur event happens */
  handleOnBlurCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** Called when the input value changes */
  handleOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** Applied to the checkbox input (useful when used in a form) */
  required: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** Applied to the checkbox input */
  title: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Applied to the checkbox input */
  value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any),
  /** Text that shows next to the checkbox */
  labelText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** Optional className applied to the labelText element */
  labelClassName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 31 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 32 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _assets_icons_nerdCoreKit_errorExclamationPoint_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var _assets_icons_nerdCoreKit_errorExclamationPoint_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_errorExclamationPoint_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_fontawesome_eye_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34);
/* harmony import */ var _assets_icons_fontawesome_eye_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_eye_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_icons_fontawesome_eye_slash_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35);
/* harmony import */ var _assets_icons_fontawesome_eye_slash_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_eye_slash_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _input_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36);
var _excluded = ["labelText", "invalid", "invalidText", "type", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function Input(_ref) {
  var labelText = _ref.labelText,
    invalid = _ref.invalid,
    invalidText = _ref.invalidText,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(type),
    _useState2 = _slicedToArray(_useState, 2),
    inputType = _useState2[0],
    setInputType = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setInputType(type);
  }, [type]);
  var togglePasswordVisibility = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (inputType === 'password') {
      return setInputType('text');
    } else {
      return setInputType('password');
    }
  }, [inputType]);
  var passwordVisibilityIcon = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return inputType === 'password' ? (_assets_icons_fontawesome_eye_svg__WEBPACK_IMPORTED_MODULE_2___default()) : (_assets_icons_fontawesome_eye_slash_svg__WEBPACK_IMPORTED_MODULE_3___default());
  }, [inputType]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "inputComponent ".concat(className !== null && className !== void 0 ? className : '')
  }, labelText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    className: "label",
    "data-core-qa": "inputLabel".concat(labelText.split(' ')[0])
  }, labelText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "inputBorder ".concat(invalid ? 'error' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "inputWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
    className: "input",
    type: inputType
  }, rest)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: 'icons'
  }, invalid && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "icon",
    src: (_assets_icons_nerdCoreKit_errorExclamationPoint_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    alt: "error"
  }), type === 'password' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    "data-core-qa": "inputImgEye",
    onClick: togglePasswordVisibility,
    className: "icon passwordVisibilityIcon",
    src: passwordVisibilityIcon,
    alt: "toggle password visibility"
  })))), invalid && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "invalidText",
    "data-core-qa": "inputError".concat(labelText.split(' ')[0])
  }, invalidText));
}
Input.propTypes = {
  /** Optional label text to show above the input */
  labelText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Boolean indicating if the user input is invalid */
  invalid: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
  /** If the `invalid` prop is true, this text will show underneath the input */
  invalidText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Type of input to display. Password input hides user input and includes an 'eye' icon to toggle visibility. Type text and type email currently don't have any differences. */
  type: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(['text', 'password', 'email', 'tel']),
  /** An optional className that will be applied to the outermost div */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Input);

/***/ }),
/* 33 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg focusable='false' preserveAspectRatio='xMidYMid meet' xmlns='http://www.w3.org/2000/svg' fill='%23da1e28' width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' class='cds--text-input__invalid-icon'%3e %3cpath d='M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z'%3e %3c/path%3e %3cpath d='M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z' data-icon-path='inner-path' opacity='0'%3e %3c/path%3e %3c/svg%3e"

/***/ }),
/* 34 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg focusable='false' preserveAspectRatio='xMidYMid meet' xmlns='http://www.w3.org/2000/svg' fill='currentColor' width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' class='cds--icon-visibility-on'%3e%3cpath d='M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z'%3e%3c/path%3e%3cpath d='M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z'%3e%3c/path%3e%3c/svg%3e"

/***/ }),
/* 35 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg focusable='false' preserveAspectRatio='xMidYMid meet' xmlns='http://www.w3.org/2000/svg' fill='currentColor' width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' class='cds--icon-visibility-off'%3e%3cpath d='M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z'%3e%3c/path%3e%3cpath d='M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z'%3e%3c/path%3e%3c/svg%3e"

/***/ }),
/* 36 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 37 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_signature_canvas__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _signatureInput_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var SignatureInput = function SignatureInput(_ref) {
  var form = _ref.form,
    checkboxId = _ref.checkboxId,
    signatureCanvasId = _ref.signatureCanvasId,
    captureSignatureData = _ref.captureSignatureData,
    checkboxLabelText = _ref.checkboxLabelText,
    checkboxOnChangeCallback = _ref.checkboxOnChangeCallback,
    _ref$signatureTitle = _ref.signatureTitle,
    signatureTitle = _ref$signatureTitle === void 0 ? 'Sign Here' : _ref$signatureTitle;
  checkboxLabelText = checkboxLabelText || "I have fully read and understand the ".concat(form.name);
  var signatureRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  function saveSignatureData() {
    var signatureData = signatureRef.toDataURL();
    captureSignatureData(signatureData);
  }
  function clearCanvas() {
    signatureRef.clear();
    captureSignatureData('');
  }
  var handleUpdateCheckbox = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (newValue) {
    setIsChecked(newValue);
    checkboxOnChangeCallback(newValue);
  }, [checkboxOnChangeCallback]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreements"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h4", {
    className: "agreements__heading",
    "data-core-qa": "signatureFormName".concat(signatureCanvasId)
  }, "Agree to ", form.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "signatureFormContent".concat(signatureCanvasId),
    className: "agreements__description",
    dangerouslySetInnerHTML: {
      __html: form.content
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreements__checkWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Checkbox, {
    "data-core-qa": "signatureCheckbox".concat(signatureCanvasId),
    id: checkboxId,
    required: true,
    value: isChecked,
    onChange: function onChange(e) {
      return handleUpdateCheckbox(e.target.checked);
    },
    labelText: checkboxLabelText
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreements__title-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "agreements__clear",
    onClick: clearCanvas,
    "data-core-qa": "signatureClear".concat(signatureCanvasId)
  }, "Clear"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "agreements__title",
    "data-core-qa": "signatureInputFormTitle".concat(signatureCanvasId)
  }, signatureTitle)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreements__signature"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react_signature_canvas__WEBPACK_IMPORTED_MODULE_1___default()), {
    id: signatureCanvasId,
    canvasProps: {
      className: 'agreements__canvasSignature sigCanvas'
    },
    ref: function ref(_ref2) {
      signatureRef = _ref2;
    },
    onEnd: saveSignatureData,
    clearOnResize: false
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreements__divider"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", null)));
};
SignatureInput.propTypes = {
  form: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    agreementId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    content: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    agreementVersionId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    createdAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }).isRequired,
  checkboxId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  signatureCanvasId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  captureSignatureData: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  checkboxLabelText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  checkboxOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  signatureTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (SignatureInput);

/***/ }),
/* 38 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(5),__webpack_require__(2),__webpack_require__(39),__webpack_require__(40)):0}(this,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0,g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas()},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear()}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps())}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){e.exports=r}])});

/***/ }),
/* 39 */
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["default"] = (SignaturePad);


/***/ }),
/* 40 */
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),
/* 41 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 42 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemsShape": function() { return /* binding */ itemsShape; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43);
/* harmony import */ var _assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var _assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _menu_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







/*********************************************************************
 * internal MenuItem component that is consumed by the Menu component *
 **********************************************************************/
var MenuItem = function MenuItem(_ref) {
  var value = _ref.value,
    handleClick = _ref.handleClick,
    icon = _ref.icon,
    showIcons = _ref.showIcons;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-item",
    onClick: handleClick
  }, showIcons && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-item__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: icon
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-item__text",
    "data-core-qa": "menuTextValue"
  }, value));
};
MenuItem.propTypes = {
  value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
  icon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
  showIcons: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
MenuItem.defaultProps = {
  handleClick: function handleClick() {}
};

/***************************
 * external Menu component *
 ***************************/
var Menu = function Menu(_ref2) {
  var items = _ref2.items,
    menuLabelIcon = _ref2.menuLabelIcon,
    menuLabel = _ref2.menuLabel,
    menuLabelSecondary = _ref2.menuLabelSecondary,
    _ref2$showIcons = _ref2.showIcons,
    showIcons = _ref2$showIcons === void 0 ? false : _ref2$showIcons,
    handleMenuItemClick = _ref2.handleMenuItemClick;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useClickOutside = (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_1__["default"])({
      handleClick: function handleClick() {
        return setIsOpen(false);
      }
    }),
    ref = _useClickOutside.ref;
  var toggleIsOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    items.length && setIsOpen(function (prevState) {
      return !prevState;
    });
  }, [items]);
  var handleMenuItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (item) {
    setIsOpen(false);
    handleMenuItemClick(item);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-container",
    ref: ref
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-label",
    onClick: toggleIsOpen,
    "data-core-qa": "menuLabel"
  }, menuLabelIcon ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: menuLabelIcon,
    className: "menu-label__bar",
    "data-core-qa": "menuLabelHamburger"
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, menuLabel, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    "data-core-qa": "menuLabelArrow",
    src: isOpen ? (_assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_2___default()) : (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "menu-label__arrow"
  }), menuLabelSecondary)), isOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "menu-dropdown-container"
  }, items.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MenuItem, {
      key: item.key,
      value: item.value,
      handleClick: function handleClick() {
        return handleMenuItem(item);
      },
      icon: item.icon,
      showIcons: showIcons
    });
  })));
};
var itemsShape = {
  key: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  icon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
};
Menu.propTypes = {
  /** Icon displayed on visible button. */
  menuLabelIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
  /** Label on visible button. */
  menuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Smaller text that appears under the primary label. */
  menuLabelSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Array of items to be displayed on the dropdown list, each item having these attributes:
   * <br/> - key: The key of the menu item
   * <br/> - value: The value of the menu item
   * <br/> - icon: The icon to be used
   */
  items: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape(itemsShape)),
  /** Content of the menu. */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
  /** If icons should be shown or not. */
  showIcons: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
  /** A callback function that passes back all the routing info when the item is clicked on */
  handleMenuItemClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func)
};
Menu.defaultProps = {
  items: []
};
/* harmony default export */ __webpack_exports__["default"] = (Menu);

/***/ }),
/* 43 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useClickOutside(_ref) {
  var handleClick = _ref.handleClick;
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      handleClick();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return {
    ref: ref
  };
}
/* harmony default export */ __webpack_exports__["default"] = (useClickOutside);

/***/ }),
/* 44 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg id='icons'%3e%3cg id='Actions'%3e%3cg id='Navigation'%3e%3cg%3e%3cpolygon points='16 10 26 20 24.59 21.41 16 12.83 7.41 21.41 6 20 16 10'/%3e%3crect id='_Transparent_Rectangle_' class='cls-1' width='32' height='32'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 45 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.g%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg id='a'/%3e%3cg id='b'%3e%3cg id='c'%3e%3cg id='d'%3e%3cg id='e'%3e%3cg%3e%3cpolygon points='16 22 6 12 7.41 10.59 16 19.17 24.59 10.59 26 12 16 22'/%3e%3crect id='f' class='g' width='32' height='32'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 46 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 47 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sideMenu_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var ButtonIcon = function ButtonIcon() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "sideMenu__buttonIcon",
    viewBox: "0 0 256 512",
    fill: "currentColor",
    stroke: "currentColor"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M89.45 87.5l143.1 152c4.375 4.625 6.562 10.56 6.562 16.5c0 5.937-2.188 11.87-6.562 16.5l-143.1 152C80.33 434.1 65.14 434.5 55.52 425.4c-9.688-9.125-10.03-24.38-.9375-33.94l128.4-135.5l-128.4-135.5C45.49 110.9 45.83 95.75 55.52 86.56C65.14 77.47 80.33 77.87 89.45 87.5z"
  }));
};
function SideMenu(_ref) {
  var children = _ref.children,
    _ref$expandedWidth = _ref.expandedWidth,
    expandedWidth = _ref$expandedWidth === void 0 ? '250px' : _ref$expandedWidth,
    _ref$collapsedWidth = _ref.collapsedWidth,
    collapsedWidth = _ref$collapsedWidth === void 0 ? '125px' : _ref$collapsedWidth;
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__.useTheme)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuExpanded = _useState2[0],
    setIsMenuExpanded = _useState2[1];
  var sideMenuCSSVariables = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var cssVariables = {
      '--expandedWidth': expandedWidth,
      '--collapsedWidth': collapsedWidth,
      '--primaryColor': '#555',
      '--color': '#fff'
    };
    if (theme) {
      cssVariables['--primaryColor'] = theme.primaryColor || '#555';
    }
    return cssVariables;
  }, [theme]);
  var toggleIsExpanded = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setIsMenuExpanded(!isMenuExpanded);
  }, [isMenuExpanded]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "sideMenu",
    style: sideMenuCSSVariables
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: isMenuExpanded ? 'sideMenu__menu sideMenu__menu--expanded' : 'sideMenu__menu sideMenu__menu--collapsed'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    className: "sideMenu__toggleButton",
    onClick: toggleIsExpanded,
    "data-core-qa": "sideMenuButtonOpen"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sideMenu__iconWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(ButtonIcon, null))), children), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sideMenu__spacer"
  }));
}
SideMenu.propTypes = {
  /** Contents of the Menu */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** Width of SideMenu when expanded (e.g. '250px') */
  expandedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Width of SideMeny when collapsed (e.g. '125px') */
  collapsedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 48 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 49 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Navbar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
/* harmony import */ var _navbar_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50);





function Navbar(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    currentPath = _ref.currentPath,
    homePath = _ref.homePath,
    _ref$logoUrl = _ref.logoUrl,
    logoUrl = _ref$logoUrl === void 0 ? '' : _ref$logoUrl,
    isMobile = _ref.isMobile,
    menuIcon = _ref.menuIcon,
    menuLabel = _ref.menuLabel,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    _ref$navItems = _ref.navItems,
    navItems = _ref$navItems === void 0 ? [] : _ref$navItems,
    _ref$handleRoutingCal = _ref.handleRoutingCallback,
    handleRoutingCallback = _ref$handleRoutingCal === void 0 ? function () {} : _ref$handleRoutingCal;
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_2__.useTheme)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("nav", {
    className: "navbar"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "navbar-brand-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "navHomeIcon",
    onClick: function onClick() {
      return handleRoutingCallback({
        path: homePath
      });
    },
    className: "nav-item"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: logoUrl,
    alt: "company logo",
    width: "120",
    height: "40"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "navbar-left-container"
  }, navItems.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      key: item.key,
      className: "nav-item",
      style: {
        color: item.path === currentPath ? theme.primaryColor : null
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: function onClick() {
        return handleRoutingCallback(item);
      },
      "data-core-qa": "navItem".concat(item.key)
    }, item.value));
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "navbar-right-container"
  }, !isLoggedIn && !isMobile ? menuItems.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "auth-item",
      key: item.key
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: function onClick() {
        return handleRoutingCallback(item);
      },
      "data-core-qa": "navItem".concat(item.key)
    }, item.value));
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Menu, {
    items: menuItems,
    showIcons: true,
    menuLabel: menuLabel,
    menuLabelIcon: isMobile && menuIcon,
    handleMenuItemClick: handleRoutingCallback
  })));
}
var navItemShape = {
  path: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  key: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  icon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
Navbar.propTypes = {
  /** A boolean flag specifing whether the user is logged in or not */
  isLoggedIn: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** A string that specifies the current path of the app (ie. /dashboard or /purchase) */
  currentPath: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** A string that specifies the path of the root of the app (typically "/") */
  homePath: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** The path to either a local logo asset, or an externally hosted logo image */
  logoUrl: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** A boolean flag that specifies if the app is in a mobile view */
  isMobile: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** A path to either a local menu image asset, or an externally hosted menu image. This menu image will show when in a mobile view */
  menuIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** A string label that will show when logged in an not in a mobile view  */
  menuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** An array of object that will be displayed in the right hand menu */
  menuItems: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape(navItemShape)),
  /** An array of objects that will be displayed in the left navbar next to the logo */
  navItems: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape(navItemShape)),
  /** A callback function that handles the actual routing in the parent app */
  handleRoutingCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};

/***/ }),
/* 50 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 51 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MobileGroup; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52);
/* harmony import */ var _Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _mobileGroup_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56);





function MobileGroup(_ref) {
  var columnList = _ref.columnList,
    currentRowsPerPage = _ref.currentRowsPerPage,
    handleSortColumnsCallback = _ref.handleSortColumnsCallback,
    icons = _ref.icons,
    mobileTableHeader = _ref.mobileTableHeader,
    pages = _ref.pages,
    pageData = _ref.pageData,
    pagesMenuLabel = _ref.pagesMenuLabel,
    rowsMenuLabel = _ref.rowsMenuLabel,
    rowsPerPageList = _ref.rowsPerPageList,
    useIsMobile = _ref.useIsMobile;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("table", {
    className: "mobile-group-wrapper sticky-table"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("thead", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", {
    className: "mobile-group-wrapper__mobile-header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
    className: "mobile-group-wrapper__mobile-header--title",
    "data-core-qa": "mobileTableTitleText"
  }, mobileTableHeader), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
    className: "mobile-group-wrapper__mobile-header--menu"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_1__["default"], {
    rowsMenuLabel: rowsMenuLabel,
    currentRowsPerPage: currentRowsPerPage,
    rowsPerPageList: rowsPerPageList,
    menuDropdownDirection: 'down'
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tbody", null, columnList.map(function (columnListItem, i) {
    var title = Object.keys(columnListItem);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), {
      key: i
    }, title.map(function (rowTitle) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", {
        key: rowTitle,
        className: "mobile-group-wrapper__mobile-row\n                  ".concat(title.indexOf(rowTitle) === title.length - 1 ? 'mobile-group-wrapper__mobile-row--bottom' : rowTitle === title[0] ? 'mobile-group-wrapper__mobile-row--top' : null)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
        className: "mobile-group-wrapper__mobile-title-cell",
        id: rowTitle,
        onClick: function onClick(e) {
          handleSortColumnsCallback(e.target.id);
        },
        "data-core-qa": "mobileTableHeaderText".concat(rowTitle.split(' ')[0])
      }, rowTitle.charAt(0).toUpperCase() + rowTitle.slice(1)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("td", {
        className: "mobile-group-wrapper__mobile-row-cell",
        "data-core-qa": "mobileTableHeaderText".concat(rowTitle.split(' ')[0])
      }, columnListItem[rowTitle]));
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("td", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "mobile-group-wrapper__mobile-break"
    }))));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tfoot", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("td", {
    className: "mobile-group-wrapper__mobile-footer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_2__["default"], {
    pages: pages,
    icons: icons,
    pageData: pageData,
    pagesMenuLabel: pagesMenuLabel,
    useIsMobile: useIsMobile,
    menuDropdownDirection: 'up'
  })))));
}
MobileGroup.propTypes = {
  columnList: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().array),
  pageData: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    totalPages: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    previousPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    nextPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired)
  }),
  icons: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    headingSortAscendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    headingSortDescendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    paginationDropdownIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    paginationLeftIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    paginationRightIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
  }),
  useIsMobile: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  rowsMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  pagesMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  pages: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    key: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
  })),
  currentRowsPerPage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
  mobileTableHeader: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  rowsPerPageList: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().array.isRequired),
  handleSortColumnsCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired)
};

/***/ }),
/* 52 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PaginationRowsPerPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _PaginationMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _pagination_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54);
var _excluded = ["currentRowsPerPage", "rowsMenuLabel", "rowsPerPageList", "menuDropdownDirection"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function PaginationRowsPerPage(_ref) {
  var currentRowsPerPage = _ref.currentRowsPerPage,
    _ref$rowsMenuLabel = _ref.rowsMenuLabel,
    rowsMenuLabel = _ref$rowsMenuLabel === void 0 ? "Rows per page: " : _ref$rowsMenuLabel,
    rowsPerPageList = _ref.rowsPerPageList,
    menuDropdownDirection = _ref.menuDropdownDirection,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "pagination-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pagination-wrapper__pagination-text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PaginationMenu__WEBPACK_IMPORTED_MODULE_1__["default"], {
    items: rowsPerPageList,
    menuLabel: rowsMenuLabel,
    currentValue: currentRowsPerPage,
    menuDropdownDirection: menuDropdownDirection
  })));
}
PaginationRowsPerPage.propTypes = {
  /** Used as part of the default rowsMenuLabel */
  currentRowsPerPage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** Custom text to display next to the dropdown. If this prop is not provided, a default will be used that includes the `currentRowsPerPage` prop */
  rowsMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** List of items to display in the dropdown. This is passed to the `Menu` component as the `items` prop. Please see that component in the `Related Components` section for more details. */
  rowsPerPageList: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(_PaginationMenu__WEBPACK_IMPORTED_MODULE_1__.itemsShape)).isRequired,
  /** This controls whether the menu opens up or down from where you click. */
  menuDropdownDirection: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['up', 'down'])
};

/***/ }),
/* 53 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemsShape": function() { return /* binding */ itemsShape; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _pagination_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







// Internal component that is consumed by the PaginationMenu component
var PaginationMenuItem = function PaginationMenuItem(_ref) {
  var value = _ref.value,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
    currentValue = _ref.currentValue;
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__.useTheme)();
  var itemCSSVariables = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      '--backgroundColor': (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#555'
    };
  }, [theme]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenuItem",
    onClick: handleClick,
    style: itemCSSVariables
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenuItem__iconContainer"
  }, value == currentValue && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "pageMenuItem__icon"
  }, "\u2713")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "pageMenuItem__value",
    "data-core-qa": "paginationMenuItem"
  }, value));
};
PaginationMenuItem.propTypes = {
  value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any.isRequired),
  currentValue: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any.isRequired),
  handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired)
};

// External PaginationMenu component
var PaginationMenu = function PaginationMenu(_ref2) {
  var items = _ref2.items,
    menuLabel = _ref2.menuLabel,
    menuLabelSecondary = _ref2.menuLabelSecondary,
    currentValue = _ref2.currentValue,
    _ref2$menuDropdownDir = _ref2.menuDropdownDirection,
    menuDropdownDirection = _ref2$menuDropdownDir === void 0 ? 'down' : _ref2$menuDropdownDir;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useClickOutside = (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_2__["default"])({
      handleClick: function handleClick() {
        return setIsOpen(false);
      }
    }),
    ref = _useClickOutside.ref;
  var toggleIsOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    items.length && setIsOpen(function (prevState) {
      return !prevState;
    });
  }, [items]);
  var handlePaginationMenuItemClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var externalHandleClick = _ref3.externalHandleClick;
    setIsOpen(false);
    externalHandleClick();
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenu"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenu__menuLabel",
    "data-core-qa": "paginationMenuPrimary"
  }, menuLabel), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenu__select",
    tabIndex: "1",
    onClick: toggleIsOpen,
    ref: ref
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "paginationMenuCurrentValue".concat(currentValue)
  }, currentValue), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "pageMenu__arrow",
    src: (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_3___default())
  }), isOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenuDropdown pageMenuDropdown--".concat(menuDropdownDirection)
  }, items.map(function (_ref4) {
    var key = _ref4.key,
      value = _ref4.value,
      _handleClick = _ref4.handleClick;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PaginationMenuItem, {
      key: key,
      value: value,
      handleClick: function handleClick(e) {
        e.stopPropagation();
        handlePaginationMenuItemClick({
          externalHandleClick: _handleClick
        });
      },
      currentValue: currentValue
    });
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pageMenu__menuLabel pageMenu__menuLabel--secondary",
    "data-core-qa": "paginationMenuSecondary"
  }, menuLabelSecondary));
};
var itemsShape = {
  key: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func)
};
PaginationMenu.propTypes = {
  items: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape(itemsShape)),
  menuDropdownDirection: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(['up', 'down']),
  menuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  menuLabelSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  currentValue: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().any),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
};
PaginationMenu.defaultProps = {
  items: []
};
/* harmony default export */ __webpack_exports__["default"] = (PaginationMenu);

/***/ }),
/* 54 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 55 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PaginationPages; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _PaginationMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _pagination_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54);
var _excluded = ["pageData", "icons", "pages", "pagesMenuLabel", "pagesMenuLabelSecondary", "menuDropdownDirection", "useIsMobile"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function PaginationPages(_ref) {
  var _ref2;
  var pageData = _ref.pageData,
    icons = _ref.icons,
    pages = _ref.pages,
    pagesMenuLabel = _ref.pagesMenuLabel,
    pagesMenuLabelSecondary = _ref.pagesMenuLabelSecondary,
    menuDropdownDirection = _ref.menuDropdownDirection,
    useIsMobile = _ref.useIsMobile,
    rest = _objectWithoutProperties(_ref, _excluded);
  var menuLabel = null;
  var menuLabelSecondary = (_ref2 = pagesMenuLabelSecondary || " of ".concat(pageData.totalPages, " pages"), pagesMenuLabelSecondary = _ref2.pagesMenuLabelSecondary, _ref2);
  if (useIsMobile) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
      className: "pagination-wrapper"
    }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "pagination-wrapper__pagination-text pagination-wrapper__pagination-text--right"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PaginationMenu__WEBPACK_IMPORTED_MODULE_1__["default"], {
      items: pages,
      menuLabel: menuLabel,
      menuLabelSecondary: menuLabelSecondary,
      currentValue: pageData.currentPage,
      menuDropdownDirection: menuDropdownDirection
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "pagination-wrapper__pagination-text pagination-wrapper__pagination-text--muted",
      "data-core-qa": "paginationPagesMobileLineBreak1"
    }, "|"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "pagination-wrapper pagination-wrapper__pagination-text "
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
      "data-core-qa": "paginationPagesMobileButtonBack",
      onClick: pageData.previousPageCallback,
      className: "pagination-wrapper__pagination-button-mobile",
      type: "button"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
      src: icons.paginationLeftIcon,
      alt: "Previous Page",
      className: "pagination-wrapper__pagination-icon"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "pagination-wrapper__pagination-text pagination-wrapper__pagination-text--muted",
      "data-core-qa": "paginationPagesMobileLineBreak2"
    }, "|"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
      "data-core-qa": "paginationPagesMobileButtonForward",
      onClick: pageData.nextPageCallback,
      className: "pagination-wrapper__pagination-button-mobile",
      type: "button"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
      src: icons.paginationRightIcon,
      alt: "Next Page",
      className: "pagination-wrapper__pagination-icon"
    }))));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "pagination-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "pagination-wrapper__pagination-text pagination-wrapper__pagination-text--right"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PaginationMenu__WEBPACK_IMPORTED_MODULE_1__["default"], {
    items: pages,
    menuLabel: menuLabel,
    menuLabelSecondary: menuLabelSecondary,
    currentValue: pageData.currentPage,
    showIcons: false,
    menuDropdownDirection: 'up'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "paginationPagesButtonBack",
    onClick: pageData.previousPageCallback,
    className: "pagination-wrapper__pagination-button",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: icons.paginationLeftIcon,
    alt: "Previous Page",
    className: "pagination-wrapper__pagination-icon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "paginationPagesButtonForward",
    onClick: pageData.nextPageCallback,
    className: "pagination-wrapper__pagination-button",
    type: "button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: icons.paginationRightIcon,
    alt: "Next Page",
    className: "pagination-wrapper__pagination-icon"
  })));
}
PaginationPages.propTypes = {
  /** An object containing the following attributes:
   * <br /> - currentPage: current page being viewed
   * <br /> - totalPages: total number of pages
   * <br /> - previousPageCallback: called when the previous page button is clicked
   * <br /> - nextPageCallback: called when the next page button is clicked
   */
  pageData: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
    totalPages: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
    previousPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
    nextPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired)
  }),
  /** icons to be used */
  icons: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    paginationLeftIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    paginationRightIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    paginationDropdownIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
  }),
  /** Passed to the `Menu` component as the `items` prop. Please see that component in the `Related Components` section for more details. */
  pages: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    key: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
  })),
  /** Passed to the `Menu` component as the `menuLabel` prop. Please see that component in the `Related Components` section for more details. */
  pagesMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Passed to the `Menu` component as the `menuLabelSecondary` prop. Please see that component in the `Related Components` section for more details. */
  pagesMenuLabelSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Boolean that determines if we show the mobile version or not */
  useIsMobile: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** Direction the menu opens when clicked */
  menuDropdownDirection: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['up', 'down'])
};

/***/ }),
/* 56 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 57 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modal_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58);
var _excluded = ["children", "closeModal", "overlayClassName", "modalClassName", "overlayStyles", "modalStyles"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Modal = function Modal(_ref) {
  var children = _ref.children,
    closeModal = _ref.closeModal,
    _ref$overlayClassName = _ref.overlayClassName,
    overlayClassName = _ref$overlayClassName === void 0 ? '' : _ref$overlayClassName,
    _ref$modalClassName = _ref.modalClassName,
    modalClassName = _ref$modalClassName === void 0 ? '' : _ref$modalClassName,
    _ref$overlayStyles = _ref.overlayStyles,
    overlayStyles = _ref$overlayStyles === void 0 ? {} : _ref$overlayStyles,
    _ref$modalStyles = _ref.modalStyles,
    modalStyles = _ref$modalStyles === void 0 ? {} : _ref$modalStyles,
    rest = _objectWithoutProperties(_ref, _excluded);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    document.body.classList.add("no-scroll-body");
    return function () {
      document.body.classList.remove("no-scroll-body");
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", rest, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    style: overlayStyles,
    className: "modal-overlay ".concat(overlayClassName),
    onClick: closeModal
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    style: modalStyles,
    className: "modal ".concat(modalClassName)
  }, children));
};
Modal.propTypes = {
  /** The content of the modal. */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  /** What happens when the modal is closed through the x button or clicking the background. */
  closeModal: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  /** Classname that will be applied to the overlay. */
  overlayClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Classname that will be applied to the modal itself. */
  modalClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Inline style of the overlay. */
  overlayStyles: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
  /** Inline style for the modal to adopt. */
  modalStyles: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
};
/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),
/* 58 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 59 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _modalWithTextAndButton_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60);
var _excluded = ["modalText", "buttonText", "handleButtonCallback", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var ModalWithTextAndButton = function ModalWithTextAndButton(_ref) {
  var modalText = _ref.modalText,
    buttonText = _ref.buttonText,
    handleButtonCallback = _ref.handleButtonCallback,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Modal, _extends({
    modalClassName: "modalWithTextAndButton ".concat(className)
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "modalText",
    "data-core-qa": "modalText"
  }, modalText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    onClick: handleButtonCallback,
    "data-core-qa": "modalButton"
  }, buttonText));
};
ModalWithTextAndButton.propTypes = {
  /** Text that shows up in the modal above the button */
  modalText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Text in the button */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Called when the button is clicked */
  handleButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** Optional className that will be passed to the modal as the `modalClassName` prop. Please see `Modal` in the `Related Components` section for more details. */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (ModalWithTextAndButton);

/***/ }),
/* 60 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 61 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ OverlayMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _overlayMenu_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2__);




var MenuItem = function MenuItem(_ref) {
  var value = _ref.value,
    handleClick = _ref.handleClick,
    icon = _ref.icon,
    showIcons = _ref.showIcons;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "overlayMenu__menuItem",
    onClick: handleClick
  }, showIcons && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "overlayMenu__menuItemIcon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: icon
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "overlayMenu__text",
    "data-core-qa": "overlayMenuItem".concat(value)
  }, value));
};
MenuItem.propTypes = {
  value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  icon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  showIcons: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};
MenuItem.defaultProps = {
  handleClick: function handleClick() {}
};
function OverlayMenu(_ref2) {
  var isOpen = _ref2.isOpen,
    handleCloseOverlayCallback = _ref2.handleCloseOverlayCallback,
    headerItems = _ref2.headerItems,
    items = _ref2.items,
    _ref2$showIcons = _ref2.showIcons,
    showIcons = _ref2$showIcons === void 0 ? false : _ref2$showIcons;
  var headerItemsList = headerItems ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "overlayMenu__headerItems"
  }, headerItems.map(function (headerItem) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
      className: "overlayMenu__headerItem",
      key: headerItem
    }, headerItem);
  })) : null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("aside", {
    className: isOpen ? "overlayMenu overlayMenu--expanded" : "overlayMenu overlayMenu--collapsed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    className: "overlayMenu__btn",
    onClick: handleCloseOverlayCallback,
    "data-core-qa": "overlayMenuButtonClose"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "overlayMenu__btnImg",
    src: (_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2___default())
  })), headerItems && headerItemsList, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
    className: "overlayMenu__menuItems"
  }, items.map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value,
      handleClick = _ref3.handleClick,
      icon = _ref3.icon;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MenuItem, {
      key: key,
      value: value,
      handleClick: handleClick,
      icon: icon,
      showIcons: showIcons
    });
  })));
}
OverlayMenu.propTypes = {
  /** Whether to menu is open. */
  isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool.isRequired),
  /** What happens when the menu is closed. */
  handleCloseOverlayCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** Array of User info to be shown. */
  headerItems: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().array),
  /** Whether icons should be shown. */
  showIcons: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** Array of items to populate list. */
  items: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    /** The key of the item. */
    key: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    /** The value of the item. */
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    /** What happens when the item is clicked. */
    handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    /** The icon of the menu item. */
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
  }))
};

/***/ }),
/* 62 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 63 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3e%3c!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath d='M393.4 41.37C405.9 28.88 426.1 28.88 438.6 41.37C451.1 53.87 451.1 74.13 438.6 86.63L269.3 255.1L438.6 425.4C451.1 437.9 451.1 458.1 438.6 470.6C426.1 483.1 405.9 483.1 393.4 470.6L223.1 301.3L54.63 470.6C42.13 483.1 21.87 483.1 9.372 470.6C-3.124 458.1-3.124 437.9 9.372 425.4L178.7 255.1L9.372 86.63C-3.124 74.13-3.124 53.87 9.372 41.37C21.87 28.88 42.13 28.88 54.63 41.37L223.1 210.7L393.4 41.37z'/%3e%3c/svg%3e"

/***/ }),
/* 64 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PaginationItems; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pagination_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54);
var _excluded = ["items"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function PaginationItems(_ref) {
  var items = _ref.items,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "pagination-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "pagination-wrapper__pagination-text",
    "data-core-qa": "paginationItemsText"
  }, items.currentStart, " - ", items.currentEnd, " of ", items.totalItems, ' ', items.itemsName ? items.itemsName : 'items'));
}
PaginationItems.propTypes = {
  /** An object that has the following attributes:
   * <br /> - currentStart: starting number of items on display
   * <br /> - currentEnd: ending number of items on display
   * <br /> - totalItems: total item count
   * <br /> - itemsName: name of the items being displayed, for example `Nodes`. If no value is provided, the default term `items` will be used
   */
  items: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
    currentStart: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number.isRequired),
    currentEnd: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number.isRequired),
    totalItems: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number.isRequired),
    itemsName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
  })
};

/***/ }),
/* 65 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Table; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _TableHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var _TableFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69);
/* harmony import */ var _MobileGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51);
/* harmony import */ var _table_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67);
var _excluded = ["currentRowsPerPage", "handleSortColumnsCallback", "sortMethod", "icons", "items", "pages", "pageData", "pagesMenuLabel", "pagesMenuLabelSecondary", "rowsMenuLabel", "rowsPerPageList", "tableData", "useIsMobile", "mobileTableHeader"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







function Table(_ref) {
  var currentRowsPerPage = _ref.currentRowsPerPage,
    handleSortColumnsCallback = _ref.handleSortColumnsCallback,
    sortMethod = _ref.sortMethod,
    icons = _ref.icons,
    items = _ref.items,
    pages = _ref.pages,
    pageData = _ref.pageData,
    pagesMenuLabel = _ref.pagesMenuLabel,
    pagesMenuLabelSecondary = _ref.pagesMenuLabelSecondary,
    rowsMenuLabel = _ref.rowsMenuLabel,
    rowsPerPageList = _ref.rowsPerPageList,
    tableData = _ref.tableData,
    useIsMobile = _ref.useIsMobile,
    mobileTableHeader = _ref.mobileTableHeader,
    rest = _objectWithoutProperties(_ref, _excluded);
  var headerTitles = Object.keys(tableData[0] || {});
  if (useIsMobile) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_MobileGroup__WEBPACK_IMPORTED_MODULE_4__["default"], _extends({
      rowsMenuLabel: rowsMenuLabel,
      currentRowsPerPage: currentRowsPerPage,
      rowsPerPageList: rowsPerPageList,
      columnList: tableData,
      pages: pages,
      icons: icons,
      pageData: pageData,
      pagesMenuLabel: pagesMenuLabel,
      pagesMenuLabelSecondary: pagesMenuLabelSecondary,
      mobileTableHeader: mobileTableHeader,
      useIsMobile: useIsMobile,
      handleSortColumnsCallback: handleSortColumnsCallback,
      sortMethod: sortMethod
    }, rest));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("table", _extends({
    className: "table-wrapper sticky-table"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("thead", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", {
    className: "table-wrapper__table-header"
  }, headerTitles.map(function (title) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TableHeader__WEBPACK_IMPORTED_MODULE_1__["default"], {
      key: title,
      title: title,
      sortMethod: sortMethod,
      icons: icons,
      handleSortColumnsCallback: handleSortColumnsCallback
    });
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tbody", null, tableData.map(function (columnListItem, i) {
    var rowKey = columnListItem.id || "".concat(i, "_").concat(Math.random());
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", {
      className: "table-wrapper__table-row",
      key: rowKey
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TableRow__WEBPACK_IMPORTED_MODULE_2__["default"], {
      columnListItem: columnListItem,
      headerTitles: headerTitles
    }));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tfoot", {
    className: "table-wrapper__table-footer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("td", {
    colSpan: "20"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TableFooter__WEBPACK_IMPORTED_MODULE_3__["default"], {
    rowsPerPageList: rowsPerPageList,
    rowsMenuLabel: rowsMenuLabel,
    currentRowsPerPage: currentRowsPerPage,
    items: items,
    pages: pages,
    icons: icons,
    pageData: pageData,
    pagesMenuLabel: pagesMenuLabel,
    pagesMenuLabelSecondary: pagesMenuLabelSecondary
  })))));
}
Table.propTypes = {
  /** Array of objects<br/>
   * object keys will be converted to the header row column names in `TableHeader`<br/>
   * object values are populated in the `TableRow` in the appropriate key column
   */
  tableData: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array),
  /** Object passed into `TableFooter` and `MobileGroup`  for the `PaginationPages` component. Please see `PaginationPages` in the Related Components section for more details. */
  pageData: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    totalPages: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    previousPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
    nextPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
  }),
  /** Sorting and dropdown menus icons passed to the `TableHeader`, `TableFooter`, and `MobileGroup` */
  icons: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    headingSortAscendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    headingSortDescendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    paginationDropdownIcon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    paginationLeftIcon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    paginationRightIcon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
  }),
  /** Boolean used to determine the table layout */
  useIsMobile: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
  /** Sort callback function passed into `TableHeader` and `MobileGroup` that returns the id (object key used as the header) of the column clicked.  */
  handleSortColumnsCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** Object containing the column header and ascending boolean passed to the `TableHeader` */
  sortMethod: _TableHeader__WEBPACK_IMPORTED_MODULE_1__["default"].propTypes.sortMethod,
  /** Text displayed in the `PaginationRowsPerPage` passed through `TableFooter` and `MobileGroup`. Please see `PaginationRowsPerPage` in Related Components for more details. */
  rowsMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Text displayed in the `PaginationPages` before the drop down arrow passed through `TableFooter` and `MobileGroup`. Please see `PaginationPages` in Related Components for more details. */
  pagesMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Text displayed in the `PaginationPages` after the drop down arrow passed through `TableFooter` and `MobileGroup`. Please see `PaginationPages` in Related Components for more details. */
  pagesMenuLabelSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Array of objects passed to `PaginationPages` through `TableFooter` and `MobileGroup`. Please see `PaginationPages` in Related Components for more details. */
  pages: prop_types__WEBPACK_IMPORTED_MODULE_6___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    key: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
  })),
  /** Number passed into the `PaginationRowsPerPage` through the `TableFooter` and `MobileGroup`. Please see `PaginationPages` in Related Components for more details. */
  currentRowsPerPage: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
  /** Object passed into the `PaginationItems` through the `TableFooter`. Please see `PaginationItems` in Related Components for more details. */
  items: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    currentStart: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    currentEnd: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    totalItems: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    itemsName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
  }),
  /** String passed specifically for the mobile view for table. Please see `MobileGroup` in Related Components for more details. */
  mobileTableHeader: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** List of items to display in the dropdown for `PaginationRowsPerPage` passed through `TableFooter` and `MobileGroup`. Please see `PaginationRowsPerPage` in Related Components for more details. */
  rowsPerPageList: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array.isRequired)
};

/***/ }),
/* 66 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TableHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _table_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67);



function TableHeader(_ref) {
  var title = _ref.title,
    sortMethod = _ref.sortMethod,
    handleSortColumnsCallback = _ref.handleSortColumnsCallback,
    icons = _ref.icons;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
    className: "table-wrapper__table-cell",
    id: title,
    onClick: function onClick(e) {
      handleSortColumnsCallback(e.target.id);
    },
    "data-core-qa": "tableHeaderTitleText".concat(title.split(' ')[0])
  }, title.charAt(0).toUpperCase() + title.slice(1), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: sortMethod.column === title && sortMethod.ascending ? icons.headingSortAscendingIcon : icons.headingSortDescendingIcon,
    className: "table-wrapper__arrow",
    id: title
  }));
}
TableHeader.propTypes = {
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  sortMethod: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
    column: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    ascending: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
  }).isRequired,
  handleSortColumnsCallback: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  headingSortAscendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  headingSortDescendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  icons: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
    headingSortAscendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
    headingSortDescendingIcon: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node)
  })
};

/***/ }),
/* 67 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 68 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TableRow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _table_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67);



function TableRow(_ref) {
  var columnListItem = _ref.columnListItem,
    headerTitles = _ref.headerTitles;
  return headerTitles.map(function (headerTitle) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("td", {
      className: "table-wrapper__table-cell",
      key: headerTitle,
      "data-core-qa": "tableRowText"
    }, columnListItem[headerTitle]);
  });
}
TableRow.propTypes = {
  columnListItem: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
  headerTitles: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array)
};

/***/ }),
/* 69 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TableFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52);
/* harmony import */ var _Pagination_PaginationItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64);
/* harmony import */ var _Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55);
/* harmony import */ var _table_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67);
var _excluded = ["currentRowsPerPage", "icons", "items", "pages", "pageData", "pagesMenuLabel", "pagesMenuLabelSecondary", "rowsMenuLabel", "rowsPerPageList"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function TableFooter(_ref) {
  var currentRowsPerPage = _ref.currentRowsPerPage,
    icons = _ref.icons,
    items = _ref.items,
    pages = _ref.pages,
    pageData = _ref.pageData,
    pagesMenuLabel = _ref.pagesMenuLabel,
    pagesMenuLabelSecondary = _ref.pagesMenuLabelSecondary,
    rowsMenuLabel = _ref.rowsMenuLabel,
    rowsPerPageList = _ref.rowsPerPageList,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "table-wrapper__table-footer-row"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Pagination_PaginationRowsPerPage__WEBPACK_IMPORTED_MODULE_1__["default"], {
    rowsMenuLabel: rowsMenuLabel,
    currentRowsPerPage: currentRowsPerPage,
    rowsPerPageList: rowsPerPageList,
    className: "table-wrapper__table-footer-row--cell1",
    menuDropdownDirection: 'up'
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Pagination_PaginationItems__WEBPACK_IMPORTED_MODULE_2__["default"], {
    items: items,
    className: "table-wrapper__table-footer-row--cell2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Pagination_PaginationPages__WEBPACK_IMPORTED_MODULE_3__["default"], {
    pages: pages,
    icons: icons,
    pageData: pageData,
    pagesMenuLabel: pagesMenuLabel,
    pagesMenuLabelSecondary: pagesMenuLabelSecondary,
    className: "table-wrapper__table-footer-row--cell3",
    menuDropdownDirection: 'up'
  }));
}
TableFooter.propTypes = {
  rowsPerPageList: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array.isRequired),
  rowsMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  currentRowsPerPage: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
  items: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    currentStart: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    currentEnd: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    totalItems: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    itemsName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  }),
  pages: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    key: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    handleClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
  })),
  pageData: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    totalPages: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    previousPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
    nextPageCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired)
  }),
  icons: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    paginationLeftIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    paginationRightIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    paginationDropdownIcon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
  }),
  pagesMenuLabel: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  pagesMenuLabelSecondary: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};

/***/ }),
/* 70 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _tabs_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71);
var _excluded = ["handleTabChangedCallback", "initialActiveTab", "tabLabels"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function Tabs(_ref) {
  var _ref$handleTabChanged = _ref.handleTabChangedCallback,
    handleTabChangedCallback = _ref$handleTabChanged === void 0 ? function () {} : _ref$handleTabChanged,
    _ref$initialActiveTab = _ref.initialActiveTab,
    initialActiveTab = _ref$initialActiveTab === void 0 ? 0 : _ref$initialActiveTab,
    _ref$tabLabels = _ref.tabLabels,
    tabLabels = _ref$tabLabels === void 0 ? [] : _ref$tabLabels,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_1__.useTheme)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialActiveTab),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    handleTabChangedCallback(activeTab);
  }, [activeTab]);
  var updateActiveTab = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (tabNum) {
    if (tabNum === activeTab) return;
    setActiveTab(tabNum);
  }, [activeTab]);
  var getTabStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (labelIndex) {
    return labelIndex === activeTab ? {
      background: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#555',
      color: '#fff'
    } : {
      background: '#fff',
      color: '#161616'
    };
  }, [activeTab]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "tabs-container"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tab-labels flexRow"
  }, tabLabels.map(function (tabLabel, tabIndex) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tab-labels__label",
      style: getTabStyles(tabIndex),
      key: tabLabel,
      onClick: function onClick() {
        return updateActiveTab(tabIndex);
      },
      "data-core-qa": "tabsLabel".concat(tabIndex)
    }, tabLabel);
  })));
}
Tabs.propTypes = {
  /** What happens when the tabs are clicked. */
  handleTabChangedCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** Which tab the user should start on. */
  initialActiveTab: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** An array of all the tab names that will have dynamically create the tabs. */
  tabLabels: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().string))
};

/***/ }),
/* 71 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 72 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EmailSent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _resetPassword_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73);
var _excluded = ["headingText", "subText", "userEmail", "image"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function EmailSent(_ref) {
  var headingText = _ref.headingText,
    subText = _ref.subText,
    userEmail = _ref.userEmail,
    image = _ref.image,
    rest = _objectWithoutProperties(_ref, _excluded);
  var heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return headingText || 'Email sent';
  }, [headingText]);
  var secondaryText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return subText || "We sent an email to ".concat(userEmail, " with a link to reset your password.");
  }, [subText]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "reset-password__email-sent"
  }, rest), image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__image-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: image,
    className: "reset-password__image"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "reset-password__heading reset-password__formBreak reset-password__heading--mobile-fix",
    "data-core-qa": "emailSentTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "reset-password__subText",
    "data-core-qa": "emailSentTitleSubText"
  }, secondaryText));
}
EmailSent.propTypes = {
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Optional image to display above the text */
  image: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  subText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** If no subText is provided, this is required for the default subText to be populated properly as it reads like this: `we sent an email to ${userEmail>} with a link...` */
  userEmail: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};

/***/ }),
/* 73 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 74 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ForgotPassword; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _resetPassword_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73);
var _excluded = ["headingText", "handleSubmitCallback", "handleCancelCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var initialFormState = {
  email: {
    value: '',
    error: false,
    message: ''
  }
};
function ForgotPassword(_ref) {
  var _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? 'Forgot password?' : _ref$headingText,
    handleSubmitCallback = _ref.handleSubmitCallback,
    handleCancelCallback = _ref.handleCancelCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var handleValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      id = _ref2$target.id,
      value = _ref2$target.value;
    var hasValidEmail = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getHasValidEmail)({
      email: value
    });
    return setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
        value: value,
        error: !hasValidEmail,
        message: hasValidEmail ? '' : _utils__WEBPACK_IMPORTED_MODULE_1__.errorMessages.email
      }));
    });
  }, [formState, setFormState]);
  var disabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.error === true || state.value === '';
    });
    return !!hasErrors.length;
  }, [formState]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      value = _ref3$target.value,
      id = _ref3$target.id;
    setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
        value: value
      })));
    });
  }, [setFormState]);
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    return handleSubmitCallback({
      email: formState.email.value
    });
  }, [formState]);
  var heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return headingText || 'Forgot password?';
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", _extends({
    className: "reset-password",
    onSubmit: handleFormSubmit
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "reset-password__heading",
    "data-core-qa": "forgotPasswordTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "forgotPasswordInputEmail",
    labelText: "Email Address",
    placeholder: "email@address.com",
    id: "email",
    onChange: handleInputChange,
    invalid: formState.email.error,
    invalidText: formState.email.message,
    onBlur: handleValidationOnBlur,
    value: formState.email.value,
    type: "email",
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    onClick: handleCancelCallback,
    kind: "outlined",
    type: "button",
    "data-core-qa": "forgotPasswordButtonCancel"
  }, "Cancel")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__button-secondary"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    type: "submit",
    kind: "solid",
    disabled: disabled,
    "data-core-qa": "forgotPasswordButtonSubmit"
  }, "Request a reset link"))));
}
ForgotPassword.propTypes = {
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Called when Request a reset link is clicked */
  handleSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Called when Cancel is clicked */
  handleCancelCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired)
};

/***/ }),
/* 75 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "errorMessages": function() { return /* binding */ errorMessages; },
/* harmony export */   "getHasLength": function() { return /* binding */ getHasLength; },
/* harmony export */   "getHasLowercase": function() { return /* binding */ getHasLowercase; },
/* harmony export */   "getHasNoSpaces": function() { return /* binding */ getHasNoSpaces; },
/* harmony export */   "getHasNumber": function() { return /* binding */ getHasNumber; },
/* harmony export */   "getHasSymbol": function() { return /* binding */ getHasSymbol; },
/* harmony export */   "getHasUppercase": function() { return /* binding */ getHasUppercase; },
/* harmony export */   "getHasValidEmail": function() { return /* binding */ getHasValidEmail; },
/* harmony export */   "getHasValidFullName": function() { return /* binding */ getHasValidFullName; },
/* harmony export */   "getHasValidName": function() { return /* binding */ getHasValidName; },
/* harmony export */   "getIsPasswordValid": function() { return /* binding */ getIsPasswordValid; },
/* harmony export */   "isBrowser": function() { return /* binding */ isBrowser; }
/* harmony export */ });
function isBrowser() {
  return typeof window !== 'undefined';
}
var wholeName = /[a-zA-Z.'-]{2,}(?: [a-zA-Z.'-]{2,})+$/;
var singularName = /([a-zA-Z.'-]{2,})+$/;
var lower = /[a-z]/;
var upper = /[A-Z]/;
var number = /[0-9]/;
var symbol = /[-!@$%^&*()_+|~=#`{}[\]:";'<>?,./]/;
var noSpace = /^\S*$/;
var validEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;
var errorMessages = {
  name: 'Improperly formatted name',
  email: 'Enter a valid email (john@example.com)',
  password: 'Password does not meet the character requirement',
  confirmPassword: 'Passwords do not match',
  checkbox: 'You must be over 18 to sign up.'
};
function getHasValidFullName(_ref) {
  var fullName = _ref.fullName;
  return wholeName.test(fullName);
}
function getHasValidName(_ref2) {
  var name = _ref2.name;
  return singularName.test(name);
}
function getHasLowercase(_ref3) {
  var password = _ref3.password;
  return lower.test(password);
}
function getHasUppercase(_ref4) {
  var password = _ref4.password;
  return upper.test(password);
}
function getHasNumber(_ref5) {
  var password = _ref5.password;
  return number.test(password);
}
function getHasSymbol(_ref6) {
  var password = _ref6.password;
  return symbol.test(password);
}
function getHasNoSpaces(_ref7) {
  var password = _ref7.password;
  return password.length === 0 ? false : noSpace.test(password);
}
function getHasLength(_ref8) {
  var _ref8$password = _ref8.password,
    password = _ref8$password === void 0 ? '' : _ref8$password,
    length = _ref8.length;
  return password.length >= length;
}
function getIsPasswordValid(_ref9) {
  var password = _ref9.password;
  return getHasLength({
    password: password,
    length: 8
  }) && getHasLowercase({
    password: password
  }) && getHasUppercase({
    password: password
  }) && getHasNumber({
    password: password
  }) && getHasSymbol({
    password: password
  }) && getHasNoSpaces({
    password: password
  });
}
function getHasValidEmail(_ref10) {
  var email = _ref10.email;
  return validEmail.test(email);
}

/***/ }),
/* 76 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PasswordChanged; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _resetPassword_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73);
/* harmony import */ var _assets_images_PasswordChanged_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77);
/* harmony import */ var _assets_images_PasswordChanged_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_images_PasswordChanged_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





function PasswordChanged(_ref) {
  var handleSuccessfulPasswordChangeCallback = _ref.handleSuccessfulPasswordChangeCallback,
    _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? 'Password changed' : _ref$headingText,
    _ref$subText = _ref.subText,
    subText = _ref$subText === void 0 ? 'Your password has been successfully changed.' : _ref$subText,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Log in' : _ref$buttonText,
    image = _ref.image;
  var passwordChangedImage = image || (_assets_images_PasswordChanged_svg__WEBPACK_IMPORTED_MODULE_2___default());
  var heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return headingText || 'Password changed';
  }, [headingText]);
  var secondaryText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return subText || 'Your password has been successfully changed.';
  }, [subText]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password password-confirmed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: passwordChangedImage,
    className: "password-confirmed__image"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "reset-password__heading",
    "data-core-qa": "resetPasswordTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "reset-password__subText--centered",
    "data-core-qa": "resetPasswordTitleSubText"
  }, secondaryText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__button-row reset-password__button-row--mobile-fix"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index_js__WEBPACK_IMPORTED_MODULE_3__.Button, {
    onClick: handleSuccessfulPasswordChangeCallback,
    "data-core-qa": "resetPasswordButtonConfirm"
  }, buttonText)));
}
PasswordChanged.propTypes = {
  /** Called on click of the button */
  handleSuccessfulPasswordChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  subText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  image: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
};

/***/ }),
/* 77 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1210.79 1316.64'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bopacity:.1;%7d.cls-2%7bopacity:.1;%7d.cls-3,.cls-4%7bfill:%23fff;%7d.cls-5,.cls-6%7bfill:%23326260;%7d.cls-7%7bfill:%23323744;%7d.cls-8%7bfill:%23a8a8a8;%7d.cls-9%7bfill:%2389a5af;%7d.cls-10%7bfill:%235ba8a1;%7d.cls-11%7bfill:%23264946;%7d.cls-4%7bopacity:.2;%7d.cls-6%7bopacity:.3;%7d%3c/style%3e%3c/defs%3e%3cg id='Layer_1-2'%3e%3cg%3e%3cpath class='cls-6' d='M597.57,1315.4c-6.06-.96-150.14-24.52-295.66-112.12-86.94-52.33-156.46-116.76-206.64-191.48C32.05,917.66,0,807.82,0,685.32V181.06c0-14.62,4.08-36.76,23.51-59.16,11.27-12.99,26.24-24.6,45.77-35.49,32.01-17.85,76.38-33.54,131.88-46.64C309.7,14.16,453.26,.04,605.38,0c152.16,.04,295.71,14.16,404.24,39.77,55.5,13.1,99.88,28.79,131.88,46.64,19.53,10.89,34.5,22.5,45.77,35.49,19.43,22.4,23.51,44.54,23.51,59.16v504.26c0,122.5-32.05,232.34-95.27,326.48-50.18,74.72-119.7,139.15-206.64,191.48-145.52,87.6-289.6,111.16-295.66,112.12l-7.82,1.24-7.82-1.24Z'/%3e%3cpath class='cls-10' d='M1160.78,181.06v504.26c0,492.74-555.39,580.7-555.39,580.7,0,0-369.6-58.53-505.78-347.6-10.45-22.18-19.52-45.71-26.95-70.68-14.44-48.53-22.66-102.48-22.66-162.42V181.06c0-72.33,248.61-130.99,555.39-131.06,38.33,0,75.75,.93,111.89,2.68,51.32,2.49,100.07,6.64,145.16,12.21,177.35,21.9,298.34,65.71,298.34,116.17Z'/%3e%3cpath class='cls-4' d='M717.96,85.04c0,383.45-279.12,701.71-645.29,762.7-14.44-48.53-22.66-102.48-22.66-162.42V181.06c0-72.33,248.61-130.99,555.39-131.06,38.33,0,75.75,.93,111.89,2.68,.45,10.74,.67,21.52,.67,32.36Z'/%3e%3crect class='cls-1' x='165.52' y='752.76' width='879.75' height='220.73' rx='110.36' ry='110.36'/%3e%3crect class='cls-3' x='165.52' y='735.09' width='879.75' height='220.73' rx='110.36' ry='110.36'/%3e%3cg%3e%3cpath class='cls-8' d='M866.56,444.5v256.87c0,40.45-32.79,73.24-73.24,73.24H417.5c-40.45,0-73.27-32.79-73.27-73.24V444.5c0-4.29,.38-8.53,1.1-12.62,5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cpath class='cls-11' d='M866.56,444.5v256.87c0,40.45-32.79,73.24-73.24,73.24H417.5c-40.45,0-73.27-32.79-73.27-73.24V444.5c0-4.29,.38-8.53,1.1-12.62,5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cpath class='cls-9' d='M797.18,284.2c-13.17-93.44-93.67-165.52-190.68-165.52s-177.48,72.08-190.65,165.52c-1.28,8.85-1.92,17.88-1.92,27.07v174.23c0,28.26,22.98,51.28,51.25,51.28h282.64c28.29,0,51.28-23.01,51.28-51.28v-174.23c0-9.2-.64-18.22-1.92-27.07Zm-54.06,196.6H469.88v-169.53c0-9.26,.93-18.31,2.7-27.07,12.59-62.45,67.85-109.57,133.92-109.57s121.33,47.13,133.92,109.57c1.77,8.76,2.7,17.82,2.7,27.07v169.53Z'/%3e%3cg class='cls-2'%3e%3cpath d='M469.88,354.84v16.42h-55.95v-18.03c19.54,.88,38.18,1.41,55.95,1.61Z'/%3e%3c/g%3e%3cg class='cls-2'%3e%3cpath d='M799.09,311.28v59.98h-55.98v-51.74c24.32-9.16,42.07-19.02,54.95-28.15,.68,6.54,1.03,13.17,1.03,19.91Z'/%3e%3c/g%3e%3cpath class='cls-5' d='M866.56,444.5v205.65c-5.98,34.44-35.98,60.62-72.14,60.62H418.6c-40.45,0-73.27-32.79-73.27-73.24v-205.65c5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cg%3e%3cpath class='cls-7' d='M653.4,472.03c0,9.25-2.61,17.88-7.14,25.21-1.55,2.51-3.33,4.87-5.3,7.04-.52,.58-1.06,1.15-1.62,1.7-8.69,8.68-20.69,14.06-33.95,14.06-17.27,0-32.4-9.12-40.86-22.8-4.53-7.33-7.15-15.96-7.15-25.21s2.74-18.29,7.47-25.73c1.89-2.98,4.1-5.73,6.59-8.22,8.69-8.69,20.7-14.06,33.95-14.06s25.26,5.37,33.95,14.06c2.48,2.48,4.69,5.24,6.59,8.22,1.42,2.23,2.66,4.58,3.7,7.04,2.42,5.75,3.77,12.06,3.77,18.69Z'/%3e%3cpath class='cls-7' d='M605.4,658.01h0c-19.33,0-34.66-16.31-33.47-35.6l7.84-126.55c.84-13.54,12.06-24.09,25.63-24.09h0c13.56,0,24.79,10.55,25.63,24.09l7.84,126.55c1.2,19.3-14.13,35.6-33.47,35.6Z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3ccircle class='cls-9' cx='378.48' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='491.94' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='605.39' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='718.85' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='832.31' cy='845.45' r='28.44'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 78 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _referAFriend_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83);
/* harmony import */ var _assets_images_ReferAFriend_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84);
/* harmony import */ var _assets_images_ReferAFriend_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_assets_images_ReferAFriend_svg__WEBPACK_IMPORTED_MODULE_4__);
var _excluded = ["referralLink", "brandName", "imageSrc"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var ReferAFriend = function ReferAFriend(_ref) {
  var referralLink = _ref.referralLink,
    brandName = _ref.brandName,
    imageSrc = _ref.imageSrc,
    rest = _objectWithoutProperties(_ref, _excluded);
  var referAFriendImageSrc = imageSrc || (_assets_images_ReferAFriend_svg__WEBPACK_IMPORTED_MODULE_4___default());
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "refer-friend"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "refer-friend-right"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "refer-friend-right__title",
    "data-core-qa": "referFriendTitleText"
  }, "Refer a Friend"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "refer-friend-right__text",
    "data-core-qa": "referFriendTitleSubText"
  }, "Invite your friends to join the ", brandName, " community! Copy the link below to share it out."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "refer-friend-link"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "refer-friend-link__box",
    "data-core-qa": "referFriendLink",
    value: referralLink,
    disabled: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__.CopyToClipboard, {
    text: referralLink,
    onCopy: function onCopy() {
      return setCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    className: "refer-friend-link__btn",
    type: "button",
    "data-core-qa": "referFriendCopyButton"
  }, copied ? 'Copied!' : 'Copy')))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "refer-friend-left"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "refer-friend-left__img",
    src: referAFriendImageSrc,
    alt: "Refer A Friend"
  })));
};
ReferAFriend.propTypes = {
  /** The link provided to the user to send to a friend. */
  referralLink: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** The name of the brand. */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** What image should be shown. */
  imageSrc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
};
/* harmony default export */ __webpack_exports__["default"] = (ReferAFriend);

/***/ }),
/* 79 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(80),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),
/* 80 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(2));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(81));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),
/* 81 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(82);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 82 */
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 83 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 84 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 459.55 429.03'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:%23e0e0e0;%7d.cls-2%7bfill:%23fff;%7d.cls-3%7bfill:none;stroke:%23e0e0e0;stroke-miterlimit:10;%7d.cls-4%7bfill:%23263238;%7d.cls-5%7bfill:%23326260;%7d.cls-6%7bfill:%23b56760;%7d.cls-7%7bfill:%238a4a43;%7d.cls-8%7bfill:%23c17560;%7d.cls-9%7bfill:%237c4236;%7d.cls-10%7bfill:%23fafafa;%7d.cls-11%7bopacity:0.3;%7d.cls-12%7bfill:%23ffbf9d;%7d.cls-13%7bfill:%23ff9a6c;%7d%3c/style%3e%3c/defs%3e%3cg id='Layer_2' data-name='Layer 2'%3e%3cg id='Character_4' data-name='Character 4'%3e%3cpath class='cls-1' d='M397.35,391.17h3.41l7.45-10.38V374s5.28-.33,4.65,8.59.06,6.65.06,6.65,11.2,0,12.13,1c.67.71,1,11.83,1.1,17.87a6.54,6.54,0,0,1-4.63,6.58,5,5,0,0,1-1.21.16c-2.79,0-17.07-2.27-17.07-2.27h-5.89Z'/%3e%3cpolygon class='cls-1' points='387.58 389.3 389.68 412.64 395.52 412.64 395.52 389.77 387.58 389.3'/%3e%3cpath class='cls-1' d='M222.84,40.19l14.7,21a4,4,0,0,0,6.57-.11l14.23-21.86Z'/%3e%3crect class='cls-1' x='207.29' y='4.99' width='64.39' height='46.83' rx='11.56'/%3e%3cpath class='cls-2' d='M252.09,24.1c-2.06-3.77-5.48-4.36-7.78-3.5a8,8,0,0,0-3.8,3.5,8,8,0,0,0-3.8-3.5c-2.3-.86-5.72-.27-7.79,3.5-4.3,7.87,11.59,18.12,11.59,18.12S256.4,32,252.09,24.1Z'/%3e%3cpath class='cls-1' d='M61.43,367.86H95.34A13.65,13.65,0,0,1,109,381.51v17.21a13.65,13.65,0,0,1-13.65,13.65H86.48l-6.24,8.93a3.77,3.77,0,0,1-6.25-.11l-5.74-8.82H61.43a13.65,13.65,0,0,1-13.65-13.65V381.51A13.65,13.65,0,0,1,61.43,367.86Z'/%3e%3cpolygon class='cls-2' points='77.18 381.53 77.18 399.09 64.61 390.31 77.18 381.53'/%3e%3cpath class='cls-2' d='M94,400.48S93.17,388,83.18,387.81H76.81v5.36l6.28.1S89.67,393.11,94,400.48Z'/%3e%3ccircle class='cls-1' cx='73.12' cy='181.96' r='8.99' transform='translate(-120.8 211.15) rotate(-76.67)'/%3e%3cpath class='cls-1' d='M73.12,189.86a15.37,15.37,0,0,0-15.37,15.37H88.49A15.37,15.37,0,0,0,73.12,189.86Z'/%3e%3cpath class='cls-1' d='M324.88,13.07a6.25,6.25,0,1,1-6.25-6.26A6.25,6.25,0,0,1,324.88,13.07Z'/%3e%3cpath class='cls-1' d='M342.22,27.69A6.25,6.25,0,1,1,336,21.44,6.25,6.25,0,0,1,342.22,27.69Z'/%3e%3cpath class='cls-1' d='M325,42.61a6.26,6.26,0,1,1-6.25-6.25A6.25,6.25,0,0,1,325,42.61Z'/%3e%3cpolyline class='cls-3' points='318.63 13.07 335.97 27.69 318.73 42.61'/%3e%3cpath class='cls-1' d='M432.73,159.69c-2.7-4.93-7.18-5.7-10.19-4.58a10.43,10.43,0,0,0-5,4.58,10.38,10.38,0,0,0-5-4.58c-3-1.12-7.49-.35-10.19,4.58-5.63,10.3,15.15,23.7,15.15,23.7S438.36,170,432.73,159.69Z'/%3e%3cpath class='cls-1' d='M408.14,207.69c-1.92-3.51-5.11-4.06-7.25-3.26a7.39,7.39,0,0,0-3.54,3.26,7.39,7.39,0,0,0-3.54-3.26c-2.14-.8-5.33-.25-7.25,3.26-4,7.34,10.79,16.88,10.79,16.88S412.16,215,408.14,207.69Z'/%3e%3cpath class='cls-2' d='M424.38,37.29H357.69a14.81,14.81,0,0,0-14.8,14.81V92.51a14.81,14.81,0,0,0,14.8,14.81H378.3l11.56,16.52a3.88,3.88,0,0,0,6.44-.11L407,107.32h17.39a14.81,14.81,0,0,0,14.8-14.81V52.1A14.81,14.81,0,0,0,424.38,37.29Z'/%3e%3cpath class='cls-4' d='M424.38,37.29h.5a10.44,10.44,0,0,1,1.47.1,13.84,13.84,0,0,1,5.41,1.78,14.83,14.83,0,0,1,7.52,12.32c.07,2.06,0,4.24.05,6.54,0,9.22,0,20.35.06,33a20.37,20.37,0,0,1-.39,4.83,14.32,14.32,0,0,1-1.91,4.62,15,15,0,0,1-8,6.32,16.83,16.83,0,0,1-5.34.75H407l.2-.11-6.11,9.41-3.16,4.84c-.54.82-1,1.63-1.63,2.47a4.09,4.09,0,0,1-2.65,1.54,4.14,4.14,0,0,1-3-.74,4.37,4.37,0,0,1-1.09-1.14l-.86-1.23-3.49-5q-3.51-5-7.1-10.15l.21.11H358.65a18.5,18.5,0,0,1-4.19-.36,16.07,16.07,0,0,1-3.92-1.45,15.14,15.14,0,0,1-7.91-13.51c0-10.61,0-20.84,0-30.59q0-3.64,0-7.22c0-1.18,0-2.35.06-3.55,0-.59.16-1.18.23-1.76s.27-1.15.46-1.7A15.35,15.35,0,0,1,347,41.57a15,15,0,0,1,5.6-3.58,9.75,9.75,0,0,1,1.57-.47,12.52,12.52,0,0,1,1.6-.3,24.48,24.48,0,0,1,3.18-.14h6.16l11.57,0,34.91.08,9.5.05,2.47,0,.84,0-.84,0-2.47,0-9.5,0-34.91.09H358.93a23.35,23.35,0,0,0-3.13.14,14.06,14.06,0,0,0-1.55.29,11.56,11.56,0,0,0-1.52.46,14.75,14.75,0,0,0-5.44,3.49,15.16,15.16,0,0,0-3.45,5.7c-.17.54-.3,1.1-.43,1.65s-.21,1.13-.23,1.71c-.08,1.14-.05,2.33-.06,3.51q0,3.57,0,7.22c0,9.75,0,20,0,30.59a14.67,14.67,0,0,0,7.65,13.06,15.31,15.31,0,0,0,3.78,1.39,17.86,17.86,0,0,0,4.08.35h19.79l.08.11,7.1,10.15q1.74,2.5,3.48,5l.86,1.24a3.77,3.77,0,0,0,1,1,3.62,3.62,0,0,0,5-.7c.54-.77,1.07-1.63,1.6-2.43l3.16-4.85,6.12-9.39.07-.12H423.7a16.39,16.39,0,0,0,5.2-.72,14.6,14.6,0,0,0,7.83-6.12,13.7,13.7,0,0,0,1.86-4.48A19.89,19.89,0,0,0,439,91c0-12.64,0-23.77,0-33,0-2.3,0-4.49,0-6.53a14.69,14.69,0,0,0-7.34-12.19,13.91,13.91,0,0,0-5.34-1.84,11.77,11.77,0,0,0-1.47-.14Z'/%3e%3cpolygon class='cls-5' points='392.94 58.8 392.94 86.43 412.71 72.61 392.94 58.8'/%3e%3cpath class='cls-5' d='M366.47,88.61s1.31-19.63,17-19.92h10v8.43l-9.89.15S373.28,77,366.47,88.61Z'/%3e%3crect class='cls-2' x='15.86' y='0.21' width='165.59' height='134.44' rx='14.01' transform='translate(197.3 134.87) rotate(180)'/%3e%3cpath class='cls-5' d='M92,130.54c-1.7,4.12-34.55,35-34.55,35v-35Z'/%3e%3cpath class='cls-4' d='M132.16,59.21c.09-7,1.19-14,.92-21s-2.11-14.3-7-19.33S112.7,11.92,107,16l-1.17,6,6.75,81.12c.3,3.55.62,7.21,2.24,10.39s4.85,5.8,8.41,5.58c4.66-.29,7.71-5,9.16-9.44C137.62,93.53,132,76.12,132.16,59.21Z'/%3e%3cpath class='cls-5' d='M115.3,22.85A19.58,19.58,0,0,0,111.73,18a6.66,6.66,0,0,0-5.52-1.84,2.76,2.76,0,0,0-2.19,1.6c-.31.89.36,2.08,1.3,2l.2.18c2.1,1.85,4.24,3.67,6.41,5.44a5.58,5.58,0,0,0,1.79,1.11,1.89,1.89,0,0,0,2-.42C116.46,25.22,115.89,23.86,115.3,22.85Z'/%3e%3cpath class='cls-4' d='M119.26,29.74c-7-8.54-16.37-13.46-27.41-13.64-6.23-.11-8.8,1.19-13.29,2.4a19.62,19.62,0,0,0-11.2,7.41c-3.18,4.51-5.85,9.56-6.45,15s-1.23,11.3-.81,16.95,2,11.34,5.29,15.93l14.38,2.5c7.94.27,16,.53,23.72-1.28s15.25-6,19.39-12.76C128.64,52.88,126.25,38.28,119.26,29.74Z'/%3e%3cpath class='cls-6' d='M79.71,101.85c.1-5,.27-11.37.27-11.35S68.25,89.21,65,74.18c-1.62-7.47-1.92-19.85-1.83-30C63.26,35.07,71,22.65,82.3,22.61l5-.58,19.17,7.61a5.33,5.33,0,0,1,5.06,5.15l.73,66.07L100,121.37l-22-17Z'/%3e%3cpath class='cls-7' d='M87.55,70.67a3.17,3.17,0,0,0-1.1-2,3.26,3.26,0,0,0-4-.23,4.37,4.37,0,0,0-1.66,4.11h0a4,4,0,0,0,2.85,1.65,4.61,4.61,0,0,0,.53,0,3.55,3.55,0,0,0,2.41-1A3.16,3.16,0,0,0,87.55,70.67Z'/%3e%3cpath class='cls-4' d='M69.23,55.91a2,2,0,0,0,2,1.86,1.86,1.86,0,0,0,1.91-1.87,1.94,1.94,0,0,0-2-1.85A1.86,1.86,0,0,0,69.23,55.91Z'/%3e%3cpath class='cls-4' d='M66.62,49.26c.26.24,1.67-.93,3.76-1s3.68.86,3.9.59-.17-.56-.86-1A5.49,5.49,0,0,0,70.28,47a5.15,5.15,0,0,0-3,1.15C66.69,48.69,66.5,49.16,66.62,49.26Z'/%3e%3cpath class='cls-4' d='M80.06,65.67a14,14,0,0,0-3.43-.43c-.54,0-1-.1-1.16-.46a2.81,2.81,0,0,1,.27-1.6c.43-1.32.89-2.71,1.36-4.16,1.87-5.91,3.2-10.76,3-10.83s-2,4.66-3.83,10.57c-.45,1.46-.88,2.84-1.28,4.17A3.13,3.13,0,0,0,74.78,65a1.37,1.37,0,0,0,.93.74,3.73,3.73,0,0,0,.91.07A13.53,13.53,0,0,0,80.06,65.67Z'/%3e%3cpath class='cls-7' d='M80,90.5A38.59,38.59,0,0,0,100,84S95.15,94.77,79.9,94.19Z'/%3e%3cpath class='cls-4' d='M86.3,66.78c-.34,0-.22,2.27-2.08,4s-4.28,1.6-4.28,1.91c0,.15.56.42,1.58.39a5.63,5.63,0,0,0,3.59-1.48,4.89,4.89,0,0,0,1.59-3.33C86.74,67.3,86.45,66.76,86.3,66.78Z'/%3e%3cpath class='cls-4' d='M67.33,41.94c.38.49,2,.06,3.85.11s3.45.46,3.84,0c.17-.23-.06-.72-.74-1.2a5.67,5.67,0,0,0-3.09-.9,5.55,5.55,0,0,0-3.1.83C67.4,41.22,67.17,41.7,67.33,41.94Z'/%3e%3cpath class='cls-4' d='M93,55.4a2,2,0,0,1-1.85,2,1.86,1.86,0,0,1-2-1.72,2,2,0,0,1,1.84-2A1.86,1.86,0,0,1,93,55.4Z'/%3e%3cpath class='cls-4' d='M94.93,48.45c-.24.26-1.73-.8-3.83-.76s-3.61,1.12-3.84.86c-.11-.11.13-.57.79-1.07a5.32,5.32,0,0,1,3.07-1,5.19,5.19,0,0,1,3,.93C94.82,47.88,95.05,48.34,94.93,48.45Z'/%3e%3cpath class='cls-4' d='M93.67,41.75c-.4.49-2,0-4,0s-3.58.38-4-.11c-.17-.24.08-.72.79-1.18a6.32,6.32,0,0,1,6.4.06C93.61,41,93.85,41.52,93.67,41.75Z'/%3e%3cpath class='cls-6' d='M108.93,60.26c-.06-1.13,1.1-3.86,2.21-4.1,3-.62,8.33-.68,8.79,6.88.64,10.33-9.87,8.83-9.9,8.54S109.14,64.16,108.93,60.26Z'/%3e%3cpath class='cls-7' d='M112.64,67.63s.19.11.5.24a1.83,1.83,0,0,0,1.35-.06c1.07-.47,1.88-2.26,1.82-4.12a5.94,5.94,0,0,0-.67-2.55,2.11,2.11,0,0,0-1.43-1.3.93.93,0,0,0-1,.56c-.12.3,0,.5-.09.52s-.23-.16-.18-.59a1.14,1.14,0,0,1,.37-.67,1.34,1.34,0,0,1,1-.32,2.52,2.52,0,0,1,2,1.48,6.19,6.19,0,0,1,.8,2.84c.06,2.09-.89,4.1-2.35,4.63a1.94,1.94,0,0,1-1.67-.18C112.68,67.88,112.61,67.65,112.64,67.63Z'/%3e%3cpath class='cls-4' d='M111.56,56.19l-2.63,2.72C97.6,48.07,75.45,20.9,76.68,22.52a33.09,33.09,0,0,1,16.2-1.76c8.42,1.44,24.41,5.66,24.16,15.6S111.56,56.19,111.56,56.19Z'/%3e%3cpath class='cls-5' d='M126.57,53.91a2.79,2.79,0,0,0-.16-.6,11.51,11.51,0,0,0-.7-1.63,15,15,0,0,0-4.32-4.85,28.25,28.25,0,0,0-8.69-4.18c-3.46-1.13-7.35-2-11.18-3.65a50.27,50.27,0,0,1-10.2-5.71A52.65,52.65,0,0,1,84.11,27,55.75,55.75,0,0,1,80,22.05c-.43-.58-.77-1.05-1-1.43a2.64,2.64,0,0,0-.39-.48,3.06,3.06,0,0,0,.3.54c.22.34.52.86,1,1.49a47.28,47.28,0,0,0,4.06,5.08A50.8,50.8,0,0,0,91,33.68a49.32,49.32,0,0,0,10.29,5.81c3.87,1.67,7.79,2.53,11.23,3.62a28.68,28.68,0,0,1,8.62,4,15.64,15.64,0,0,1,4.36,4.66C126.28,53.11,126.51,53.93,126.57,53.91Z'/%3e%3cpath class='cls-5' d='M123.56,55.54a5.33,5.33,0,0,0-.4-2.26,10.52,10.52,0,0,0-3.88-4.86c-2.16-1.61-5.24-2.61-8.62-3.38A50.85,50.85,0,0,1,100,41.64a45.38,45.38,0,0,1-9.55-5.9,46.67,46.67,0,0,1-6.55-6.43,48.27,48.27,0,0,1-3.65-5l-.88-1.45a4.28,4.28,0,0,0-.33-.49,1.84,1.84,0,0,0,.24.54L80,24.4a43.49,43.49,0,0,0,3.54,5.14,44.2,44.2,0,0,0,6.53,6.58,44.53,44.53,0,0,0,9.64,6,49.7,49.7,0,0,0,10.82,3.39c3.38.75,6.39,1.69,8.51,3.21A10.68,10.68,0,0,1,123,53.35,12.37,12.37,0,0,1,123.56,55.54Z'/%3e%3cpath class='cls-5' d='M111.22,73.68c0-.07.87-.18,2.4-.58a15,15,0,0,0,5.78-3.23,20.7,20.7,0,0,0,5.37-8.22A36,36,0,0,0,127,49.73a29.86,29.86,0,0,0-.5-6.26,28.87,28.87,0,0,0-7.06-13.94,48.15,48.15,0,0,0-6.94-6,2.09,2.09,0,0,1,.58.3c.35.22.91.52,1.56,1a31.54,31.54,0,0,1,5.15,4.43,29.35,29.35,0,0,1,5.58,8.41,30.84,30.84,0,0,1,1.79,5.72,30.56,30.56,0,0,1,.52,6.41,35.9,35.9,0,0,1-2.33,12.13,20.82,20.82,0,0,1-5.64,8.35,14.29,14.29,0,0,1-6,3.12,12.7,12.7,0,0,1-1.83.3A2.07,2.07,0,0,1,111.22,73.68Z'/%3e%3cpath class='cls-5' d='M46.77,118.43l.25-.33C58.41,106.05,79.35,102,79.35,102s1.28,7.89,13,8.77,20.37-11.08,20.37-11.08l15.66,2.19s7.89.93,12.8,3.82c11.06,6.5,16.93,28.94,16.93,28.94l-120.82.48Z'/%3e%3cpath class='cls-4' d='M35.72.21l-.85.07-1,.06c-.41,0-.89.13-1.43.21a19.69,19.69,0,0,0-8.77,3.88,20.32,20.32,0,0,0-4.7,5.24,19.78,19.78,0,0,0-2.79,7.92A35.32,35.32,0,0,0,16,22.35v5.1c0,3.51,0,7.24,0,11.18,0,15.74,0,34.79.05,56.51q0,8.14,0,16.79c0,1.44,0,2.89.07,4.33a20.2,20.2,0,0,0,.79,4.27,19.79,19.79,0,0,0,4.41,7.62,21,21,0,0,0,3.42,2.95,20.77,20.77,0,0,0,4.07,2.07l1.08.39,1.12.29a19.09,19.09,0,0,0,2.28.42c.77.12,1.55.1,2.33.16h22v.24c0,9.75,0,20.18,0,30.87l-.42-.18q7.66-7.23,15.58-14.93c5.23-5.14,10.6-10.36,15.71-15.93l.08-.09h70.72c1.3,0,2.59,0,3.86-.08a19.81,19.81,0,0,0,7.27-2.08,19.61,19.61,0,0,0,9.61-11.09,21.44,21.44,0,0,0,1.08-7.33v-7.48c0-19.84,0-39,0-57.2q0-13.68,0-26.64a31.9,31.9,0,0,0-.39-6.36,20.27,20.27,0,0,0-2.22-5.83,18.78,18.78,0,0,0-3.85-4.78,18.62,18.62,0,0,0-5-3.32A19.28,19.28,0,0,0,164,.59a55.17,55.17,0,0,0-5.89-.17H125L59.66.31,41.91.27l-4.62,0-1.57,0s.53,0,1.57,0l4.62,0,17.75,0L125,0l21.64,0h11.51a54,54,0,0,1,5.94.17,19.84,19.84,0,0,1,5.84,1.65,19.15,19.15,0,0,1,5.15,3.39A19.42,19.42,0,0,1,179,10.09a20.77,20.77,0,0,1,2.27,6,31.61,31.61,0,0,1,.41,6.45q0,12.95,0,26.64c0,18.23,0,37.36,0,57.2v7.48a22,22,0,0,1-1.1,7.49,20.1,20.1,0,0,1-17.33,13.52c-1.31.09-2.6.1-3.9.09H88.76l.19-.08c-5.13,5.59-10.5,10.81-15.74,16s-10.47,10.1-15.59,14.92l-.41.39v-.57c0-10.69,0-21.12,0-30.87l.23.23H35.63c-.79-.06-1.59,0-2.38-.16a18.4,18.4,0,0,1-2.33-.44L29.78,134l-1.11-.4a21.2,21.2,0,0,1-4.16-2.13,21,21,0,0,1-3.49-3,20.07,20.07,0,0,1-4.5-7.79,20.61,20.61,0,0,1-.8-4.37c-.11-1.48-.07-2.92-.07-4.36q0-8.64,0-16.79c0-21.72,0-40.77.05-56.51q0-5.91,0-11.18c0-1.76,0-3.46,0-5.1a37.35,37.35,0,0,1,.18-4.78A20,20,0,0,1,23.54,4.31,19.43,19.43,0,0,1,32.38.48c.55-.08,1-.17,1.44-.2l1,0C35.43.21,35.72.21,35.72.21Z'/%3e%3cpath class='cls-4' d='M290.64,429,165.87,429c-15,0-27.17-11.6-27.16-25.9L138.77,105c0-14.31,12.18-25.91,27.19-25.9l124.77.07c15,0,27.17,11.61,27.16,25.91l-.06,298.08C317.83,417.45,305.65,429,290.64,429Z'/%3e%3cpath class='cls-2' d='M290.6,89.7l-24.19,0a5.87,5.87,0,0,0-5.88,5.85v4.18a5.86,5.86,0,0,1-5.87,5.85l-47.15,0a5.86,5.86,0,0,1-5.88-5.85V95.5a5.87,5.87,0,0,0-5.87-5.86H166.08c-10.52,0-19,8.11-19.05,18.13l-.06,291c0,10,8.52,18.14,19,18.14l124.52.07c10.51,0,19-8.11,19-18.13l.06-291C309.62,97.82,301.11,89.7,290.6,89.7Z'/%3e%3cpath class='cls-4' d='M224.15,162.22a7.1,7.1,0,0,0,.36-14.12,7.39,7.39,0,0,0-8.67-11,8.83,8.83,0,0,0-14.45-4.6,9.93,9.93,0,0,0-12.07,2.06,7.07,7.07,0,0,0-3.88,12.95'/%3e%3cpath class='cls-8' d='M225.35,163a30.12,30.12,0,0,0-34.68-21.6l-1.53.29c-16.35,4.11-22,20.29-17.42,36.51l11.43,58.9h0l33.67,26,8.72-21.7-3.43-19.6s15.41-5.5,12.59-21.42C233.33,192.69,229.23,177.09,225.35,163Z'/%3e%3cpath class='cls-9' d='M222.23,221.75a39.22,39.22,0,0,1-22-2.13s6.88,10.85,22.46,6.4Z'/%3e%3cpath class='cls-4' d='M223.94,178.25a2.31,2.31,0,0,1-1.75,2.7,2.2,2.2,0,0,1-2.73-1.6,2.3,2.3,0,0,1,1.75-2.7A2.21,2.21,0,0,1,223.94,178.25Z'/%3e%3cpath class='cls-4' d='M223.42,171.43c-.23.35-2.19-.6-4.63-.13s-4,2-4.31,1.79c-.16-.11,0-.7.7-1.41a6.25,6.25,0,0,1,3.38-1.8,6.14,6.14,0,0,1,3.76.47C223.18,170.78,223.53,171.27,223.42,171.43Z'/%3e%3cpath class='cls-4' d='M201.79,182.93a2.31,2.31,0,0,1-1.75,2.71,2.21,2.21,0,0,1-2.73-1.6,2.32,2.32,0,0,1,1.75-2.71A2.21,2.21,0,0,1,201.79,182.93Z'/%3e%3cpath class='cls-4' d='M199.51,176.45c-.22.35-2.19-.59-4.62-.12s-4,2-4.32,1.78c-.16-.11,0-.69.7-1.41a6.38,6.38,0,0,1,3.39-1.8,6.12,6.12,0,0,1,3.75.47C199.27,175.81,199.62,176.29,199.51,176.45Z'/%3e%3cpath class='cls-4' d='M211.82,192.87c0-.14,1.43-.69,3.82-1.47.62-.18,1.18-.42,1.21-.87a3.25,3.25,0,0,0-.77-1.77l-2.75-4.39c-3.85-6.27-6.76-11.47-6.5-11.63s3.58,4.81,7.42,11.08c.94,1.55,1.83,3,2.68,4.44a3.67,3.67,0,0,1,.79,2.38,1.6,1.6,0,0,1-.86,1.11,4.18,4.18,0,0,1-1,.35A16.86,16.86,0,0,1,211.82,192.87Z'/%3e%3cpath class='cls-4' d='M198.67,168c-.2.68-2.42.41-5,.82s-4.67,1.24-5,.64c-.16-.28.19-.93,1-1.6a8,8,0,0,1,3.71-1.55,7.66,7.66,0,0,1,4,.44C198.26,167.16,198.76,167.68,198.67,168Z'/%3e%3cpath class='cls-4' d='M222.07,162.73c-.41.65-2.53.46-5,.9s-4.4,1.22-5,.73c-.26-.24,0-.86.76-1.55a7.88,7.88,0,0,1,3.85-1.68,8,8,0,0,1,4.16.36C221.86,161.9,222.25,162.42,222.07,162.73Z'/%3e%3cpath class='cls-8' d='M177.21,193.18a4.39,4.39,0,0,0-5.44-3.27c-2.91.85-5.89,3.16-4.53,9.24,2.42,10.8,12.76,6.15,12.7,5.83S178.26,197.69,177.21,193.18Z'/%3e%3cpath class='cls-9' d='M176.69,201.45c-.06,0-.16.17-.45.39a1.9,1.9,0,0,1-1.4.34c-1.23-.16-2.59-1.76-3.08-3.69a6.4,6.4,0,0,1-.08-2.81,2.25,2.25,0,0,1,1.09-1.76,1,1,0,0,1,1.23.27c.21.27.19.5.25.5s.19-.23,0-.66a1.29,1.29,0,0,0-.58-.58,1.48,1.48,0,0,0-1.1,0,2.7,2.7,0,0,0-1.59,2.11,6.5,6.5,0,0,0,0,3.16c.56,2.16,2.13,3.94,3.79,4a2,2,0,0,0,1.65-.67C176.73,201.71,176.73,201.46,176.69,201.45Z'/%3e%3cpath class='cls-4' d='M212,142.13a4,4,0,0,0-.53-.7,7.14,7.14,0,0,0-6-2.05,28.59,28.59,0,0,0-4.11-.87,9.63,9.63,0,0,0-16.19,2.38l-1.29.47A9.84,9.84,0,0,0,170,148.31a7.14,7.14,0,0,0-6,11.7c-1.74,1.49-3,3.75-2.65,6s2.7,3.83,4.69,3.2c.6,5.27,2.33,11.29,3.63,16.65.92,3.76,6.19,5.1,7,7.62,4.2,12.85,7.13,4.75,3.59-22.84.23-.26.46-.54.7-.85a16,16,0,0,0,.87-2c.46-.81,1.59-.8,2.52-.88a7,7,0,0,0,6.25-6.34c1,1.06,2.9.65,4-.37a15.94,15.94,0,0,0,2.36-3.73c.74-1.27,1.9-2.5,3.37-2.57a11.32,11.32,0,0,0,2.46.07c1.4-.4,1.78-2.2,1.73-3.66a6.67,6.67,0,0,1,.45-3.61,8.34,8.34,0,0,1,2.61-1.32c.55,0,1.12,0,1.66-.06a4.27,4.27,0,0,0,.78-.1,9.43,9.43,0,0,1,1.06.21c5.24,1.41,11.32,10.56,11.32,10.56C221.57,149.65,217.15,145.05,212,142.13Z'/%3e%3cpath class='cls-5' d='M162.76,160.85s0-.06.07-.17.14-.29.27-.49a6.23,6.23,0,0,1,1.46-1.56,7,7,0,0,1,3.08-1.3,6.4,6.4,0,0,1,4.32.74l-.27.14a8.75,8.75,0,0,1,3.45-6.29,11.29,11.29,0,0,1,3.67-1.93,13.7,13.7,0,0,1,4.35-.51,22.06,22.06,0,0,1,7.92,2l-.3.15a9.87,9.87,0,0,1,3.92-6.06,9.48,9.48,0,0,1,5.45-1.74,9.36,9.36,0,0,1,3.68.73,5.26,5.26,0,0,1,.9.45c.2.11.3.18.29.19s-.43-.21-1.24-.51a9.87,9.87,0,0,0-3.63-.59,9.23,9.23,0,0,0-5.23,1.77,9.51,9.51,0,0,0-3.71,5.84l-.05.27-.25-.11a22,22,0,0,0-7.77-2,13,13,0,0,0-4.2.48,11,11,0,0,0-3.53,1.84,8.44,8.44,0,0,0-3.36,6v.3l-.27-.15a6.18,6.18,0,0,0-4.08-.76,6.93,6.93,0,0,0-3,1.18A7.8,7.8,0,0,0,162.76,160.85Z'/%3e%3cpath class='cls-5' d='M205,146s0,.16-.11.45a9,9,0,0,0-.17,1.33c0,.59,0,1.31-.07,2.16a6.77,6.77,0,0,1-.56,2.88,2.25,2.25,0,0,1-1.37,1.1,7.72,7.72,0,0,1-1.87.23,3.76,3.76,0,0,0-1.82.49,5,5,0,0,0-1.34,1.52c-.39.61-.73,1.28-1.1,2a7.75,7.75,0,0,1-1.29,2,5.09,5.09,0,0,1-2.23,1.25,4.19,4.19,0,0,1-1.33.17,1.91,1.91,0,0,1-1.32-.57l.39-.14a6.8,6.8,0,0,1-.38,2,6.5,6.5,0,0,1-1,1.78,7.53,7.53,0,0,1-3.5,2.33,9.3,9.3,0,0,1-1.72.39,3.81,3.81,0,0,0-1.58.3,2.29,2.29,0,0,0-1,1.15,12.17,12.17,0,0,1-.88,1.43,8.67,8.67,0,0,1-5.09,3.68,8,8,0,0,1-5.51-1.21A8.28,8.28,0,0,1,167,169l.21.08a4.36,4.36,0,0,1-3.7-.18,4.2,4.2,0,0,1-2.18-3.8,3.36,3.36,0,0,1,.05-.46,1,1,0,0,1,0-.15,4.86,4.86,0,0,0,.39,2.27,3.92,3.92,0,0,0,1.82,1.92,4.08,4.08,0,0,0,3.45.11l.14-.06.07.14a7.88,7.88,0,0,0,3.07,3.49,7.58,7.58,0,0,0,5.23,1.12,8.25,8.25,0,0,0,4.81-3.53,10.57,10.57,0,0,0,.84-1.38,2.71,2.71,0,0,1,1.17-1.34,2.8,2.8,0,0,1,.89-.28l.85-.07a8.46,8.46,0,0,0,1.64-.37,7.29,7.29,0,0,0,3.3-2.18,6.26,6.26,0,0,0,.95-1.66,6.39,6.39,0,0,0,.36-1.82l0-.53.35.39a2.23,2.23,0,0,0,2.2.28,4.76,4.76,0,0,0,2.05-1.14,7.42,7.42,0,0,0,1.24-1.93c.38-.67.72-1.34,1.13-2a5.19,5.19,0,0,1,1.47-1.62,4,4,0,0,1,2-.52,7.75,7.75,0,0,0,1.8-.2,2,2,0,0,0,1.22-.94,6.74,6.74,0,0,0,.58-2.75c.05-.84.08-1.57.14-2.16a7.49,7.49,0,0,1,.24-1.34C204.91,146.14,205,146,205,146Z'/%3e%3cpath class='cls-9' d='M205,198.58c-.45,3,.84,5.88,3.66,6.9a4,4,0,0,0,3.06-.17,4,4,0,0,0,2.41-2.72,7.81,7.81,0,0,0,.06-3.75C211.63,198.69,207.61,198.73,205,198.58Z'/%3e%3cpath class='cls-4' d='M213.63,203.8s0,.08-.1.21a3.79,3.79,0,0,1-.44.52,4.11,4.11,0,0,1-2.24,1.11,5.36,5.36,0,0,1-3.63-.74,5.62,5.62,0,0,1-2.45-3.81,5,5,0,0,1-.06-1.22,2.62,2.62,0,0,1,.31-1.21,1,1,0,0,1,.56-.44,2,2,0,0,1,.61-.08l1.07,0c1.37.07,2.6.21,3.63.31,2.05.23,3.32.29,3.32.36a14.27,14.27,0,0,1-3.35,0c-1-.06-2.26-.16-3.62-.2h-1c-.36,0-.61.06-.75.29a2.17,2.17,0,0,0-.23,1,5.91,5.91,0,0,0,.06,1.11,5.26,5.26,0,0,0,2.2,3.49,5.13,5.13,0,0,0,3.32.77,4.31,4.31,0,0,0,2.16-.89C213.4,204,213.59,203.76,213.63,203.8Z'/%3e%3cpath class='cls-5' d='M274,169.29s12.67-1.58,31.72-16.73,29.35-36.67,31.48-36.36,11.87-3.15,26,37.14,6.28,48.6,2.75,48.2-26.88-9.35-42-9.06-35.14,6.28-35.14,6.28Z'/%3e%3cpolygon class='cls-5' points='251.23 199.38 258 197.93 254.34 189.03 248.62 191.88 251.23 199.38'/%3e%3cpath class='cls-4' d='M252,188.78l2.5,7.52,1.56,3.79A10.55,10.55,0,0,0,269.34,206l27.48-7.72L285,163.52,257.72,175A10.55,10.55,0,0,0,252,188.78Z'/%3e%3cpath class='cls-4' d='M261.87,200.34l9.21,16.32,4.2-1.36L304,236.74l7.13-15.52s-16.71-6.39-20-12.12.18-7.2.18-7.2l-8.1-8.46Z'/%3e%3cpath class='cls-4' d='M361.7,153.91c7.48,21.81,9.66,40.82,4.86,42.47s-14.73-14.71-22.21-36.52S334.7,119,339.49,117.4,354.23,132.1,361.7,153.91Z'/%3e%3cpath class='cls-10' d='M342.88,147.44s11.42-5.67,15.95,9.46-7.05,16.46-7.05,16.46A97.43,97.43,0,0,1,342.88,147.44Z'/%3e%3cpath class='cls-4' d='M333,129a17,17,0,0,0,.17,2.82c.17,1.81.41,4.44.8,7.68q.47,2.42,1,5.24c.18.94.37,1.92.57,2.92q.15.75.3,1.53c.11.51.28,1,.42,1.54.59,2.08,1.2,4.26,1.84,6.52.16.56.32,1.13.49,1.71s.4,1.13.6,1.7c.43,1.13.86,2.29,1.29,3.45s.88,2.32,1.3,3.46c.23.56.4,1.14.66,1.68s.51,1.08.76,1.61l2.89,6.13c.24.48.45,1,.7,1.44s.52.9.77,1.35c.52.88,1,1.75,1.49,2.58l2.69,4.62c1.82,2.69,3.37,4.83,4.43,6.31a16,16,0,0,0,1.73,2.23,16.36,16.36,0,0,0-1.43-2.44l-4.19-6.47L349.77,182c-.47-.84-.94-1.7-1.44-2.58q-.37-.66-.75-1.35c-.24-.46-.45-.95-.68-1.44l-2.82-6.11c-.24-.53-.49-1.06-.74-1.6s-.43-1.11-.65-1.67l-1.28-3.43c-.44-1.16-.87-2.3-1.29-3.43-.2-.57-.45-1.12-.61-1.69s-.33-1.13-.49-1.69l-1.88-6.46c-.15-.52-.32-1-.44-1.53s-.21-1-.31-1.51c-.21-1-.42-2-.62-2.89l-1.11-5.19c-.46-3.18-.83-5.77-1.09-7.62A15.49,15.49,0,0,0,333,129Z'/%3e%3cpath class='cls-5' d='M296.82,198.31a7.45,7.45,0,0,1-1.24.39l-3.41.89c-2.88.75-6.85,1.8-11.22,3s-8.33,2.31-11.23,3c-1.44.36-2.61.63-3.43.8a6.53,6.53,0,0,1-1.28.21,5.71,5.71,0,0,1,1.23-.41l3.39-1,11.18-3.17c4.38-1.21,8.37-2.2,11.28-2.86,1.45-.32,2.63-.57,3.44-.73A5.5,5.5,0,0,1,296.82,198.31Z'/%3e%3cpath class='cls-5' d='M280.67,192.63a15.85,15.85,0,0,1-2.68,1.14c-1.69.63-4,1.44-6.68,2.22s-5,1.4-6.8,1.8a15.57,15.57,0,0,1-2.87.52,17.15,17.15,0,0,1,2.78-.88c1.73-.48,4.12-1.15,6.75-1.94s5-1.53,6.7-2.07A17,17,0,0,1,280.67,192.63Z'/%3e%3cpath class='cls-5' d='M276.31,184.68a76.75,76.75,0,0,1-8.48,2.84,77.44,77.44,0,0,1-8.62,2.33,75,75,0,0,1,8.47-2.83A75.52,75.52,0,0,1,276.31,184.68Z'/%3e%3cpath class='cls-5' d='M272.05,177a63.57,63.57,0,0,1-7.22,3.44,61.79,61.79,0,0,1-7.43,3,63.57,63.57,0,0,1,7.22-3.44A61.79,61.79,0,0,1,272.05,177Z'/%3e%3cpath class='cls-5' d='M241.14,263.1,224.45,235l-43.12-1.79,0,3.93S169.52,249,165.71,265.24c-2.89,12.29,9.26,59.19,12.69,75.45,4.2,20,10,45.29,10,45.29-.86,4.47-6.61,8.1-6.22,14.08L278.08,399l-4.93-19.43Z'/%3e%3cpath class='cls-2' d='M274.39,387c0,.14-19.07.26-42.6.26s-42.6-.12-42.6-.26,19.07-.26,42.6-.26S274.39,386.88,274.39,387Z'/%3e%3cpath class='cls-2' d='M267.77,363c0,.14-18.9.26-42.22.26s-42.22-.12-42.22-.26,18.9-.26,42.22-.26S267.77,362.83,267.77,363Z'/%3e%3cpath class='cls-2' d='M261.26,336.83c0,.14-18.5.26-41.31.26s-41.32-.12-41.32-.26,18.5-.26,41.32-.26S261.26,336.69,261.26,336.83Z'/%3e%3cpath class='cls-2' d='M256.71,310.52c0,.14-19,.26-42.55.26s-42.56-.12-42.56-.26,19.05-.26,42.56-.26S256.71,310.38,256.71,310.52Z'/%3e%3cpath class='cls-2' d='M246.65,277.88c0,.14-18,.26-40.27.26s-40.27-.12-40.27-.26,18-.26,40.27-.26S246.65,277.73,246.65,277.88Z'/%3e%3cpath class='cls-2' d='M232.92,248c0,.15-13.32.26-29.74.26s-29.75-.11-29.75-.26,13.32-.26,29.75-.26S232.92,247.84,232.92,248Z'/%3e%3cpath class='cls-11' d='M177.93,280.45a76.78,76.78,0,0,0,15.74,18.76c9.63,8,38.93,22.33,38.93,22.33l2.44-5.06,21.87,5.11-4.06-13.46Z'/%3e%3cpath class='cls-8' d='M280.77,245l-7.62,41.43-65.36-31.07-10.54,36.86c25.69,12.56,77.7,33.47,84.39,32.87,9.52-.86,16.09-6.54,19.06-20.49,1.83-8.63,1-66.5,1-66.5Z'/%3e%3cpath class='cls-5' d='M212.06,249.74s-24.45-15.1-35.11,3.93c-7.62,18.56.82,33.38,19.63,42.59,9.08,4.43,21.44,9.91,33.92,15.12L248.69,271Z'/%3e%3cpath class='cls-4' d='M212.06,249.74l.67.36,1.94,1.09,7.38,4.22,26.74,15.43.16.09-.07.17-18.15,40.38-.1.23-.23-.1c-6.4-2.66-13-5.49-19.71-8.5-3-1.33-5.91-2.67-8.79-4s-5.72-2.71-8.46-4.2c-1.34-.77-2.67-1.57-3.94-2.41a45.07,45.07,0,0,1-3.66-2.72,37,37,0,0,1-6.18-6.33l-1.25-1.77a17.15,17.15,0,0,1-1.08-1.85,27,27,0,0,1-1.78-3.82c-.24-.65-.4-1.32-.6-2l-.29-1c-.08-.33-.13-.67-.19-1-.11-.67-.23-1.33-.34-2s-.09-1.33-.13-2a28,28,0,0,1,.08-3.89c.1-1.27.37-2.51.54-3.73s.61-2.38.94-3.53.81-2.22,1.21-3.3h0v0a19.88,19.88,0,0,1,5.78-6.54,17.75,17.75,0,0,1,7.27-2.87,28.73,28.73,0,0,1,12.43,1.22,45.23,45.23,0,0,1,7.38,3c.81.42,1.42.76,1.82,1s.6.38.6.38l-.63-.33c-.41-.22-1-.54-1.84-.94a48.19,48.19,0,0,0-7.39-2.88,28.94,28.94,0,0,0-12.32-1.11,17.38,17.38,0,0,0-7.11,2.85,19.57,19.57,0,0,0-5.64,6.44v0c-.39,1.07-.78,2.17-1.18,3.28s-.61,2.31-.92,3.49c-.16,1.21-.43,2.43-.52,3.68a27.13,27.13,0,0,0-.07,3.83c.05.65.07,1.3.13,2s.23,1.3.34,2c.07.32.11.66.19,1l.29,1c.2.64.36,1.3.59,1.94a27.73,27.73,0,0,0,1.76,3.75,18.3,18.3,0,0,0,1.07,1.81l1.23,1.75a36.69,36.69,0,0,0,6.11,6.23c1.12,1,2.39,1.8,3.62,2.69s2.58,1.62,3.91,2.39c2.71,1.47,5.55,2.82,8.43,4.17s5.81,2.69,8.78,4c6.71,3,13.31,5.83,19.7,8.5l-.33.13,18.23-40.34.08.26-26.65-15.58-7.32-4.32-1.91-1.14C212.27,249.89,212.06,249.74,212.06,249.74Z'/%3e%3cpath class='cls-8' d='M279.8,252l1.47-15.44s-5.9-11.88-5.79-13.07.47-7.74.47-7.74l14.75-13.27s4.77,0,4.89,4.72c0,0,4.6-1,4.66,4.54,0,0,5,.18,5.11,4.21h0s3-.4,2.89,3.81c-.07,3-1.39,14.61-1.39,14.61l-6.17,10.73-.51,10.73Z'/%3e%3cpath class='cls-9' d='M281.32,301.53c-.17.06-1.25-3.69-3.49-7.9s-4.82-7.14-4.68-7.25a10,10,0,0,1,1.75,1.86,33.26,33.26,0,0,1,3.39,5.15,36.62,36.62,0,0,1,2.41,5.67A9.87,9.87,0,0,1,281.32,301.53Z'/%3e%3cpath class='cls-2' d='M197.25,244.62a8.21,8.21,0,0,1-.65,1.4c-.44.89-1.11,2.16-2,3.72-1.68,3.13-4.09,7.41-6.79,12.11l-6.92,12c-.85,1.48-1.56,2.7-2.11,3.64a8.93,8.93,0,0,1-.82,1.31,7.46,7.46,0,0,1,.65-1.4c.44-.89,1.11-2.16,2-3.73,1.68-3.13,4.09-7.4,6.79-12.11l6.92-12,2.11-3.64A9.1,9.1,0,0,1,197.25,244.62Z'/%3e%3cpath class='cls-2' d='M217.18,253.35a1.65,1.65,0,0,1-.16.45l-.54,1.25c-.49,1.08-1.22,2.63-2.14,4.54-1.84,3.82-4.48,9.05-7.55,14.74s-6,10.76-8.21,14.39c-1.09,1.82-2,3.28-2.63,4.28l-.75,1.14c-.17.26-.27.39-.29.38a2.43,2.43,0,0,1,.2-.44l.67-1.19,2.49-4.35c2.1-3.68,5-8.77,8.06-14.46s5.76-10.88,7.68-14.65c.94-1.83,1.71-3.34,2.28-4.47.26-.48.47-.88.64-1.21A1.89,1.89,0,0,1,217.18,253.35Z'/%3e%3cpath class='cls-2' d='M239.48,265.82a9.74,9.74,0,0,1-.6,1.66c-.41,1-1,2.56-1.88,4.41-1.64,3.7-4.08,8.73-7.09,14.13s-6,10.13-8.3,13.47c-1.14,1.67-2.08,3-2.76,3.92a11.73,11.73,0,0,1-1.09,1.38,10.9,10.9,0,0,1,.92-1.5c.67-1,1.55-2.37,2.63-4,2.2-3.39,5.14-8.14,8.15-13.52s5.48-10.38,7.21-14l2-4.33A12.8,12.8,0,0,1,239.48,265.82Z'/%3e%3cpolygon class='cls-4' points='181.37 418.56 183.46 400.05 274.9 399.05 277.24 418.56 181.37 418.56'/%3e%3cpath class='cls-5' d='M294.63,416.92c0,.15-28.18.26-62.92.26s-62.92-.11-62.92-.26,28.16-.26,62.92-.26S294.63,416.78,294.63,416.92Z'/%3e%3crect class='cls-5' x='207.61' y='93.96' width='38.09' height='5.55' rx='2.04'/%3e%3cpath class='cls-5' d='M254.93,96.73A2.78,2.78,0,1,1,252.16,94,2.78,2.78,0,0,1,254.93,96.73Z'/%3e%3cpath class='cls-4' d='M139.7,137H142a0,0,0,0,1,0,0v46.4a0,0,0,0,1,0,0H139.7a6.2,6.2,0,0,1-6.2-6.2v-34A6.2,6.2,0,0,1,139.7,137Z'/%3e%3cpath class='cls-4' d='M139.15,204.46h2.25a0,0,0,0,1,0,0v46.4a0,0,0,0,1,0,0h-2.25a6.2,6.2,0,0,1-6.2-6.2v-34A6.2,6.2,0,0,1,139.15,204.46Z'/%3e%3cpath class='cls-5' d='M139.3,273.23c-.14,0-.26-33.69-.26-75.22s.12-75.23.26-75.23.26,33.67.26,75.23S139.45,273.23,139.3,273.23Z'/%3e%3crect class='cls-2' x='0.26' y='230.47' width='119.2' height='96.78' rx='11.41'/%3e%3cpath class='cls-5' d='M64.65,324.29c1.22,3,24.86,25.18,24.86,25.18V324.29Z'/%3e%3cpath class='cls-4' d='M81.26,252a14.94,14.94,0,0,0-7.41-8.84A18.77,18.77,0,0,0,61.16,242a39.73,39.73,0,0,0-11.82,5.29,19.29,19.29,0,0,0-5.6,4.62c-2.66,3.55-5.23,9.34-5.37,13.78-.11,3.59,1.52,12.52,3.13,15.73a8,8,0,0,0,3.52,3,30.76,30.76,0,0,0,6.74,8.4L54,285.5Z'/%3e%3cpath class='cls-4' d='M79.07,247.6,72,246.54c4.12,9.08,5.77,30.08,8.25,39.74,2.5-3.85,8.22-15.53,7.76-20.1S87.44,246.58,79.07,247.6Z'/%3e%3cpath class='cls-12' d='M46,263.86a12.07,12.07,0,0,1,8.76-11.37l16.14-4.61c7-1,12,7.55,12.61,14.59.74,7.83,1.29,16.09.54,22C82.56,296.25,73.6,298,73.6,298s.15,5.59.25,9l-2.64,15.39L49.92,304.28,46,264C46,263.8,46,264.13,46,263.86Z'/%3e%3cpath class='cls-4' d='M80,272.26a1.51,1.51,0,0,1-1.41,1.57A1.44,1.44,0,0,1,77,272.51a1.49,1.49,0,0,1,1.4-1.56A1.44,1.44,0,0,1,80,272.26Z'/%3e%3cpath class='cls-4' d='M81.9,267.13c-.18.2-1.35-.61-3-.55s-2.79.9-3,.71.09-.45.59-.84a4.11,4.11,0,0,1,2.37-.81,4,4,0,0,1,2.38.68C81.81,266.69,82,267,81.9,267.13Z'/%3e%3cpath class='cls-4' d='M65.36,272.26A1.51,1.51,0,0,1,64,273.83a1.44,1.44,0,0,1-1.59-1.32,1.49,1.49,0,0,1,1.4-1.56A1.44,1.44,0,0,1,65.36,272.26Z'/%3e%3cpath class='cls-4' d='M66.48,267.57c-.18.2-1.35-.61-3-.55s-2.79.9-3,.71.09-.45.6-.84a4.11,4.11,0,0,1,2.37-.81,4,4,0,0,1,2.37.68C66.39,267.13,66.57,267.48,66.48,267.57Z'/%3e%3cpath class='cls-4' d='M71.92,280.18a10.2,10.2,0,0,1,2.62-.56c.42-.06.81-.15.87-.44a2.09,2.09,0,0,0-.32-1.22l-1.32-3.11c-1.84-4.45-3.19-8.1-3-8.17s1.82,3.46,3.66,7.9c.44,1.1.87,2.14,1.27,3.14a2.44,2.44,0,0,1,.27,1.62,1,1,0,0,1-.67.63,2.78,2.78,0,0,1-.7.12A10.78,10.78,0,0,1,71.92,280.18Z'/%3e%3cpath class='cls-13' d='M57.88,294.29s4,8,15.79,6.51L73.6,298A29.64,29.64,0,0,1,57.88,294.29Z'/%3e%3cpath class='cls-4' d='M65.81,261.72c-.15.45-1.78.29-3.67.58s-3.43.85-3.69.46c-.12-.18.14-.61.74-1.05a6.3,6.3,0,0,1,2.71-1,6.21,6.21,0,0,1,2.9.25C65.51,261.17,65.87,261.51,65.81,261.72Z'/%3e%3cpath class='cls-4' d='M81.23,262.18c-.28.38-1.41,0-2.75.05s-2.48.33-2.75-.05c-.12-.18,0-.56.53-.92a4,4,0,0,1,4.43,0C81.18,261.62,81.35,262,81.23,262.18Z'/%3e%3cpath class='cls-4' d='M80,251.82a5.19,5.19,0,0,0-4.65-2.8A10.08,10.08,0,0,0,70,250.76c-6.89,4.25-10.21,14.13-17,18.52-1.68,1.08-3.92.2-5.33,1.6s-2.28,3.62-1.43,5.41a16.19,16.19,0,0,1-2.52-4,5.56,5.56,0,0,1,.06-4.59c.57-1,1.61-1.87,1.87-3s-.21-2.08-.2-3.14a7,7,0,0,1,1-3,30.62,30.62,0,0,1,10.91-12.15,19.94,19.94,0,0,1,10.25-3A15.22,15.22,0,0,1,77.52,247c1.59,1.39,3.26,2.84,2.51,4.82'/%3e%3cpath class='cls-12' d='M47.87,272.34c-.13-.34-6.33-2.38-6.23,4.15.11,6.33,6.46,4.9,6.47,4.72S47.87,272.34,47.87,272.34Z'/%3e%3cpath class='cls-13' d='M46.11,278.85s-.11.08-.29.17a1.14,1.14,0,0,1-.83,0,2.73,2.73,0,0,1-1.31-2.43A3.54,3.54,0,0,1,44,275a1.29,1.29,0,0,1,.81-.87.57.57,0,0,1,.66.29c.09.18,0,.31.08.32s.14-.11.08-.37a.66.66,0,0,0-.25-.39.81.81,0,0,0-.62-.15,1.53,1.53,0,0,0-1.13,1,3.79,3.79,0,0,0-.35,1.77,2.86,2.86,0,0,0,1.66,2.71,1.16,1.16,0,0,0,1-.19C46.1,279,46.13,278.86,46.11,278.85Z'/%3e%3cpath class='cls-2' d='M45.26,269.15a3.11,3.11,0,0,0,.37-.22c.24-.16.61-.38,1-.71A21.43,21.43,0,0,0,50,265a61.88,61.88,0,0,0,4-5.55,49.26,49.26,0,0,1,5-6.66,19.73,19.73,0,0,1,3.3-2.76A16.11,16.11,0,0,1,66,248.28a18.13,18.13,0,0,1,6.69-1,17.35,17.35,0,0,1,4.52.76,11.42,11.42,0,0,1,1.19.4,2.68,2.68,0,0,0,.42.13,4.14,4.14,0,0,0-.4-.19,11,11,0,0,0-1.17-.45,16.14,16.14,0,0,0-4.55-.85,17.66,17.66,0,0,0-6.78,1,16.25,16.25,0,0,0-3.67,1.77,19.91,19.91,0,0,0-3.35,2.8,47.68,47.68,0,0,0-5,6.71,65,65,0,0,1-4,5.57,23.34,23.34,0,0,1-3.24,3.25c-.42.34-.78.57-1,.75A2,2,0,0,0,45.26,269.15Z'/%3e%3cpath class='cls-4' d='M46.9,270.9a9.82,9.82,0,0,0,.77,5.08c.84,1.51,2.89,2.5,4.37,1.6,1.21-.74,1.53-2.32,1.7-3.73.48-4.05.64-8.14,1.16-12.18Z'/%3e%3cpath class='cls-5' d='M78.38,248.85s-.56-.09-1.57-.09a10.86,10.86,0,0,0-4.18.89,13.88,13.88,0,0,0-2.58,1.42,29.08,29.08,0,0,0-2.65,2.15,32.79,32.79,0,0,0-5.15,5.87c-.77,1.15-1.45,2.34-2.19,3.43a16.11,16.11,0,0,1-2.46,2.93,28.42,28.42,0,0,1-5.25,3.74c-1.6.9-2.93,1.54-3.86,2l-1.07.49a1.8,1.8,0,0,1-.38.15,2.05,2.05,0,0,1,.35-.21l1-.55c.9-.48,2.22-1.16,3.79-2.08a29.37,29.37,0,0,0,5.16-3.76,15.91,15.91,0,0,0,2.39-2.88c.73-1.09,1.41-2.27,2.19-3.44A31.65,31.65,0,0,1,67.18,253a26.44,26.44,0,0,1,2.7-2.15,14.1,14.1,0,0,1,2.66-1.42,10.52,10.52,0,0,1,4.27-.79,7.86,7.86,0,0,1,1.17.13A2.15,2.15,0,0,1,78.38,248.85Z'/%3e%3cpath class='cls-2' d='M46.62,267a2.77,2.77,0,0,1-.55.39l-1.58,1-.53.33a1.83,1.83,0,0,1-.69.25.69.69,0,0,1-.43-.09.58.58,0,0,1-.25-.41,1.38,1.38,0,0,1,.28-.81l1.77-3,.26.23a6.66,6.66,0,0,1-4.27,1.4,1.91,1.91,0,0,1-.57-.08.79.79,0,0,1-.51-.41.7.7,0,0,1,.09-.65,3.57,3.57,0,0,1,.35-.4,13.19,13.19,0,0,0,2.08-2.78,23.26,23.26,0,0,0,1.29-3,3.09,3.09,0,0,1-.18.86,11.2,11.2,0,0,1-.89,2.21,12.83,12.83,0,0,1-2.06,2.9c-.23.23-.46.49-.36.69s.44.28.77.28a6.52,6.52,0,0,0,4-1.34l.74-.57-.49.8c-.64,1.08-1.25,2.09-1.81,3a1.18,1.18,0,0,0-.25.63c0,.18.17.28.37.26a3.14,3.14,0,0,0,1.12-.5l1.63-.9A2.54,2.54,0,0,1,46.62,267Z'/%3e%3cpath class='cls-13' d='M65.83,283.34A2.13,2.13,0,0,1,68,281.67a2.23,2.23,0,0,1,1.73,1.17,2.72,2.72,0,0,1,.16,2.11l0,.16a2.41,2.41,0,0,1-2.7.65A2.27,2.27,0,0,1,65.83,283.34Z'/%3e%3cpath class='cls-4' d='M71,285.11c0-.25-1.65-.13-2.92-1.44s-1.23-3.07-1.46-3.06-.29.41-.25,1.15a4.1,4.1,0,0,0,1.13,2.57A3.53,3.53,0,0,0,70,285.42C70.64,285.43,71,285.22,71,285.11Z'/%3e%3cpath class='cls-5' d='M97.21,315.57l-.19-.24c-8.19-8.67-23.27-11.57-23.27-11.57s-.92,5.68-9.38,6.31-14.66-8-14.66-8l-11.28,1.58s-5.68.67-9.21,2.75C21.26,311.1,17,327.25,17,327.25l87,.35Z'/%3e%3cpath class='cls-4' d='M105.16,230.47h.61a10.08,10.08,0,0,1,1.79.17,13.9,13.9,0,0,1,6.38,2.76,14.3,14.3,0,0,1,5.5,9.55,25.82,25.82,0,0,1,.14,3.44c0,1.19,0,2.41,0,3.68,0,2.53,0,5.21,0,8,0,11.34,0,25.05.06,40.69q0,5.87,0,12.08c0,1,0,2.07,0,3.14a15.55,15.55,0,0,1-.58,3.16,14.56,14.56,0,0,1-3.25,5.64,14.18,14.18,0,0,1-5.53,3.71l-.8.29-.83.22a13.59,13.59,0,0,1-1.69.31,26.22,26.22,0,0,1-3.43.12h-14l.24-.24c0,7,0,14.53,0,22.22v.58l-.42-.4q-5.52-5.19-11.22-10.74c-3.77-3.7-7.63-7.45-11.33-11.48l.19.08H16.14c-.93,0-1.86,0-2.81-.06A14.51,14.51,0,0,1,.8,317.67a15.71,15.71,0,0,1-.8-5.42v-5.38c0-14.28,0-28.06,0-41.18q0-9.84,0-19.18a23.54,23.54,0,0,1,.29-4.66A15.15,15.15,0,0,1,2,237.55,14,14,0,0,1,4.82,234a14,14,0,0,1,3.72-2.45,14.39,14.39,0,0,1,4.22-1.19,41.36,41.36,0,0,1,4.29-.12h8.28l15.58,0,47,.08,12.79,0,3.32,0,1.13,0-1.13,0-3.32,0-12.79,0-47,.08-15.58,0H17.05a39.69,39.69,0,0,0-4.23.12A13.81,13.81,0,0,0,8.72,232a14.27,14.27,0,0,0-6.37,5.81,14.6,14.6,0,0,0-1.58,4.17,22.33,22.33,0,0,0-.28,4.57q0,9.33,0,19.18c0,13.12,0,26.9,0,41.18v5.38a15.55,15.55,0,0,0,.77,5.25,14,14,0,0,0,12.1,9.43c.9.07,1.83.07,2.76.06h51l.08.08c3.67,4,7.54,7.77,11.31,11.47s7.53,7.28,11.2,10.74l-.41.18c0-7.69,0-15.2,0-22.22V327h14.23a27,27,0,0,0,3.38-.11,12.65,12.65,0,0,0,1.63-.3l.8-.21.78-.28a13.78,13.78,0,0,0,5.36-3.59,14.22,14.22,0,0,0,3.17-5.46,14.68,14.68,0,0,0,.56-3.07c.08-1,0-2.07.06-3.11q0-6.21,0-12.08c0-15.64,0-29.35.06-40.69,0-2.83,0-5.51,0-8,0-1.27,0-2.49,0-3.68a25.25,25.25,0,0,0-.12-3.41,14.14,14.14,0,0,0-2-5.7,14.53,14.53,0,0,0-3.37-3.77,14.2,14.2,0,0,0-6.3-2.8,12,12,0,0,0-1.78-.2Z'/%3e%3crect class='cls-2' x='322.78' y='240.95' width='136.51' height='110.84' rx='11.46' transform='translate(782.07 592.74) rotate(180)'/%3e%3cpath class='cls-5' d='M385.55,348.39c-1.4,3.4-28.48,28.84-28.48,28.84V348.39Z'/%3e%3cpath class='cls-12' d='M375.07,325.19c0-3.5,0-6.42,0-6.78,0,0-11.84-1.12-12.69-12.84-.41-5.66-.3-17.39-.08-28a21.88,21.88,0,0,1,20.57-21.38l1.13-.07c12.24,0,19.1,10.37,18.78,22.61l-.43,45.94-19.81,15.9-1.43-.13Z'/%3e%3cpath class='cls-13' d='M375.05,318.41a28.39,28.39,0,0,0,15-5.43s-3.21,8.79-15,8.43Z'/%3e%3cpath class='cls-4' d='M382.22,282.62c.23.24,1.6-.83,3.56-.86s3.41.95,3.62.71-.13-.55-.76-1a5,5,0,0,0-2.91-.86,4.67,4.67,0,0,0-2.82,1C382.31,282.07,382.11,282.51,382.22,282.62Z'/%3e%3cpath class='cls-4' d='M383.67,288a1.6,1.6,0,0,0,1.63,1.51,1.52,1.52,0,0,0,1.54-1.53,1.59,1.59,0,0,0-1.62-1.51A1.53,1.53,0,0,0,383.67,288Z'/%3e%3cpath class='cls-4' d='M377.14,296.2a11.71,11.71,0,0,0-3-.36c-.47,0-.91-.08-1-.39a2.32,2.32,0,0,1,.22-1.38c.37-1.14.75-2.34,1.15-3.59,1.59-5.1,2.71-9.28,2.51-9.35s-1.66,4-3.25,9.13c-.38,1.26-.75,2.45-1.1,3.6a2.72,2.72,0,0,0-.13,1.82,1.16,1.16,0,0,0,.8.63,3.24,3.24,0,0,0,.79.06A12,12,0,0,0,377.14,296.2Z'/%3e%3cpath class='cls-4' d='M383.2,276.33c.18.43,1.76.13,3.64.25s3.42.55,3.64.14c.1-.2-.19-.61-.82-1a5.89,5.89,0,0,0-2.75-.81,5.82,5.82,0,0,0-2.8.51C383.44,275.75,383.12,276.12,383.2,276.33Z'/%3e%3cpath class='cls-4' d='M364.81,277.44c.2.36,1.73,0,3.59-.05s3.39.23,3.59-.14c.09-.18-.22-.5-.86-.79a6.41,6.41,0,0,0-2.73-.49,6.58,6.58,0,0,0-2.74.64C365,276.93,364.72,277.27,364.81,277.44Z'/%3e%3cpath class='cls-12' d='M402.32,287.46c.2-.1,7.92-2.87,8.14,5.16s-7.88,6.61-7.9,6.38S402.32,287.46,402.32,287.46Z'/%3e%3cpath class='cls-13' d='M404.93,295.88s.14.1.38.2a1.37,1.37,0,0,0,1,0c.84-.33,1.52-1.7,1.52-3.15a4.55,4.55,0,0,0-.45-2,1.63,1.63,0,0,0-1.08-1.05.73.73,0,0,0-.82.41c-.1.23,0,.39-.08.4s-.18-.13-.12-.46a.82.82,0,0,1,.3-.51,1,1,0,0,1,.77-.23,2,2,0,0,1,1.49,1.2,4.75,4.75,0,0,1,.55,2.23c0,1.62-.79,3.16-1.94,3.53a1.53,1.53,0,0,1-1.29-.18C405,296.08,404.9,295.9,404.93,295.88Z'/%3e%3cpath class='cls-4' d='M379.63,303c-.09-.2,1.49-.65,2.61-2.11a8.6,8.6,0,0,0,1.14-2.08c.24-.58.43-.95.51-.92s.06.42-.08,1a6,6,0,0,1-1.06,2.34,4.84,4.84,0,0,1-2.07,1.54C380.06,303.08,379.65,303.09,379.63,303Z'/%3e%3cpath class='cls-4' d='M413.17,274.6c-1.64-2.85-2-6.24-2.86-9.41s-2.59-6.46-5.67-7.61l-.07,0c-2.77-1.15-6.2-1.21-8.51.69-.51-4.18-4.13-7.53-8.18-8.65s-10.6-.57-14.53.95c-3,1.18-6,3.63-9.58,7.24a38.17,38.17,0,0,0-4.16,4.91l-3.68,10.89,3,5.78a10.58,10.58,0,0,0,.58,1.17v0l2.58,12.12c.21-3.29.12-14.76.34-18.05a18.37,18.37,0,0,0,13.17-5.88c1.83-2,3.28-4.45,5.7-5.61,3.12-1.5,6.81-.33,10.07.85l-.14-.13a14.84,14.84,0,0,1,4.49,3.33,45.64,45.64,0,0,0,1.73,19.36c.29.94,1.11,2.88,2,3.24,1.79.72,2.3-1.1,3.4-2.07a4.81,4.81,0,0,1,3.29-.76,72.1,72.1,0,0,0,2.31-8.3,7.39,7.39,0,0,0,3.37.27c-.34-.84-.67-1.67-1-2.5a3.79,3.79,0,0,0,1.44.67,1.28,1.28,0,0,0,1.37-.58C413.91,275.91,413.51,275.2,413.17,274.6Z'/%3e%3cpath class='cls-5' d='M392.36,259.6a9.07,9.07,0,0,1,1.16,1.08,8.44,8.44,0,0,1,1.75,3.91,15.38,15.38,0,0,1,.26,3c0,1.08-.11,2.24-.21,3.45a30,30,0,0,0-.14,3.84,12.91,12.91,0,0,0,.24,2,4.17,4.17,0,0,0,.8,2,1.75,1.75,0,0,0,1.65.58,2.57,2.57,0,0,0,1.49-.82,6,6,0,0,0,1.17-3l-.25,0a9.7,9.7,0,0,0,1.4,2.48,3.52,3.52,0,0,0,2.26,1.27,2.27,2.27,0,0,0,1.21-.2,2,2,0,0,0,.83-.8,2,2,0,0,0,.26-1,1.54,1.54,0,0,0-.36-.92l-.13.11a7.55,7.55,0,0,0,2.49,1.92,6.11,6.11,0,0,0,.78.31l.28.08-.27-.12a8.19,8.19,0,0,1-.75-.35,7.72,7.72,0,0,1-2.4-1.94l-.13.1a1.52,1.52,0,0,1,.06,1.75,1.88,1.88,0,0,1-.75.7,2,2,0,0,1-1.1.16,3.28,3.28,0,0,1-2.1-1.2,9.7,9.7,0,0,1-1.34-2.42l-.16-.38-.09.41a5.86,5.86,0,0,1-1.11,2.83,2.34,2.34,0,0,1-1.34.73,1.5,1.5,0,0,1-1.4-.49,4,4,0,0,1-.73-1.84,12.42,12.42,0,0,1-.24-2,31.66,31.66,0,0,1,.12-3.81c.09-1.21.19-2.37.18-3.46a14.81,14.81,0,0,0-.29-3,8.4,8.4,0,0,0-1.86-3.95A4.68,4.68,0,0,0,392.36,259.6Z'/%3e%3cpath class='cls-5' d='M356,270.52l.09.08.29.22a3.36,3.36,0,0,0,.5.32c.2.12.43.26.7.39a10.41,10.41,0,0,0,5,1,13.17,13.17,0,0,0,7.1-2.52,22.93,22.93,0,0,0,6.16-6.91c.87-1.41,1.59-2.86,2.37-4.19a15.71,15.71,0,0,1,2.66-3.53,8.07,8.07,0,0,1,3.4-2,5.48,5.48,0,0,1,1.78-.18,6,6,0,0,1,1.63.33,6.79,6.79,0,0,1,3.72,3.23,7.86,7.86,0,0,1,.58,1.77s0-.05,0-.13,0-.21,0-.36a5.79,5.79,0,0,0-.42-1.32,6.77,6.77,0,0,0-1.29-1.8,6.86,6.86,0,0,0-2.47-1.57,5.91,5.91,0,0,0-3.53-.19,8.14,8.14,0,0,0-3.51,2,15.37,15.37,0,0,0-2.72,3.58c-.79,1.34-1.51,2.78-2.37,4.17a23,23,0,0,1-6.07,6.86,13.22,13.22,0,0,1-7,2.53,10.5,10.5,0,0,1-4.94-.87A15.23,15.23,0,0,1,356,270.52Z'/%3e%3cpath class='cls-4' d='M364.34,283.13c.23.24,1.59-.83,3.55-.86s3.42,1,3.63.7-.14-.54-.77-1a4.9,4.9,0,0,0-2.9-.87,4.75,4.75,0,0,0-2.83,1C364.42,282.58,364.22,283,364.34,283.13Z'/%3e%3cpath class='cls-4' d='M367.34,288.22a1.58,1.58,0,0,0,1.62,1.5,1.52,1.52,0,0,0,1.55-1.52,1.6,1.6,0,0,0-1.63-1.51A1.51,1.51,0,0,0,367.34,288.22Z'/%3e%3cpath class='cls-4' d='M360.61,261.42c-1,1.31-2.53,2.51-4.18,2.33a12.12,12.12,0,0,1-1.74-.51c-.57.35-.44,2.31-.05,2.85a11.3,11.3,0,0,0,1.23,1.28c-1.92,1-3.67.52-5.73-.23a10.06,10.06,0,0,0,6,8.07,3.51,3.51,0,0,0,3.23.06,4,4,0,0,0,1.42-2.52A43.92,43.92,0,0,0,362.22,262Z'/%3e%3cpath class='cls-5' d='M348.26,338.41l.22-.27c9.38-9.93,26.65-13.26,26.65-13.26s1.05,6.5,10.73,7.23,16.8-9.14,16.8-9.14l12.91,1.81s6.5.77,10.55,3.15c9.12,5.36,14,23.86,14,23.86l-99.6.4Z'/%3e%3cpath class='cls-4' d='M339.15,241l-.69.06-.86.05c-.34,0-.73.11-1.18.18a16.13,16.13,0,0,0-7.22,3.2,16.7,16.7,0,0,0-3.87,4.31,16.51,16.51,0,0,0-2.3,6.53,31.37,31.37,0,0,0-.13,3.92c0,1.36,0,2.76,0,4.21,0,2.89,0,6,0,9.21,0,13,0,28.68.06,46.59q0,6.72,0,13.84c0,1.18,0,2.39.06,3.57a17,17,0,0,0,.65,3.51,16.33,16.33,0,0,0,3.63,6.27,15.75,15.75,0,0,0,6.16,4.12l.89.32.92.24a15,15,0,0,0,1.87.35,31,31,0,0,0,3.87.13h16.27v.24c0,8,0,16.63,0,25.44l-.42-.18c4.21-4,8.51-8.07,12.84-12.3s8.74-8.54,12.95-13.13l.08-.09H441.1c1.07,0,2.13,0,3.17-.07a15.91,15.91,0,0,0,6-1.71,16.14,16.14,0,0,0,7.91-9.12,17.55,17.55,0,0,0,.88-6v-6.16c0-16.36,0-32.14,0-47.17q0-11.26,0-22a25.86,25.86,0,0,0-.32-5.23,17.13,17.13,0,0,0-1.82-4.79,15.34,15.34,0,0,0-3.17-3.93,15.52,15.52,0,0,0-4.14-2.74,16,16,0,0,0-4.7-1.33,46.13,46.13,0,0,0-4.85-.14H412.73l-53.84-.09L344.26,241l-3.81,0-1.3,0s.44,0,1.3,0l3.81,0,14.63-.05,53.84-.08,17.84,0h9.49a44.9,44.9,0,0,1,4.9.14,16.21,16.21,0,0,1,4.83,1.36,16.74,16.74,0,0,1,7.51,6.83,17.52,17.52,0,0,1,1.88,4.93,27.09,27.09,0,0,1,.34,5.32q0,10.68,0,22c0,15,0,30.81,0,47.17q0,3.06,0,6.16a18.19,18.19,0,0,1-.91,6.19A16.66,16.66,0,0,1,444.31,352c-1.08.07-2.15.08-3.21.07H382.88l.19-.08c-4.23,4.61-8.65,8.92-13,13.15s-8.63,8.33-12.85,12.3l-.41.4v-.58c0-8.81,0-17.4,0-25.44l.23.23H341a34.32,34.32,0,0,1-3.92-.14,15.62,15.62,0,0,1-1.93-.36l-.94-.25-.92-.33A16.34,16.34,0,0,1,327,346.7a16.86,16.86,0,0,1-3.72-6.44,18,18,0,0,1-.66-3.61c-.09-1.23-.05-2.41-.06-3.6q0-7.12,0-13.84c0-17.91,0-33.61.06-46.59,0-3.24,0-6.32,0-9.21V259.2a29.9,29.9,0,0,1,.16-3.94,16.35,16.35,0,0,1,2.35-6.6,16.72,16.72,0,0,1,3.94-4.34,16.1,16.1,0,0,1,7.3-3.16c.45-.06.84-.13,1.18-.16l.87,0Z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 85 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ResetPasswordForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _resetPassword_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var initialFormState = {
  password: {
    value: '',
    error: false,
    message: ''
  },
  confirmPassword: {
    value: '',
    error: false,
    message: ''
  }
};
function ResetPasswordForm(_ref) {
  var headingText = _ref.headingText,
    handleSubmitCallback = _ref.handleSubmitCallback,
    errorText = _ref.errorText;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.value === '' || state.error === true;
    });
    return !!hasErrors.length || formState.password.value !== formState.confirmPassword.value;
  }, [formState]);
  var heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return headingText || 'Reset password';
  });
  var handleValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      id = _ref2$target.id,
      value = _ref2$target.value;
    switch (id) {
      case 'password':
        {
          var isValid = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getIsPasswordValid)({
            password: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !isValid,
              message: isValid ? '' : _utils__WEBPACK_IMPORTED_MODULE_1__.errorMessages.password
            }));
          });
        }
      case 'confirmPassword':
        {
          return setFormState(function (previousState) {
            var isIdentical = value === previousState.password.value;
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !isIdentical,
              message: isIdentical ? '' : _utils__WEBPACK_IMPORTED_MODULE_1__.errorMessages.confirmPassword
            }));
          });
        }
    }
  }, [formState, setFormState]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      value = _ref3$target.value,
      id = _ref3$target.id;
    setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
        value: value
      })));
    });
  }, [setFormState]);
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    return handleSubmitCallback({
      password: formState.password.value
    });
  }, [formState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "reset-password",
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "reset-password__heading reset-password__formBreak",
    "data-core-qa": "resetPasswordFormTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "resetPasswordFormInputPassword",
    type: "password",
    labelText: "New password",
    id: "password",
    placeholder: "Enter new password",
    onChange: handleInputChange,
    invalid: formState.password.error,
    invalidText: formState.password.message,
    onBlur: handleValidationOnBlur,
    value: formState.password.value,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.PasswordValidation, {
    password: formState.password.value
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "resetPasswordFormInputConfirmPassword",
    type: "password",
    labelText: "Confirm password",
    id: "confirmPassword",
    placeholder: "Confirm password",
    onChange: handleInputChange,
    invalid: formState.confirmPassword.error,
    invalidText: formState.confirmPassword.message,
    onBlur: handleValidationOnBlur,
    value: formState.confirmPassword.value,
    required: true
  })), errorText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "reset-password__warning reset-password__formBreak",
    "data-core-qa": "resetPasswordFormErrorText"
  }, errorText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "reset-password__button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    type: "submit",
    kind: "solid",
    disabled: isDisabled,
    "data-core-qa": "resetPasswordFormButtonSubmit"
  }, "Reset")));
}
ResetPasswordForm.propTypes = {
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Callback function that is called when the 'Reset' button is pressed or the form is submitted */
  handleSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Displays an error message to the user */
  errorText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};

/***/ }),
/* 86 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Agreements; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _agreements_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87);
var _excluded = ["formsList", "handleSubmitCallback"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function Agreements(_ref) {
  var formsList = _ref.formsList,
    handleSubmitCallback = _ref.handleSubmitCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(formsList.map(function (agreement) {
      return agreement;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    agreements = _useState2[0],
    setAgreements = _useState2[1];
  var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    handleSubmitCallback(agreements);
  }, [agreements]);
  var updateAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (agreementId, updates) {
    setAgreements(function (currentAgreements) {
      return currentAgreements.map(function (agreement) {
        if (agreement.agreementId === agreementId) {
          agreement = _objectSpread(_objectSpread({}, agreement), updates);
        }
        return agreement;
      });
    });
  }, [setAgreements]);
  var captureSignatureDataForAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, signatureData) {
    return updateAgreement(id, {
      signatureImageData: signatureData
    });
  }, [updateAgreement]);
  var captureCheckboxChangeForAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, isChecked) {
    return updateAgreement(id, {
      checked: isChecked
    });
  }, [setAgreements]);
  var allFormsAreFilledOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return agreements.every(function (agreement) {
      if (!agreement.signatureImageData) {
        return false;
      }
      if (!agreement.checked) {
        return false;
      }
      return true;
    });
  }, [agreements]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", rest, formsList && formsList.map(function (agreement) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      key: agreement.agreementId,
      className: "agreements-wrapper"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.SignatureInput, {
      form: agreement,
      checkboxOnChangeCallback: function checkboxOnChangeCallback(newValue) {
        return captureCheckboxChangeForAgreement(agreement.agreementId, newValue);
      },
      captureSignatureData: function captureSignatureData(signatureData) {
        return captureSignatureDataForAgreement(agreement.agreementId, signatureData);
      },
      checkboxId: "".concat(agreement.agreementId, "Checkbox"),
      checkboxLabelText: agreement.checkboxLabelText,
      signatureCanvasId: "".concat(agreement.agreementId, "SignatureCanvas")
    }));
  }), !allFormsAreFilledOut && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "agreements-wrapper__errorMessage",
    "data-core-qa": "agreementsErrorText"
  }, "You must agree and sign for all items on this form to continue."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "agreementsButtonSubmit",
    className: "agreements-wrapper__button",
    onClick: handleSubmit,
    disabled: !allFormsAreFilledOut
  }, "Accept & Sign"));
}
Agreements.propTypes = {
  /** Array of objects containing form data to be passed into the Signature Input component.*/
  formsList: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    agreementId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    content: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    agreementVersionId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    createdAt: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
  })),
  /** Callback function returning an array of form objects which includes a bit64 string signature value for each form. */
  handleSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};

/***/ }),
/* 87 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 88 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Benefit_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89);
var _excluded = ["benefitImage", "headingText", "bodyText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var Benefit = function Benefit(_ref) {
  var benefitImage = _ref.benefitImage,
    headingText = _ref.headingText,
    bodyText = _ref.bodyText,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "benefit"
  }, rest), benefitImage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "benefit__img",
    src: benefitImage
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "benefit__heading",
    "data-core-qa": "benefitTitleText"
  }, headingText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "benefit__body",
    "data-core-qa": "benefitTitleSubText"
  }, bodyText));
};
Benefit.propTypes = {
  /** Optional image set at the top of the component spanning the whole width. */
  benefitImage: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Optional slightly larger and bolder text meant to be used as grabber text set under the image. */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Optional paragraph text beneath the heading text. */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Benefit);

/***/ }),
/* 89 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 90 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _logIn_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91);
/* harmony import */ var _Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30);
var _excluded = ["brandImage", "brandName", "welcomeText", "subText", "createAccountButtonText", "createAccountCallback", "handleSubmitCallback", "handleRememberMeCallback", "handleForgotPasswordCallback", "invalidPassword", "clearInvalidPasswordCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var initialFormState = {
  email: {
    value: '',
    error: false,
    message: ''
  },
  password: {
    value: '',
    error: false,
    message: ''
  }
};
var errorMessage = 'This is a required field';
var LogIn = function LogIn(_ref) {
  var brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    _ref$welcomeText = _ref.welcomeText,
    welcomeText = _ref$welcomeText === void 0 ? "Welcome Back! You've been missed." : _ref$welcomeText,
    _ref$subText = _ref.subText,
    subText = _ref$subText === void 0 ? "Don't have a ".concat(brandName, " account?") : _ref$subText,
    _ref$createAccountBut = _ref.createAccountButtonText,
    createAccountButtonText = _ref$createAccountBut === void 0 ? 'Create One Here' : _ref$createAccountBut,
    createAccountCallback = _ref.createAccountCallback,
    handleSubmitCallback = _ref.handleSubmitCallback,
    handleRememberMeCallback = _ref.handleRememberMeCallback,
    handleForgotPasswordCallback = _ref.handleForgotPasswordCallback,
    _ref$invalidPassword = _ref.invalidPassword,
    invalidPassword = _ref$invalidPassword === void 0 ? false : _ref$invalidPassword,
    clearInvalidPasswordCallback = _ref.clearInvalidPasswordCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (invalidPassword) {
      setFormState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          password: _objectSpread(_objectSpread({}, prevState.password), {}, {
            error: true,
            message: 'Incorrect Password'
          })
        });
      });
    } else {
      setFormState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          password: _objectSpread(_objectSpread({}, prevState.password), {}, {
            error: false,
            message: ''
          })
        });
      });
    }
  }, [invalidPassword]);
  var isSubmitDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.error === true || state.value === '' || isLoading;
    });
    return !!hasErrors.length;
  }, [formState, isLoading]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      value = _ref2$target.value,
      id = _ref2$target.id;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        value: value
      })));
    });
    clearInvalidPasswordCallback();
  }, [setFormState]);
  var handleValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      id = _ref3$target.id,
      value = _ref3$target.value;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        error: !value.length,
        message: !value.length ? errorMessage : ''
      })));
    });
  }, [formState, setFormState]);
  var clearValidationErrorOnFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref4) {
    var _ref4$target = _ref4.target,
      id = _ref4$target.id,
      value = _ref4$target.value;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        error: false,
        message: ''
      })));
    });
  });
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    setIsLoading(true);
    return handleSubmitCallback({
      email: formState.email.value,
      password: formState.password.value
    }).finally(function () {
      return setIsLoading(false);
    });
  }, [formState]);
  var headingText = welcomeText || "Welcome Back! You've been missed.";
  var headingSubText = subText || "Don't have a ".concat(brandName, " account?");
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", _extends({
    className: "log-in-form",
    onSubmit: handleFormSubmit
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__formBreak"
  }, brandImage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: brandImage,
    className: "log-in-form__logo",
    alt: "brand"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__header-main",
    "data-core-qa": "loginTitleText"
  }, headingText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__header-subtext",
    "data-core-qa": "loginTitleSubText"
  }, headingSubText, ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "loginButtonCreateAccountLink",
    onClick: createAccountCallback,
    type: "button",
    kind: "link",
    className: "log-in-form__create-button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__create-button",
    "data-core-qa": "loginButtonCreateAccountLinkText"
  }, createAccountButtonText)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "loginInputEmail",
    labelText: "Email Address",
    placeholder: "email@address.com",
    id: "email",
    onChange: handleInputChange,
    onBlur: handleValidationOnBlur,
    onFocus: clearValidationErrorOnFocus,
    value: formState.email.value,
    invalid: formState.email.error,
    invalidText: formState.email.message,
    required: true,
    type: "email"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "loginInputPassword",
    type: "password",
    labelText: "Password",
    placeholder: "Password",
    id: "password",
    onChange: handleInputChange,
    onBlur: handleValidationOnBlur,
    onFocus: clearValidationErrorOnFocus,
    value: formState.password.value,
    invalid: formState.password.error,
    invalidText: formState.password.message,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__formBreak log-in-form__additional-options"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__floatRight"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "loginButtonForgotPassword",
    kind: "link",
    type: "button",
    onClick: handleForgotPasswordCallback,
    className: "log-in-form__forgot-button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__forgot-button",
    "data-core-qa": "loginButtonForgotPasswordText"
  }, "Forgot Password?"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "loginCheckboxRememberMe",
    id: "rememberMe",
    labelText: "Remember Me",
    handleOnChangeCallback: handleRememberMeCallback,
    checkboxClassName: "log-in-form__checkbox"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "loginButtonSubmit",
    type: "submit",
    kind: "solid",
    disabled: isSubmitDisabled,
    className: "log-in-form__submit-button"
  }, isLoading ? 'Logging in...' : 'Log In')));
};
LogIn.propTypes = {
  /** 50px width image intended to show the brand logo at the top of the form if desired */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Optional: Specifically used in the default subtext `Don't have a ${brandName} account?` */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** This is a function called in the built in handleChange function in order to clear the invalidPassword error set by the invalidPassword bool*/
  clearInvalidPasswordCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Text Create Account button (kind=link) */
  createAccountButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** This function is called when the user clicks Create Account */
  createAccountCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Function is called inside the handle submit and returns the email and password required to provide to the api call */
  handleSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Function applied directly to the Remember Me checkbox */
  handleRememberMeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** This function is called when the user clicks Forgot Password */
  handleForgotPasswordCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Used to specifically set the error message on the password input for Incorrect Password*/
  invalidPassword: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** Text is displayed prior to but on the same line as the Create Account button */
  subText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Initial heading text */
  welcomeText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (LogIn);

/***/ }),
/* 91 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 92 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _passwordStrengthIndicator_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93);
var _excluded = ["passwordStrengthPercentage", "className", "passwordStrengthLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var PasswordStrengthIndicator = function PasswordStrengthIndicator(_ref) {
  var passwordStrengthPercentage = _ref.passwordStrengthPercentage,
    className = _ref.className,
    _ref$passwordStrength = _ref.passwordStrengthLabel,
    passwordStrengthLabel = _ref$passwordStrength === void 0 ? 'Password strength:' : _ref$passwordStrength,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('Weak'),
    _useState2 = _slicedToArray(_useState, 2),
    passwordStrengthText = _useState2[0],
    setPasswordStrengthText = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var newPasswordStrengthText = 'Weak';
    if (passwordStrengthPercentage > 50 && passwordStrengthPercentage < 100) {
      newPasswordStrengthText = 'Fair';
    }
    if (passwordStrengthPercentage === 100) {
      newPasswordStrengthText = 'Great';
    }
    setPasswordStrengthText(newPasswordStrengthText);
  }, [passwordStrengthPercentage]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "passwordStrengthIndicator ".concat(className)
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "passwordStrengthBar"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "passwordStrengthBar",
    className: "passwordStrengthFill",
    style: {
      width: "".concat(passwordStrengthPercentage, "%")
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "passwordStrengthText",
    "data-core-qa": "passwordStrengthBarText"
  }, passwordStrengthLabel, " ", passwordStrengthText));
};
PasswordStrengthIndicator.propTypes = {
  /** This determines the width of the 'green' area that indicates how strong the password is. It also determines what verbiage is used: 0-49% => Weak, 50-99% => Fair, 100% => Great. */
  passwordStrengthPercentage: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number.isRequired),
  /** Optional className that will be applied to the outermost div */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Text label that shows up underneath the password strength indicator */
  passwordStrengthLabel: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (PasswordStrengthIndicator);

/***/ }),
/* 93 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 94 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_check_solid_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_check_solid_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_check_solid_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _passwordTag_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);





var PasswordTag = function PasswordTag(_ref) {
  var children = _ref.children,
    confirm = _ref.confirm;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "password-validation"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "validated-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "validation-icon",
    src: confirm ? (_assets_icons_nerdCoreKit_circle_check_solid_svg__WEBPACK_IMPORTED_MODULE_1___default()) : (_assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    height: "16",
    width: "16"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    "data-core-qa": "passwordTagText".concat(children.split(' ')[0])
  }, children)));
};
PasswordTag.propTypes = {
  /** Text to be displayed on the tag: certain password criteria that must be met when created a password such as 1 Uppercase letter*/
  children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Boolean property to indicate if the criteria has been met, changing the icon indicator accordingly. */
  confirm: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
};
/* harmony default export */ __webpack_exports__["default"] = (PasswordTag);

/***/ }),
/* 95 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e %3cpath id='circle-check-solid' d='M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8ZM11.619,6.619a.875.875,0,0,0-1.237-1.238L7,8.762,5.619,7.381A.875.875,0,0,0,4.381,8.619l2,2a.877.877,0,0,0,1.238,0Z' fill='%23428e21'/%3e %3c/svg%3e"

/***/ }),
/* 96 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e %3cpath id='Fill' d='M8,16A7.951,7.951,0,0,1,0,8,7.95,7.95,0,0,1,8,0a7.951,7.951,0,0,1,8,8,7.951,7.951,0,0,1-8,8ZM4.914,4h0L4,4.914,11.086,12,12,11.086,4.914,4Z' fill='%23c13838'/%3e %3c/svg%3e"

/***/ }),
/* 97 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 98 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75);
/* harmony import */ var _passwordValidation_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99);
var _excluded = ["password", "showPasswordStrengthIndicator", "passwordStrengthLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var PasswordValidation = function PasswordValidation(_ref) {
  var password = _ref.password,
    _ref$showPasswordStre = _ref.showPasswordStrengthIndicator,
    showPasswordStrengthIndicator = _ref$showPasswordStre === void 0 ? false : _ref$showPasswordStre,
    _ref$passwordStrength = _ref.passwordStrengthLabel,
    passwordStrengthLabel = _ref$passwordStrength === void 0 ? 'Password Strength:' : _ref$passwordStrength,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasNumber = _useState2[0],
    setHasNumber = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasSymbol = _useState4[0],
    setHasSymbol = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasLength = _useState6[0],
    setHasLength = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasNoSpace = _useState8[0],
    setHasNoSpace = _useState8[1];
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    hasLowercase = _useState10[0],
    setHasLowercase = _useState10[1];
  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    hasUppercase = _useState12[0],
    setHasuppercase = _useState12[1];
  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    passwordStrength = _useState14[0],
    setPasswordStrength = _useState14[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var strengthChecks = {
      hasLowerCase: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasLowercase)({
        password: password
      }),
      hasUpperCase: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasUppercase)({
        password: password
      }),
      hasNumber: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasNumber)({
        password: password
      }),
      hasSymbol: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasSymbol)({
        password: password
      }),
      hasNoSpaces: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasNoSpaces)({
        password: password
      }),
      hasLength: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasLength)({
        password: password,
        length: 8
      })
    };
    setHasLowercase(strengthChecks.hasLowerCase);
    setHasuppercase(strengthChecks.hasUpperCase);
    setHasNumber(strengthChecks.hasNumber);
    setHasSymbol(strengthChecks.hasSymbol);
    setHasNoSpace(strengthChecks.hasNoSpaces);
    setHasLength(strengthChecks.hasLength);
    updatePasswordStrength(strengthChecks);
  }, [password]);
  function updatePasswordStrength(strengthChecks) {
    var strengthChecksArr = Object.values(strengthChecks);
    var numberOfStrengthChecks = strengthChecksArr.length;
    var newPasswordStrength = 0;
    strengthChecksArr.forEach(function (strengthCheck) {
      if (strengthCheck) {
        newPasswordStrength += 100 / numberOfStrengthChecks;
      }
    });
    setPasswordStrength(Math.round(newPasswordStrength));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "validation-container"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasNoSpace
  }, "No Spaces"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasLength
  }, "Minimum 8 characters"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasUppercase
  }, "1 UPPERCASE letter"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasLowercase
  }, "1 lowercase letter"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasNumber
  }, "1 number"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordTag, {
    confirm: hasSymbol
  }, "1 symbol !@#$%^&*"), showPasswordStrengthIndicator && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordStrengthIndicator, {
    passwordStrengthPercentage: passwordStrength,
    passwordStrengthLabel: passwordStrengthLabel
  }));
};
PasswordValidation.propTypes = {
  password: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  showPasswordStrengthIndicator: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  passwordStrengthLabel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (PasswordValidation);

/***/ }),
/* 99 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 100 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_icons_nerdCoreKit_time_nerdgreen_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101);
/* harmony import */ var _assets_icons_nerdCoreKit_time_nerdgreen_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_time_nerdgreen_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sessionExpired_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(102);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var _Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30);
var _excluded = ["headerText", "image", "handleCancelCallback", "handleLoginCallback", "errorMessage", "handleForgotPasswordCallback", "handleRememberMeCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var defaultHeaderText = 'Your session has expired due to inactivity.';
var defaultImageURL = (_assets_icons_nerdCoreKit_time_nerdgreen_svg__WEBPACK_IMPORTED_MODULE_1___default());
var initialFormState = {
  email: {
    value: '',
    error: false,
    message: ''
  },
  password: {
    value: '',
    error: false,
    message: ''
  }
};
var errorMessage = 'This is a required field';
var SessionExpired = function SessionExpired(_ref) {
  var headerText = _ref.headerText,
    image = _ref.image,
    handleCancelCallback = _ref.handleCancelCallback,
    handleLoginCallback = _ref.handleLoginCallback,
    errorMessage = _ref.errorMessage,
    handleForgotPasswordCallback = _ref.handleForgotPasswordCallback,
    handleRememberMeCallback = _ref.handleRememberMeCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  headerText = headerText || defaultHeaderText;
  image = image || defaultImageURL;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var isSubmitDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.error === true || state.value === '' || isLoading;
    });
    return !!hasErrors.length;
  }, [formState, isLoading]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      value = _ref2$target.value,
      id = _ref2$target.id;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        value: value
      })));
    });
  }, [setFormState]);
  var handleValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      id = _ref3$target.id,
      value = _ref3$target.value;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        error: !value.length,
        message: !value.length ? errorMessage : ''
      })));
    });
  }, [formState, setFormState]);
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    setIsLoading(true);
    return handleLoginCallback({
      email: formState.email.value,
      password: formState.password.value
    }).finally(function () {
      return setIsLoading(false);
    });
  }, [formState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "sessionExpiredContainer"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("table", {
    className: "topTable"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tbody", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("tr", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
    className: "leftCell"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: image,
    className: "topImage"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("th", {
    className: "rightCell"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "timeoutX",
    onClick: handleCancelCallback
  }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "textContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "timeoutText",
    "data-core-qa": "sessionExpiredTitleText"
  }, headerText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "log-in-form-basic",
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form-basic__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.Input, {
    "data-core-qa": "sessionExpiredInputEmail",
    labelText: "Email Address",
    placeholder: "email@address.com",
    id: "email",
    onChange: handleInputChange,
    onBlur: handleValidationOnBlur,
    value: formState.email.value,
    invalid: formState.email.error,
    invalidText: formState.email.message,
    required: true,
    type: "email"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form-basic__formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.Input, {
    "data-core-qa": "sessionExpiredInputPassword",
    type: "password",
    labelText: "Password",
    placeholder: "Password",
    id: "password",
    onChange: handleInputChange,
    onBlur: handleValidationOnBlur,
    value: formState.password.value,
    invalid: formState.password.error,
    invalidText: formState.password.message,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form__formBreak log-in-form__additional-options"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "log-in-form__floatRight"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.Button, {
    "data-core-qa": "sessionExpiredButtonForgotLink",
    kind: "link",
    type: "button",
    onClick: handleForgotPasswordCallback,
    className: "log-in-form__forgot-button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "sessionExpiredButtonForgotText",
    className: "log-in-form__forgot-button"
  }, "Forgot Password?"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_5__["default"], {
    "data-core-qa": "sessionExpiredCheckboxRememberMe",
    id: "rememberMe",
    labelText: "Remember Me",
    handleOnChangeCallback: handleRememberMeCallback,
    checkboxClassName: "log-in-form__checkbox"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "log-in-form-basic__button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.Button, {
    "data-core-qa": "sessionExpiredButtonSubmit",
    type: "submit",
    kind: "solid",
    disabled: isSubmitDisabled,
    className: "log-in-form-basic__submit-button"
  }, isLoading ? 'Logging in...' : 'Log In')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "errorMessage",
    "data-core-qa": "sessionExpiredErrorText"
  }, errorMessage)));
};
SessionExpired.propTypes = {
  /** Clock Image at the top of the module. */
  image: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
  /** The header text. */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** The error message that pops up if the password is wrong or an error occurs. */
  errorMessage: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** What happens when they press the x at the top right or outside the modal. */
  handleCancelCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** What happens when they press the login button. */
  handleLoginCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** What happens when they press the Forgot Password button. */
  handleForgotPasswordCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** What happens when they check the Remember Me box.*/
  handleRememberMeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
/* harmony default export */ __webpack_exports__["default"] = (SessionExpired);

/***/ }),
/* 101 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.g%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg id='a'/%3e%3cg id='b'%3e%3cg id='c'%3e%3cg id='d'%3e%3cg id='e'%3e%3cg%3e%3cpath fill='%23326260' d='M16,30c-7.72,0-14-6.28-14-14S8.28,2,16,2s14,6.28,14,14-6.28,14-14,14Zm0-26c-6.62,0-12,5.38-12,12s5.38,12,12,12,12-5.38,12-12-5.38-12-12-12Z'/%3e%3cpolygon fill='%23326260' points='20.59 22 15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22'/%3e%3crect id='f' class='g' width='32' height='32'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 102 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 103 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Signup; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18);
/* harmony import */ var _signup_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(104);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var initialFormState = {
  fullName: {
    value: '',
    error: false,
    message: ''
  },
  firstName: {
    value: '',
    error: false,
    message: ''
  },
  lastName: {
    value: '',
    error: false,
    message: ''
  },
  email: {
    value: '',
    error: false,
    message: ''
  },
  password: {
    value: '',
    error: false,
    message: ''
  },
  confirmPassword: {
    value: '',
    error: false,
    message: ''
  },
  adult: {
    value: false,
    error: false,
    message: ''
  },
  optInNewsletter: {
    value: false,
    error: false,
    message: ''
  }
};
function Signup(_ref) {
  var callToActionText = _ref.callToActionText,
    handleSubmitCallback = _ref.handleSubmitCallback,
    brandName = _ref.brandName,
    handleRedirectToLoginCallback = _ref.handleRedirectToLoginCallback,
    _ref$showOnlyFullName = _ref.showOnlyFullName,
    showOnlyFullName = _ref$showOnlyFullName === void 0 ? true : _ref$showOnlyFullName,
    userHasAccountText = _ref.userHasAccountText,
    userHasAccountLinkText = _ref.userHasAccountLinkText;
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_3__.useTheme)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.error === true;
    });
    var hasNameError = showOnlyFullName ? formState.fullName.value === '' : formState.firstName.value === '' || formState.lastName.value === '';
    return !!hasErrors.length || hasNameError || formState.adult.value === false || isLoading;
  }, [formState, isLoading]);
  var handleValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      id = _ref2$target.id,
      value = _ref2$target.value;
    switch (id) {
      case 'fullName':
        {
          var hasValidName = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasValidFullName)({
            fullName: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !hasValidName,
              message: hasValidName ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.name
            }));
          });
        }
      case 'firstName':
        {
          var _hasValidName = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasValidName)({
            name: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !_hasValidName,
              message: _hasValidName ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.name
            }));
          });
        }
      case 'lastName':
        {
          var _hasValidName2 = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasValidName)({
            name: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !_hasValidName2,
              message: _hasValidName2 ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.name
            }));
          });
        }
      case 'email':
        {
          var hasValidEmail = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getHasValidEmail)({
            email: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !hasValidEmail,
              message: hasValidEmail ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.email
            }));
          });
        }
      case 'password':
        {
          var isValid = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getIsPasswordValid)({
            password: value
          });
          return setFormState(function (previousState) {
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !isValid,
              message: isValid ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.password
            }));
          });
        }
      case 'confirmPassword':
        {
          return setFormState(function (previousState) {
            var isIdentical = value === previousState.password.value;
            return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, {
              value: value,
              error: !isIdentical,
              message: isIdentical ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.confirmPassword
            }));
          });
        }
    }
  }, [formState, setFormState]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      value = _ref3$target.value,
      id = _ref3$target.id;
    setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
        value: value
      })));
    });
  }, [setFormState]);
  var handleCheckboxChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref4) {
    var _ref4$target = _ref4.target,
      id = _ref4$target.id,
      checked = _ref4$target.checked;
    if (id === 'adult') {
      setFormState(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
          value: checked,
          error: !checked,
          message: checked ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.checkbox
        })));
      });
    } else {
      setFormState(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
          value: checked
        })));
      });
    }
  }, [setFormState]);
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var confirmPassword, password, fullName, firstName, lastName, email, optInNewsletter, isPasswordValid, isPasswordMatch;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              confirmPassword = formState.confirmPassword, password = formState.password, fullName = formState.fullName, firstName = formState.firstName, lastName = formState.lastName, email = formState.email, optInNewsletter = formState.optInNewsletter;
              setIsLoading(true);
              isPasswordValid = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.getIsPasswordValid)({
                password: password.value
              });
              isPasswordMatch = confirmPassword.value === password.value;
              _context.prev = 5;
              if (isPasswordValid) {
                _context.next = 10;
                break;
              }
              setFormState(function (previousState) {
                return _objectSpread(_objectSpread({}, previousState), {}, {
                  password: _objectSpread(_objectSpread({}, previousState.password), {}, {
                    error: true,
                    message: _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.password
                  })
                });
              });
              _context.next = 16;
              break;
            case 10:
              if (isPasswordMatch) {
                _context.next = 14;
                break;
              }
              setFormState(function (previousState) {
                return _objectSpread(_objectSpread({}, previousState), {}, {
                  confirmPassword: _objectSpread(_objectSpread({}, previousState.confirmPassword), {}, {
                    error: true,
                    message: _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.confirmPassword
                  })
                });
              });
              _context.next = 16;
              break;
            case 14:
              _context.next = 16;
              return handleSubmitCallback({
                fullName: fullName.value,
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                password: password.value,
                newsletter: optInNewsletter.value
              });
            case 16:
              _context.prev = 16;
              setIsLoading(false);
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5,, 16, 19]]);
    }));
    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [formState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "signup-form",
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "heading",
    "data-core-qa": "signupHeadingTitle"
  }, "Create Your Free ", brandName, " Account"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "cta-text",
    "data-core-qa": "signupHeadingSubText"
  }, callToActionText + ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "cta-text-login-link",
    "data-core-qa": "signupTextLoginText"
  }, userHasAccountText || 'Already have an account?', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "signupTextLoginLink",
    className: "link",
    onClick: handleRedirectToLoginCallback,
    style: {
      color: theme.primaryColor
    }
  }, ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("u", null, userHasAccountLinkText || 'Login here'))))), showOnlyFullName ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputFullName",
    labelText: "Full Name",
    placeholder: "Ex. John Smith",
    id: "fullName",
    onChange: handleInputChange,
    invalid: formState.fullName.error,
    invalidText: formState.fullName.message,
    onBlur: handleValidationOnBlur,
    value: formState.fullName.value
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "nameFields"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputFirstName",
    className: "inputName",
    labelText: "First Name",
    placeholder: "Ex. John ",
    id: "firstName",
    onChange: handleInputChange,
    invalid: formState.firstName.error,
    invalidText: formState.firstName.message,
    onBlur: handleValidationOnBlur,
    value: formState.firstName.value
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputLastName",
    labelText: "Last Name",
    placeholder: "Ex. Smith ",
    id: "lastName",
    onChange: handleInputChange,
    invalid: formState.lastName.error,
    invalidText: formState.lastName.message,
    onBlur: handleValidationOnBlur,
    value: formState.lastName.value
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputEmail",
    labelText: "Email Address",
    placeholder: "email@address.com",
    id: "email",
    onChange: handleInputChange,
    invalid: formState.email.error,
    invalidText: formState.email.message,
    onBlur: handleValidationOnBlur,
    value: formState.email.value,
    type: "email",
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputPassword",
    type: "password",
    labelText: "Create A Password",
    id: "password",
    placeholder: "Password",
    onChange: handleInputChange,
    invalid: formState.password.error,
    invalidText: formState.password.message,
    onBlur: handleValidationOnBlur,
    value: formState.password.value,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "passwordVerify"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.PasswordValidation, {
    password: formState.password.value
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "signupInputConfirmPassword",
    type: "password",
    labelText: "Confirm Password",
    id: "confirmPassword",
    placeholder: "Password Confirmation",
    onChange: handleInputChange,
    invalid: formState.confirmPassword.error,
    invalidText: formState.confirmPassword.message,
    onBlur: handleValidationOnBlur,
    value: formState.confirmPassword.value,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Checkbox, {
    "data-core-qa": "signupCheckboxAdult",
    id: "adult",
    labelText: "I am at least 18 years old.",
    handleOnChangeCallback: handleCheckboxChange,
    required: true,
    style: {
      marginBottom: '22px'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Checkbox, {
    "data-core-qa": "signupCheckboxSubscribe",
    id: "optInNewsletter",
    labelText: "Subscribe to our newsletter.",
    handleOnChangeCallback: handleCheckboxChange,
    required: false,
    style: {
      marginBottom: '30px'
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "signupButtonSubmit",
    className: "createAccount",
    type: "submit",
    disabled: isDisabled
  }, isLoading ? 'Creating....' : 'Get Started')));
}
Signup.propTypes = {
  /** The text displayed beneath the heading */
  callToActionText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Callback function that is called when the Submit button is pressed or the form is submitted */
  handleSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
  /** This is used in the heading */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Callback function that is called when the `Login here` link is clicked */
  handleRedirectToLoginCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
  /** If true, signup form shows full name field, if false, first and last name fields appear instead, default true*/
  showOnlyFullName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
  /** Text prior to login page link ex: Already have an account? */
  userHasAccountText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Link to login page text ex: Login here */
  userHasAccountLinkText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};

/***/ }),
/* 104 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 105 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _verifyEmail_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106);
var _excluded = ["headingText", "bodyText", "userEmail", "image", "handleDidNotReceiveEmailCallback", "buttonText", "sentMessageText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var VerifyEmail = function VerifyEmail(_ref) {
  var headingText = _ref.headingText,
    bodyText = _ref.bodyText,
    userEmail = _ref.userEmail,
    image = _ref.image,
    handleDidNotReceiveEmailCallback = _ref.handleDidNotReceiveEmailCallback,
    buttonText = _ref.buttonText,
    sentMessageText = _ref.sentMessageText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleButtonClick = function handleButtonClick() {
    handleDidNotReceiveEmailCallback();
    setSent(true);
  };
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    sent = _useState2[0],
    setSent = _useState2[1];
  var heading = headingText || "We need to verify your email address.";
  var btnText = buttonText || 'Send Again';
  var sentText = sentMessageText || "We have sent another email. Please check your spam folder if you don't see it in your inbox.";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "verify-email"
  }, rest), image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "verify-email__brand-image-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "verify-email__image",
    src: image
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "verify-email__text-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "verify-email__heading",
    "data-core-qa": "verifyEmailTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "verify-email__body",
    "data-core-qa": "verifyEmailTitleSubText"
  }, bodyText ? bodyText : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, "Thanks for creating an account. We sent a confirmation link to", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "verify-email__body--bold"
  }, userEmail), ". Check your email to continue!"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    type: "solid",
    "data-core-qa": "verifyEmailButtonSendAgain",
    className: "verify-email__button",
    onClick: handleButtonClick
  }, btnText), sent && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "verify-email__send-again-text",
    "data-core-qa": "verifyEmailButtonSendAgainText"
  }, sentText));
};
VerifyEmail.propTypes = {
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  userEmail: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  image: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  handleDidNotReceiveEmailCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  sentMessageText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (VerifyEmail);

/***/ }),
/* 106 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 107 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Welcome_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);



var Welcome = function Welcome(_ref) {
  var introText = _ref.introText,
    handleGetStartedCallback = _ref.handleGetStartedCallback,
    buttonText = _ref.buttonText;
  var btnText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return buttonText || 'Get Started';
  }, [buttonText]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "welcome"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "welcome__heading",
    "data-core-qa": "welcomeTitleText"
  }, "Welcome!"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "welcome__body",
    "data-core-qa": "welcomeTitleSubText"
  }, introText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "welcomeButtonSubmit",
    className: "welcome__button",
    onClick: handleGetStartedCallback
  }, btnText));
};
Welcome.propTypes = {
  /** Subtext displayed beneath the heading */
  introText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** Callback function that is called when the button is clicked */
  handleGetStartedCallback: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  /** Text displayed in the button */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Welcome);

/***/ }),
/* 108 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 109 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DownloadSoftware; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _downloadSoftware_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(110);
/* harmony import */ var _assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(111);
/* harmony import */ var _assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_icons_logos_window_logo_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(112);
/* harmony import */ var _assets_icons_logos_linux_logo_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(113);
/* harmony import */ var _assets_icons_logos_apple_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(114);
var _excluded = ["headingText", "stepOneData", "downloadHelpDocumentUrl", "handleFinishSetupCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








function DownloadSoftware(_ref) {
  var _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? 'Download & Install Software' : _ref$headingText,
    stepOneData = _ref.stepOneData,
    downloadHelpDocumentUrl = _ref.downloadHelpDocumentUrl,
    handleFinishSetupCallback = _ref.handleFinishSetupCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var heading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return headingText || 'Download & Install Software';
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "download-software-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "download-software-wrapper__heading",
    "data-core-qa": "downloadSoftwareTitleText"
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "download-software-wrapper__section-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "download-software-wrapper__download-icon-background"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: stepOneData.systemOneIcon || _assets_icons_logos_apple_logo_png__WEBPACK_IMPORTED_MODULE_6__["default"],
    className: "download-software-wrapper__download-system-icon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "downloadSoftwareLink1",
    href: stepOneData.downloadSystemOneLink,
    download: true,
    className: "download-software-wrapper__download-text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "download-software-wrapper__download-text-icon"
  }), stepOneData.downloadSystemOneText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "download-software-wrapper__download-icon-background"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: stepOneData.systemTwoIcon || _assets_icons_logos_window_logo_png__WEBPACK_IMPORTED_MODULE_4__["default"],
    className: "download-software-wrapper__download-system-icon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "downloadSoftwareLink2",
    href: stepOneData.downloadSystemTwoLink,
    download: true,
    className: "download-software-wrapper__download-text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "download-software-wrapper__download-text-icon"
  }), stepOneData.downloadSystemTwoText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "download-software-wrapper__download-icon-background"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: stepOneData.systemThreeIcon || _assets_icons_logos_linux_logo_png__WEBPACK_IMPORTED_MODULE_5__["default"],
    className: "download-software-wrapper__download-system-icon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "downloadSoftwareLink3",
    href: stepOneData.downloadSystemThreeLink,
    download: true,
    className: "download-software-wrapper__download-text"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "download-software-wrapper__download-text-icon"
  }), stepOneData.downloadSystemThreeText))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "download-software-wrapper__help-guide-text",
    "data-core-qa": "downloadSoftwareBodyText"
  }, "Download our", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    "data-core-qa": "downloadSoftwareLinkHelpGuide",
    className: "download-software-wrapper__help-guide-link",
    download: true,
    target: "_blank",
    href: downloadHelpDocumentUrl,
    rel: "noreferrer"
  }, "help guide"), ' ', "for step-by-step instructions on how to setup your node after downloading. The help guide also contains instructions on how to set it up using a Virtual Private Server."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    "data-core-qa": "downloadSoftwareButtonConfirm",
    onClick: handleFinishSetupCallback,
    type: "button",
    kind: "solid",
    className: "download-software-wrapper__finish-button"
  }, "Finish")));
}
DownloadSoftware.propTypes = {
  /** Component heading */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
  /** Each of the 3 download options are shown with an image of the system logo, the download icon, and text:
   * <br/>`downloadSystem__text`: clickable text under each image
   * <br/>`downloadSystem__link`: href for the `<a>` associated with each system text link
   * <br />`system__Icon`: logo src for the `<img>` for each system, defaults to the order Mac, Windows, Linux
   */
  stepOneData: prop_types__WEBPACK_IMPORTED_MODULE_7___default().shape({
    downloadSystemOneText: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    downloadSystemTwoText: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    downloadSystemThreeText: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    downloadSystemOneLink: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    downloadSystemTwoLink: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    downloadSystemThreeLink: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    systemOneIcon: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    systemTwoIcon: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    systemThreeIcon: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node)
  }),
  /** href for <a> on help guide in the subtext */
  downloadHelpDocumentUrl: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
  /** called on button onClick */
  handleFinishSetupCallback: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired)
};

/***/ }),
/* 110 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 111 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3e%3c!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath d='M224 352c4.094 0 8.188-1.562 11.31-4.688l144-144c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0L240 297.4V16C240 7.156 232.8 0 224 0S208 7.156 208 16v281.4L91.31 180.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l144 144C215.8 350.4 219.9 352 224 352zM448 432v-96c0-8.844-7.156-16-16-16S416 327.2 416 336v96c0 26.47-21.53 48-48 48h-288C53.53 480 32 458.5 32 432v-96C32 327.2 24.84 320 16 320S0 327.2 0 336v96C0 476.1 35.88 512 80 512h288C412.1 512 448 476.1 448 432z'/%3e%3c/svg%3e"

/***/ }),
/* 112 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "7607519498bdacfe6b697f67608f674d.png");

/***/ }),
/* 113 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "2c87c7e04f37af51f814bc448078a732.png");

/***/ }),
/* 114 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "2be480169f01e9b23126529e2f84f5c2.png");

/***/ }),
/* 115 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MintRewards; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75);
/* harmony import */ var _mintRewards_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(116);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["handleConfirm", "brandName", "handleCancel", "isLoading", "gasPrice", "numRewards", "wrongPassCodeError"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var initialFormState = function initialFormState(rewards, gasFee) {
  return {
    rewards: {
      value: rewards ? rewards : '',
      error: false,
      message: ''
    },
    gasFee: {
      value: gasFee ? gasFee : '',
      error: false,
      message: ''
    },
    passcode: {
      value: '',
      error: false,
      message: ''
    },
    olderThan18: {
      value: false,
      error: false,
      message: ''
    }
  };
};
function MintRewards(_ref) {
  var handleConfirm = _ref.handleConfirm,
    brandName = _ref.brandName,
    handleCancel = _ref.handleCancel,
    isLoading = _ref.isLoading,
    gasPrice = _ref.gasPrice,
    numRewards = _ref.numRewards,
    _ref$wrongPassCodeErr = _ref.wrongPassCodeError,
    wrongPassCodeError = _ref$wrongPassCodeErr === void 0 ? false : _ref$wrongPassCodeErr,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState(numRewards, gasPrice)),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var brandNameRewards = brandName + ' Rewards';
  var isDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var hasErrors = Object.values(formState).filter(function (state) {
      return state.value === '' || state.error === true;
    });
    return !!hasErrors.length || formState.olderThan18.value === false || isLoading;
  }, [formState, isLoading]);
  var handleInputChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      value = _ref2$target.value,
      id = _ref2$target.id;
    setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
        value: value
      })));
    });
  }, [setFormState]);
  var handleCheckboxChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      id = _ref3$target.id,
      checked = _ref3$target.checked;
    setFormState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, previousState[id]), {}, {
        value: checked,
        error: !checked,
        message: checked ? '' : _utils__WEBPACK_IMPORTED_MODULE_2__.errorMessages.checkbox
      })));
    });
  }, [setFormState]);
  var handleFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var passcode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              passcode = formState.passcode;
              _context.next = 4;
              return handleConfirm({
                passcode: passcode.value
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [formState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", _extends({
    className: "mint-rewards",
    onSubmit: handleFormSubmit
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "heading",
    "data-core-qa": "mintRewardsTitleText"
  }, "Mint your ", brandName, " Rewards"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "description-text",
    "data-core-qa": "mintRewardsTitleSubText"
  }, "Minting your ", brandName, " rewards will turn them into ", brandName, " tokens on the blockchain. To do this you will need to pay an Ethereum gas fee.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "mintRewardsInputAvailableRewards",
    className: "formInput",
    labelText: brandNameRewards,
    placeholder: numRewards,
    id: "rewards",
    value: numRewards,
    disabled: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "mintRewardsInputGasFee",
    className: "formInput",
    labelText: "Ethereum Gas Fee",
    placeholder: gasPrice,
    id: "gasFee",
    value: gasPrice,
    disabled: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "mintRewardsInputPasscode",
    type: "password",
    className: "formInput",
    labelText: "Wallet Passcode",
    id: "passcode",
    placeholder: "Wallet passcode",
    onChange: handleInputChange,
    invalid: wrongPassCodeError,
    invalidText: "Incorrect wallet passcode entered",
    value: formState.passcode.value,
    required: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "formBreak"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Checkbox, {
    "data-core-qa": "mintRewardsCheckboxAge",
    className: "checkBox",
    id: "olderThan18",
    labelText: "I am over 18 years of age",
    onChange: handleCheckboxChange,
    required: true
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "button-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "mintRewardsButtonConfirm",
    className: "confirmButton",
    kind: "solid",
    disabled: isDisabled,
    loading: isLoading,
    type: "submit"
  }, "Confirm"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    className: "cancelButton",
    onClick: handleCancel,
    "data-core-qa": "mintRewardsButtonCancel"
  }, "Cancel")));
}
MintRewards.propTypes = {
  /** Called on form submit */
  handleConfirm: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Called onClick of cancel button */
  handleCancel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Used in the heading of the component */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** State passed in for disabling the Confirm button and displaying a spinner while the api is called */
  isLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** Gas or Transaction fee for converting rewards to ETH */
  gasPrice: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Quantity of rewards the user will be minting */
  numRewards: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** State bool to show the incorrect passcode error */
  wrongPassCodeError: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
};

/***/ }),
/* 116 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 117 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NodeActions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _PageAndLayout_Table_Table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
/* harmony import */ var _nodeActions_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(118);





function NodeActions(_ref) {
  var headingText = _ref.headingText,
    isLoading = _ref.isLoading,
    nodesNeedSetup = _ref.nodesNeedSetup,
    userHasNodes = _ref.userHasNodes,
    purchaseNodesButtonText = _ref.purchaseNodesButtonText,
    purchaseNodesButtonCallback = _ref.purchaseNodesButtonCallback,
    setupNodeSoftwareButtonText = _ref.setupNodeSoftwareButtonText,
    setupNodeSoftwareButtonCallback = _ref.setupNodeSoftwareButtonCallback,
    mintRewardsButtonText = _ref.mintRewardsButtonText,
    mintRewardsButtonCallback = _ref.mintRewardsButtonCallback,
    nodeTableProps = _ref.nodeTableProps;
  headingText = headingText || 'Nodes';
  purchaseNodesButtonText = purchaseNodesButtonText || 'Purchase Nodes';
  setupNodeSoftwareButtonText = setupNodeSoftwareButtonText || 'Set Up Node Software';
  var showNodesTable = userHasNodes && nodeTableProps;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-actions"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "actions-row ".concat(showNodesTable ? 'spacing-for-table' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "heading"
  }, headingText), isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Loading...") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    className: "button",
    onClick: purchaseNodesButtonCallback
  }, purchaseNodesButtonText), nodesNeedSetup && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    className: "button",
    onClick: setupNodeSoftwareButtonCallback
  }, setupNodeSoftwareButtonText), userHasNodes && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    className: "button",
    onClick: mintRewardsButtonCallback
  }, mintRewardsButtonText))), showNodesTable && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PageAndLayout_Table_Table__WEBPACK_IMPORTED_MODULE_1__["default"], nodeTableProps));
}
NodeActions.propTypes = {
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  isLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
  nodesNeedSetup: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
  userHasNodes: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
  purchaseNodesButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  purchaseNodesButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  setupNodeSoftwareButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  setupNodeSoftwareButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  mintRewardsButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  mintRewardsButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  nodeTableProps: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape(_PageAndLayout_Table_Table__WEBPACK_IMPORTED_MODULE_1__["default"].propTypes)
};

/***/ }),
/* 118 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 119 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NodeData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _nodeData_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(120);
/* harmony import */ var _assets_icons_fontawesome_gear_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(121);
/* harmony import */ var _assets_icons_fontawesome_gear_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_gear_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_solid_green_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(122);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_solid_green_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_solid_green_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_solid_red_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(123);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_solid_red_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_solid_red_svg__WEBPACK_IMPORTED_MODULE_5__);







function NodeData(_ref) {
  var system = _ref.system,
    active = _ref.active,
    type = _ref.type,
    licenseID = _ref.licenseID,
    downloadNodeCallback = _ref.downloadNodeCallback;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper__node-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper__grid-item-system"
  }, system ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    onClick: downloadNodeCallback,
    className: "node-data-wrapper__active-button"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_gear_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "node-data-wrapper__settings-icon"
  }), system) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    type: "button",
    onClick: downloadNodeCallback,
    className: "node-data-wrapper__setup-button"
  }, "Set Up Node")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper__grid-item-active"
  }, active ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_circle_solid_green_svg__WEBPACK_IMPORTED_MODULE_4___default()),
    className: "node-data-wrapper__active-icon"
  }), "YES") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_circle_solid_red_svg__WEBPACK_IMPORTED_MODULE_5___default()),
    className: "node-data-wrapper__active-icon"
  }), "NO")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper__grid-item-type"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, type)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-data-wrapper__grid-item-license"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, licenseID))));
}
NodeData.propTypes = {
  system: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  active: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
  type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  licenseID: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  downloadNodeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};

/***/ }),
/* 120 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 121 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg id='icons'%3e%3cg id='Actions'%3e%3cg id='Controls'%3e%3cg%3e%3cpath d='M26.96,16.76c.02-.25,.04-.5,.04-.76s-.01-.51-.03-.77l1.92-1.69c.72-.63,.89-1.68,.41-2.5l-2.36-4.09c-.37-.63-1.03-1-1.73-1-.21,0-.43,.03-.64,.11l-2.43,.82c-.42-.28-.86-.54-1.31-.76l-.5-2.52c-.19-.93-1.01-1.61-1.96-1.61h-4.72c-.95,0-1.77,.67-1.96,1.61l-.5,2.52c-.46,.22-.91,.47-1.33,.75l-2.42-.82c-.21-.07-.43-.11-.64-.11-.7,0-1.37,.37-1.73,1l-2.36,4.09c-.48,.83-.3,1.87,.41,2.5l1.93,1.7c-.02,.25-.04,.5-.04,.76s.01,.51,.03,.77l-1.92,1.69c-.72,.63-.89,1.68-.41,2.5l2.36,4.09c.37,.63,1.03,1,1.73,1,.21,0,.43-.03,.64-.11l2.43-.82c.42,.28,.86,.54,1.31,.76l.5,2.52c.19,.93,1.01,1.61,1.96,1.61h4.72c.95,0,1.77-.67,1.96-1.61l.5-2.52c.46-.22,.91-.47,1.33-.75l2.42,.82c.21,.07,.43,.11,.64,.11,.7,0,1.37-.37,1.73-1l2.36-4.09c.48-.83,.3-1.87-.41-2.5l-1.93-1.7Zm-1.75,7.29l-3.43-1.16c-.8,.68-1.73,1.21-2.71,1.56l-.71,3.55h-4.72l-.71-3.55c-.98-.36-1.9-.91-2.69-1.57l-3.45,1.17-2.36-4.09,2.73-2.39c-.18-1.04-.19-2.08,0-3.13l-2.72-2.39,2.36-4.09,3.43,1.16c.8-.68,1.73-1.21,2.71-1.56l.71-3.55h4.72l.71,3.55c.98,.36,1.9,.91,2.69,1.57l3.45-1.17,2.36,4.09-2.73,2.4c.18,1.04,.19,2.08,0,3.13l2.72,2.39-2.36,4.09Z'/%3e%3cpath d='M16,22c-3.36,0-6-2.64-6-6s2.64-6,6-6,6,2.64,6,6-2.64,6-6,6Zm0-10c-2.28,0-4,1.72-4,4s1.72,4,4,4,4-1.72,4-4-1.72-4-4-4Z'/%3e%3crect id='_Transparent_Rectangle_' class='cls-1' width='32' height='32'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 122 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3c!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath fill='%2300AA34' d='M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z'/%3e%3c/svg%3e"

/***/ }),
/* 123 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3c!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath fill='%23FF0000' d='M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z'/%3e%3c/svg%3e"

/***/ }),
/* 124 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NodesDisplay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _NodeData_NodeData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(119);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45);
/* harmony import */ var _assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _nodesDisplay_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function NodesDisplay(_ref) {
  var nodesData = _ref.nodesData,
    downloadNodeCallback = _ref.downloadNodeCallback,
    rowsPerPage = _ref.rowsPerPage;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(nodesData),
    _useState2 = _slicedToArray(_useState, 2),
    nodeList = _useState2[0],
    setNodeList = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
      column: 'system',
      ascending: true
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    sortMethod = _useState4[0],
    setSortMethod = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    pageData = _useState6[0],
    setPageData = _useState6[1];
  var sortNodes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, ascending) {
    if (ascending) {
      var sorted = _toConsumableArray(nodeList).sort(function (a, b) {
        if (a[id] < b[id]) {
          return -1;
        }
        if (a[id] > b[id]) {
          return 1;
        }
        return 0;
      });
      return sorted;
    } else {
      var _sorted = _toConsumableArray(nodeList).sort(function (a, b) {
        if (a[id] > b[id]) {
          return -1;
        }
        if (a[id] < b[id]) {
          return 1;
        }
        return 0;
      });
      return _sorted;
    }
  }, [nodeList]);
  var sortList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id) {
    if (id === sortMethod.column) {
      setSortMethod(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          ascending: !prevState.ascending
        });
      });
    } else {
      setSortMethod(function () {
        return {
          column: id,
          ascending: true
        };
      });
    }
  }, [sortMethod]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var sorted = sortNodes(sortMethod.column, sortMethod.ascending);
    setNodeList(sorted);
  }, [sortMethod]);

  //*********
  //BELOW is functions for the pagination that will change in the footer of this html - not built yet ... but design just changed, this component is on hold until after MVP. Will come back to it

  var pagination = function pagination(nodeList, currentPage, perPageItems) {
    var page = currentPage || 1;
    var perPage = perPageItems || 25;
    var offset = (page - 1) * perPage;
    var paginatedNodes = nodeList.slice(offset).slice(0, perPageItems);
    var totalPages = Math.ceil(nodeList.length / perPage);
    return {
      page: page,
      perPage: perPage,
      priorPage: page - 1 ? page - 1 : null,
      nextPage: totalPages > page ? page + 1 : null,
      totalNodes: nodeList.length,
      totalPages: totalPages,
      data: paginatedNodes
    };
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setPageData(pagination(nodeList, 1, {
      rowsPerPage: rowsPerPage
    }));
  }, []);

  //TODO: on sort change arrow direction icon on that column

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__title"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", null, "Nodes")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__node-header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__grid-item-system"
  }, "System", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "node-display-wrapper__arrow",
    id: "system",
    onClick: function onClick(e) {
      sortList(e.target.id);
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__grid-item-active"
  }, "Active", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "node-display-wrapper__arrow",
    id: "active",
    onClick: function onClick(e) {
      sortList(e.target.id);
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__grid-item-type"
  }, "Type", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "node-display-wrapper__arrow",
    id: "type",
    onClick: function onClick(e) {
      sortList(e.target.id);
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "node-display-wrapper__grid-item-license"
  }, "License ID", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_down_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "node-display-wrapper__arrow",
    id: "licenseID",
    onClick: function onClick(e) {
      sortList(e.target.id);
    }
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, nodeList && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, nodeList.map(function (node) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      key: node.licenseID
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_NodeData_NodeData__WEBPACK_IMPORTED_MODULE_1__["default"], {
      system: node.system,
      active: node.active,
      type: node.type,
      licenseID: node.licenseID,
      downloadNodeCallback: downloadNodeCallback
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", null));
  }))));
}
NodesDisplay.propTypes = {
  nodesData: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    system: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    active: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    licenseID: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    downloadNodeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
  })),
  downloadNodeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  rowsPerPage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};

/***/ }),
/* 125 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 126 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var qrcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(127);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _receiveTab_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(156);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var ReceiveTab = function ReceiveTab(_ref) {
  var bodyText = _ref.bodyText,
    bodyTitle = _ref.bodyTitle,
    coinName = _ref.coinName,
    handleDoneButtonCallback = _ref.handleDoneButtonCallback,
    _ref$doneButtonText = _ref.doneButtonText,
    doneButtonText = _ref$doneButtonText === void 0 ? 'Done' : _ref$doneButtonText,
    walletId = _ref.walletId;
  bodyText = bodyText || "Receive ".concat(coinName, " by either scanning the QR code or simply copying and pasting this wallet address into the send to/recipient address of a compatible wallet application. After successfully sending, please click done down below.");
  bodyTitle = bodyTitle || "Receive ".concat(coinName, " from Another Wallet");
  var qrRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    qrcode__WEBPACK_IMPORTED_MODULE_1__.toCanvas(qrRef.current, walletId, function (error) {
      if (error) console.error(error);
    });
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-tab-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body__title",
    "data-core-qa": "receiveTabTitleText"
  }, bodyTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body__text",
    "data-core-qa": "receiveTabTitleSubText"
  }, bodyText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-id-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("canvas", {
    "data-core-qa": "receiveTabQRCode",
    className: "receive-external-wallet-id-container__crypto-address-canvas",
    ref: qrRef
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-id-container__or",
    "data-core-qa": "receiveTabOrText"
  }, "OR"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-copy flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-copy__id"
  }, walletId), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    text: walletId,
    onCopy: function onCopy() {
      return setCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "receiveTabButtonCopy",
    kind: "solid",
    className: "receive-external-wallet-copy__btn",
    onClick: function onClick() {
      return setCopied(true);
    }
  }, copied ? 'Copied!' : 'Copy')))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "receiveTabButtonConfirm",
    kind: "solid",
    className: "receive-external-wallet-done-btn",
    onClick: handleDoneButtonCallback
  }, doneButtonText))));
};
ReceiveTab.propTypes = {
  /** Subtext displayed beneath the heading */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** The heading text */
  bodyTitle: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** If not bodyText prop is provided, the coinName prop is used as part of a default 'bodyText' value */
  coinName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** Callback function that is called when the Done button is clicked */
  handleDoneButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
  /** Text displayed on the Done button */
  doneButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** This value is displayed in the QR code as well as in an input that can be copied to the clipboard */
  walletId: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["default"] = (ReceiveTab);

/***/ }),
/* 127 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


const canPromise = __webpack_require__(128)

const QRCode = __webpack_require__(129)
const CanvasRenderer = __webpack_require__(153)
const SvgRenderer = __webpack_require__(155)

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),
/* 128 */
/***/ (function(module) {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),
/* 129 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Utils = __webpack_require__(130)
const ECLevel = __webpack_require__(131)
const BitBuffer = __webpack_require__(132)
const BitMatrix = __webpack_require__(133)
const AlignmentPattern = __webpack_require__(134)
const FinderPattern = __webpack_require__(135)
const MaskPattern = __webpack_require__(136)
const ECCode = __webpack_require__(137)
const ReedSolomonEncoder = __webpack_require__(138)
const Version = __webpack_require__(141)
const FormatInfo = __webpack_require__(145)
const Mode = __webpack_require__(142)
const Segments = __webpack_require__(146)

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),
/* 130 */
/***/ (function(__unused_webpack_module, exports) {

let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),
/* 131 */
/***/ (function(__unused_webpack_module, exports) {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 132 */
/***/ (function(module) {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),
/* 133 */
/***/ (function(module) {

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),
/* 134 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = (__webpack_require__(130).getSymbolSize)

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),
/* 135 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const getSymbolSize = (__webpack_require__(130).getSymbolSize)
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),
/* 136 */
/***/ (function(__unused_webpack_module, exports) {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),
/* 137 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const ECLevel = __webpack_require__(131)

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),
/* 138 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Polynomial = __webpack_require__(139)

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),
/* 139 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const GF = __webpack_require__(140)

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}


/***/ }),
/* 140 */
/***/ (function(__unused_webpack_module, exports) {

const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),
/* 141 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Utils = __webpack_require__(130)
const ECCode = __webpack_require__(137)
const ECLevel = __webpack_require__(131)
const Mode = __webpack_require__(142)
const VersionCheck = __webpack_require__(143)

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),
/* 142 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const VersionCheck = __webpack_require__(143)
const Regex = __webpack_require__(144)

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 143 */
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),
/* 144 */
/***/ (function(__unused_webpack_module, exports) {

const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),
/* 145 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Utils = __webpack_require__(130)

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),
/* 146 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Mode = __webpack_require__(142)
const NumericData = __webpack_require__(147)
const AlphanumericData = __webpack_require__(148)
const ByteData = __webpack_require__(149)
const KanjiData = __webpack_require__(151)
const Regex = __webpack_require__(144)
const Utils = __webpack_require__(130)
const dijkstra = __webpack_require__(152)

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),
/* 147 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Mode = __webpack_require__(142)

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),
/* 148 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Mode = __webpack_require__(142)

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),
/* 149 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const encodeUtf8 = __webpack_require__(150)
const Mode = __webpack_require__(142)

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    data = encodeUtf8(data)
  }
  this.data = new Uint8Array(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),
/* 150 */
/***/ (function(module) {

"use strict";


module.exports = function encodeUtf8 (input) {
  var result = []
  var size = input.length

  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index)

    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
      var second = input.charCodeAt(index + 1)

      if (second >= 0xDC00 && second <= 0xDFFF) {
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000
        index += 1
      }
    }

    // US-ASCII
    if (point < 0x80) {
      result.push(point)
      continue
    }

    // 2-byte UTF-8
    if (point < 0x800) {
      result.push((point >> 6) | 192)
      result.push((point & 63) | 128)
      continue
    }

    // 3-byte UTF-8
    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
      result.push((point >> 12) | 224)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // 4-byte UTF-8
    if (point >= 0x10000 && point <= 0x10FFFF) {
      result.push((point >> 18) | 240)
      result.push(((point >> 12) & 63) | 128)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // Invalid character
    result.push(0xEF, 0xBF, 0xBD)
  }

  return new Uint8Array(result).buffer
}


/***/ }),
/* 151 */
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Mode = __webpack_require__(142)
const Utils = __webpack_require__(130)

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),
/* 152 */
/***/ (function(module) {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),
/* 153 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Utils = __webpack_require__(154)

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),
/* 154 */
/***/ (function(__unused_webpack_module, exports) {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),
/* 155 */
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const Utils = __webpack_require__(154)

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),
/* 156 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 157 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RewardsHistory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _rewardsHistory_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(158);
var _excluded = ["handleReturnToDashboardCallback", "rewardsHistoryTableProps", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function RewardsHistory(_ref) {
  var handleReturnToDashboardCallback = _ref.handleReturnToDashboardCallback,
    rewardsHistoryTableProps = _ref.rewardsHistoryTableProps,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Rewards History' : _ref$title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "rewards-history flexColumn"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "rewards-history__title"
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "rewards-history__table-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "rewards-history__table reward-history-table"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Table, rewardsHistoryTableProps))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "rewardsHistoryButtonConfirm",
    kind: "solid",
    className: "rewards-history__button",
    onClick: handleReturnToDashboardCallback
  }, "Return To Dashboard"));
}
RewardsHistory.propTypes = {
  /** Callback function that is called when the "Return To Dashbaord" button is clicked */
  handleReturnToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** This is an object that is passed to these children components: Table
   * <br />**Please see `Table` in the `Related Components` section above for the structure of this prop */
  rewardsHistoryTableProps: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(_index__WEBPACK_IMPORTED_MODULE_1__.Table.propTypes),
  /** Displayed as a title above the table */
  title: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 158 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 159 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sendConfirmation_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
var _excluded = ["headingText", "bodyText", "image", "buttonText", "handleReturnToDashboardCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SendConfirmation = function SendConfirmation(_ref) {
  var headingText = _ref.headingText,
    bodyText = _ref.bodyText,
    image = _ref.image,
    buttonText = _ref.buttonText,
    handleReturnToDashboardCallback = _ref.handleReturnToDashboardCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var useCallback = function useCallback() {
    handleReturnToDashboardCallback();
  };
  headingText = headingText || 'Thank You Your Transaction Has Been Sent';
  bodyText = bodyText || 'Your transaction has been sent, please verify and check status from your dashboard.';
  buttonText = buttonText || 'Return To Dashboard';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "sendConfirmation"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sendConfirmation__brand-image-wrapper"
  }, image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "__image",
    src: image
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sendConfirmation__text-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "sendConfirmation__heading",
    "data-core-qa": "sendConfirmTitleText"
  }, headingText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "sendConfirmation__body",
    "data-core-qa": "sendConfirmTitleSubText"
  }, bodyText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    className: "sendConfirmation__button",
    onClick: useCallback,
    "data-core-qa": "sendConfirmButtonConfirm"
  }, buttonText));
};
SendConfirmation.propTypes = {
  /** Text In bold at the top. */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Text in the body that gives more detail. */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Image at the top.*/
  image: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** Text in the button.*/
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Where the user is returned to upon button click. */
  handleReturnToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (SendConfirmation);

/***/ }),
/* 160 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 161 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SendTab; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _sendTab_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(162);
var _excluded = ["availableBalance", "availableEthBalance", "coinSymbol", "continueTitleText", "confirmTitleText", "estimatedGasFee", "handleSendFormSubmitCallback", "incorrectPasscodeError", "sendConfirmIsLoading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function isValidPositiveDecimalNumber(value) {
  var regex = /^[0-9]*\.?[0-9]*$/;
  if (!regex.test(value)) {
    return false;
  }
  var parsedVal = parseFloat(value);
  return Number.isNaN(parsedVal) || parsedVal <= 0 ? false : true;
}
function validateAmountToSend(amountToSend, estimatedGasFee, availableBalance) {
  if (!isValidPositiveDecimalNumber(amountToSend)) {
    return {
      result: {
        value: amountToSend,
        error: true,
        errorMsg: 'Please enter a valid amount'
      },
      total: null
    };
  }
  var totalAmount = parseFloat(amountToSend) + estimatedGasFee;
  if (totalAmount > availableBalance) {
    return {
      result: {
        value: amountToSend,
        error: true,
        errorMsg: 'Amount entered exceeds available balance with gas fee'
      },
      total: totalAmount
    };
  }
  return {
    result: {
      value: amountToSend,
      error: false,
      errorMsg: ''
    },
    total: totalAmount
  };
}
function validateBrandAmountToSend(amountToSend, estimatedGasFee, availableBalance, availableEthBalance) {
  if (amountToSend > availableBalance) {
    return {
      result: {
        value: amountToSend,
        error: true,
        errorMsg: 'Amount entered exceeds available coin balance'
      },
      //no total as brand coin and ETH are not summable
      total: ''
    };
  } else if (estimatedGasFee > availableEthBalance) {
    return {
      result: {
        value: amountToSend,
        error: true,
        errorMsg: 'Gas fee exceeds available ETH balance'
      },
      total: ''
    };
  }
  return {
    result: {
      value: amountToSend,
      error: false,
      errorMsg: ''
    },
    total: ''
  };
}
function validateWalletAddress(sendToAddress, coinSymbol) {
  var ethRegex = /^0x[a-fA-F0-9]{40}$/;
  var mainnetRegex = /^(bc1|[13])[a-km-zA-HJ-NP-Z1-9]{25,39}$/;
  var testnetRegex = /^(tb1|[2nm]|bcrt)[a-km-zA-HJ-NP-Z1-9]{25,40}$/;
  var isValidAddress = coinSymbol === 'BTC' ? mainnetRegex.test(sendToAddress) || testnetRegex.test(sendToAddress) : ethRegex.test(sendToAddress);
  return {
    result: {
      value: sendToAddress,
      error: !isValidAddress,
      errorMsg: !isValidAddress ? 'Incorrect wallet address format, please double check and try again' : ''
    }
  };
}
var initialFormState = {
  amountToSend: {
    value: '',
    error: false,
    errorMsg: ''
  },
  isAdult: {
    checked: false
  },
  sendToAddress: {
    value: '',
    error: false,
    errorMsg: ''
  },
  total: {
    value: ''
  },
  walletPasscode: {
    value: '',
    error: false
  }
};
function SendTab(_ref) {
  var availableBalance = _ref.availableBalance,
    availableEthBalance = _ref.availableEthBalance,
    coinSymbol = _ref.coinSymbol,
    _ref$continueTitleTex = _ref.continueTitleText,
    continueTitleText = _ref$continueTitleTex === void 0 ? 'Send To Another Wallet' : _ref$continueTitleTex,
    _ref$confirmTitleText = _ref.confirmTitleText,
    confirmTitleText = _ref$confirmTitleText === void 0 ? 'Confirm Transaction' : _ref$confirmTitleText,
    estimatedGasFee = _ref.estimatedGasFee,
    handleSendFormSubmitCallback = _ref.handleSendFormSubmitCallback,
    _ref$incorrectPasscod = _ref.incorrectPasscodeError,
    incorrectPasscodeError = _ref$incorrectPasscod === void 0 ? false : _ref$incorrectPasscod,
    sendConfirmIsLoading = _ref.sendConfirmIsLoading,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialFormState),
    _useState4 = _slicedToArray(_useState3, 2),
    formState = _useState4[0],
    setFormState = _useState4[1];
  var isContinueDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return formState.amountToSend.value === '' || formState.amountToSend.error || formState.sendToAddress.value === '' || formState.sendToAddress.error || validateWalletAddress(formState.sendToAddress.value, coinSymbol).result.error;
  }, [formState]);
  var isConfirmDisabled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return formState.walletPasscode.value === '' || !formState.isAdult.checked;
  }, [formState]);
  var handleContinueButtonClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setStep(1);
  }, []);
  var handleInputOnChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
      id = _ref2$target.id,
      value = _ref2$target.value;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevState[id]), {}, {
        value: value
      })));
    });
  }, []);
  var handleCheckboxOnChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref3) {
    var _ref3$target = _ref3.target,
      id = _ref3$target.id,
      checked = _ref3$target.checked;
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, id, {
        checked: checked
      }));
    });
  }, []);
  var handleAmountToSendOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref4) {
    var value = _ref4.target.value;
    var validation = coinSymbol !== 'ETH' && coinSymbol !== 'BTC' ? validateBrandAmountToSend(value, estimatedGasFee, availableBalance, availableEthBalance) : validateAmountToSend(value, estimatedGasFee, availableBalance);
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        amountToSend: validation.result,
        total: {
          value: validation.total
        }
      });
    });
  }, [estimatedGasFee, availableBalance, coinSymbol, availableEthBalance]);
  var handleSendToAddressOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref5) {
    var value = _ref5.target.value;
    var validation = validateWalletAddress(value, coinSymbol);
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        sendToAddress: validation.result
      });
    });
  }, []);
  var handleConfirmFormSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    handleSendFormSubmitCallback(formState);
  }, [formState]);
  var gasFeeValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var symbol = coinSymbol === 'BTC' ? 'BTC' : 'ETH';
    return "".concat(parseFloat(estimatedGasFee).toFixed(8), " ").concat(symbol);
  }, [coinSymbol, estimatedGasFee]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "send-tab"
  }, rest), step === 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "send-tab__title",
    "data-core-qa": "sendTabTitleText1"
  }, continueTitleText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "send-tab-continue-form"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow send-tab-input-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputBalance",
    id: "availableBalance",
    labelText: "Available Balance",
    className: "send-tab-input-container__input",
    disabled: "disabled",
    value: "".concat(parseFloat(availableBalance).toFixed(8), " ").concat(coinSymbol)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputGasFee",
    id: "estimatedGasFee",
    labelText: "Estimated Gas Fee",
    className: "send-tab-input-container__input",
    disabled: "disabled",
    value: gasFeeValue
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputAmount",
    id: "amountToSend",
    labelText: "Enter Amount",
    placeholder: "1.0 ".concat(coinSymbol),
    className: "send-tab-input-container__input",
    onChange: handleInputOnChange,
    onBlur: handleAmountToSendOnBlur,
    invalidText: formState.amountToSend.errorMsg,
    invalid: formState.amountToSend.error,
    value: formState.amountToSend.value
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputAddress",
    id: "sendToAddress",
    labelText: "Send to Address",
    className: "send-tab-input-container__input",
    onChange: handleInputOnChange,
    onBlur: handleSendToAddressOnBlur,
    invalidText: formState.sendToAddress.errorMsg,
    invalid: formState.sendToAddress.error,
    value: formState.sendToAddress.value
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "sendTabButtonContinue",
    kind: "solid",
    type: "button",
    className: "send-tab-continue-form__button",
    disabled: isContinueDisabled,
    onClick: handleContinueButtonClick
  }, "Continue"))), step === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "send-tab__title",
    "data-core-qa": "sendTabTitleText2"
  }, confirmTitleText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", {
    className: "send-tab-continue-form",
    onSubmit: handleConfirmFormSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow send-tab-input-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputAddressConfirm",
    id: "sendToAddressConfirm",
    labelText: "Send To Address",
    className: "send-tab-input-container__input",
    disabled: true,
    value: formState.sendToAddress.value
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputAmountConfirm",
    id: "amountToSendConfirm",
    labelText: "Amount",
    className: "send-tab-input-container__input",
    disabled: true,
    value: "".concat(parseFloat(formState.amountToSend.value).toFixed(8), " ").concat(coinSymbol)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputGasConfirm",
    id: "estimatedGasFeeConfirm",
    labelText: "Estimated Gas Fee",
    className: "send-tab-input-container__input",
    disabled: "disabled",
    value: gasFeeValue
  }), coinSymbol === 'BTC' || coinSymbol === 'ETH' ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputTotalConfirm",
    id: "total",
    labelText: "Total",
    className: "send-tab-input-container__input",
    disabled: "disabled",
    value: "".concat(parseFloat(formState.total.value).toFixed(8), " ").concat(coinSymbol)
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("br", {
    "data-core-qa": "sendTabInputNoTotal"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Input, {
    "data-core-qa": "sendTabInputPasscode",
    type: "password",
    id: "walletPasscode",
    labelText: "Wallet Passcode",
    className: "send-tab-input-container__input",
    onChange: handleInputOnChange,
    invalidText: "Incorrect Wallet Passcode",
    invalid: incorrectPasscodeError
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Checkbox, {
    "data-core-qa": "sendTabCheckboxAge",
    id: "isAdult",
    labelText: "I am over 18 years of age",
    className: "send-tab-confirm-form__checkbox",
    onChange: handleCheckboxOnChange
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "sendTabButtonSubmit",
    kind: "solid",
    type: "submit",
    className: "send-tab-confirm-form__button",
    disabled: isConfirmDisabled,
    loading: sendConfirmIsLoading
  }, "Confirm"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "sendTabButtonBack",
    kind: "outlined",
    type: "button",
    className: "send-tab-confirm-form__button-right",
    onClick: function onClick() {
      return setStep(0);
    }
  }, "Back"))));
}
SendTab.propTypes = {
  /**Number (amount) displayed in the Available Balance input display field */
  availableBalance: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** Number (amount) used to verify the user has enough ETH to cover a brand coin transaction */
  availableEthBalance: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** follows the amount in the Available Balance input display field */
  coinSymbol: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** Component heading title for step 2 (user inputs wallet passcode) */
  confirmTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Component heading title for step 1 (user enters amount and wallet) */
  continueTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Amount displayed in the Estimated Gas Fee input display field */
  estimatedGasFee: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** Callback function that returns the formState object */
  handleSendFormSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** Boolean dictating if there has been an error returned from the backend that the passcode is incorrect. Displays the message "Incorrect Wallet Passcode" under the passcode input box when true.*/
  incorrectPasscodeError: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** Loading state boolean utilized on the step 2 Confirm button */
  sendConfirmIsLoading: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};

/***/ }),
/* 162 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 163 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _thankYouForMintingRewards_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(164);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
var _excluded = ["headingText", "brandName", "image", "buttonText", "handleReturnToDashboard"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var ThankYouForMintingRewards = function ThankYouForMintingRewards(_ref) {
  var headingText = _ref.headingText,
    brandName = _ref.brandName,
    image = _ref.image,
    buttonText = _ref.buttonText,
    handleReturnToDashboard = _ref.handleReturnToDashboard,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleButtonClick = function handleButtonClick() {
    handleReturnToDashboard();
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "thankYouForMintingRewards"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "thankYouForMintingRewards__image",
    src: image
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "thankYouForMintingRewards__text-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "thankYouForMintingRewards__heading",
    "data-core-qa": "thankYouMintTitleText"
  }, headingText || 'Thank You for Minting Your Rewards'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "thankYouForMintingRewards__body",
    "data-core-qa": "thankYouMintTitleSubText"
  }, "Your ", brandName, " tokens are being created on the Ethereum Blockchain and will be added to your wallet. This process usually takes less than 10 minutes, but could take longer if the network is busy. Your coins will appear in your wallet when this is complete.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    "data-core-qa": "thankYouMintButtonSubmit",
    className: "thankYouForMintingRewards__button",
    kind: "solid",
    onClick: handleButtonClick
  }, buttonText || 'Return To Dashboard'));
};
ThankYouForMintingRewards.propTypes = {
  /** Text for the header. */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The name of the brand to be used in the component. */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** What image is used. */
  image: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** The text inside the button. */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** What happens when the user clicks Return to Dashboard. */
  handleReturnToDashboard: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (ThankYouForMintingRewards);

/***/ }),
/* 164 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 165 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TransactionHistoryTab; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _transactionHistoryTab_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(166);
var _excluded = ["transactionHistoryTableProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function TransactionHistoryTab(_ref) {
  var _transactionHistoryTa;
  var transactionHistoryTableProps = _ref.transactionHistoryTableProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "transaction-history"
  }, rest), (transactionHistoryTableProps === null || transactionHistoryTableProps === void 0 ? void 0 : (_transactionHistoryTa = transactionHistoryTableProps.tableData) === null || _transactionHistoryTa === void 0 ? void 0 : _transactionHistoryTa.length) > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "transaction-history__table-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "transaction-history__table txn-history-table"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Table, transactionHistoryTableProps))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "transaction-history__no-data"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "transactionTabErrorText"
  }, "No Records Found")));
}
TransactionHistoryTab.propTypes = {
  /** This is an object that is passed to these children components: Table
   * <br/>**Please see `Table` in the `Related Components` section above for the structure of this prop
   */
  transactionHistoryTableProps: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(_index__WEBPACK_IMPORTED_MODULE_1__.Table.propTypes)
};

/***/ }),
/* 166 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 167 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VaultNode; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vaultNode_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(168);
var _excluded = ["headingText", "nodeDataOne", "nodeDataTwo", "nodeDataSubText", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function VaultNode(_ref) {
  var headingText = _ref.headingText,
    nodeDataOne = _ref.nodeDataOne,
    nodeDataTwo = _ref.nodeDataTwo,
    nodeDataSubText = _ref.nodeDataSubText,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "vault-node-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "vault-node-wrapper__heading",
    "data-core-qa": "vaultNodeTitleText".concat(headingText === null || headingText === void 0 ? void 0 : headingText.split(' ')[0]).concat(id)
  }, headingText), nodeDataOne !== undefined && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "vault-node-wrapper__display"
  }, nodeDataTwo !== undefined ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "vaultNodeText".concat(headingText === null || headingText === void 0 ? void 0 : headingText.split(' ')[0]).concat(id)
  }, nodeDataOne === null || nodeDataOne === void 0 ? void 0 : nodeDataOne.toLocaleString(0), "/", nodeDataTwo === null || nodeDataTwo === void 0 ? void 0 : nodeDataTwo.toLocaleString(0)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "vaultNodeText".concat(headingText === null || headingText === void 0 ? void 0 : headingText.split(' ')[0]).concat(id)
  }, nodeDataOne !== undefined && (nodeDataOne === null || nodeDataOne === void 0 ? void 0 : nodeDataOne.toLocaleString(0)))), nodeDataSubText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "vault-node-wrapper__subText",
    "data-core-qa": "vaultNodeSubText".concat(headingText === null || headingText === void 0 ? void 0 : headingText.split(' ')[0]).concat(id)
  }, nodeDataSubText));
}
VaultNode.propTypes = {
  /** Title for the display info */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  /** Displays number, with comma separators, no decimals  */
  nodeDataOne: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
  /** To use: nodeDataOne is required, will display "nodeDataOne / nodeDataTwo" with comma separators, no decimals*/
  nodeDataTwo: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),
  /** Text to display in place of or below the nodeDataOne and two */
  nodeDataSubText: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** index used for data tag */
  id: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)
};

/***/ }),
/* 168 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 169 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WalletFunctionality; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _walletFunctionality_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(170);
var _excluded = ["coinAmt", "ethAmt", "coinLogo", "coinName", "coinSymbol", "estimatedGasFee", "initialActiveTab", "incorrectPasscodeError", "handleSendFormSubmitCallback", "receiveTabHandleDoneButtonCallback", "sendConfirmIsLoading", "tabLabels", "transactionHistoryTableProps", "usd", "walletId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function WalletFunctionality(_ref) {
  var coinAmt = _ref.coinAmt,
    ethAmt = _ref.ethAmt,
    coinLogo = _ref.coinLogo,
    coinName = _ref.coinName,
    coinSymbol = _ref.coinSymbol,
    estimatedGasFee = _ref.estimatedGasFee,
    _ref$initialActiveTab = _ref.initialActiveTab,
    initialActiveTab = _ref$initialActiveTab === void 0 ? 0 : _ref$initialActiveTab,
    _ref$incorrectPasscod = _ref.incorrectPasscodeError,
    incorrectPasscodeError = _ref$incorrectPasscod === void 0 ? false : _ref$incorrectPasscod,
    handleSendFormSubmitCallback = _ref.handleSendFormSubmitCallback,
    receiveTabHandleDoneButtonCallback = _ref.receiveTabHandleDoneButtonCallback,
    sendConfirmIsLoading = _ref.sendConfirmIsLoading,
    _ref$tabLabels = _ref.tabLabels,
    tabLabels = _ref$tabLabels === void 0 ? ['Send', 'Receive', 'Transaction History'] : _ref$tabLabels,
    transactionHistoryTableProps = _ref.transactionHistoryTableProps,
    usd = _ref.usd,
    walletId = _ref.walletId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialActiveTab),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var tabChangedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (tabNum) {
    setCurrentTab(tabNum);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "wallet-functionality"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-coinbox flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: coinLogo,
    className: "wallet-functionality-coinbox__logo"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-coinbox__name",
    "data-core-qa": "walletFuncCoinName"
  }, coinName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-coinbox__currency-labels"
  }, usd !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletFuncDollarSign"
  }, "$"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletFuncCoinSymbol"
  }, coinSymbol)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-coinbox__currency-amounts"
  }, usd !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletFuncUSDAmount"
  }, usd.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletFuncCoinAmount"
  }, coinAmt.toFixed(8)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-body"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Tabs, {
    tabLabels: tabLabels,
    handleTabChangedCallback: tabChangedCallback,
    initialActiveTab: initialActiveTab
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-functionality-body__content"
  }, currentTab === 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.SendTab, {
    availableBalance: coinAmt,
    availableEthBalance: ethAmt,
    coinSymbol: coinSymbol,
    estimatedGasFee: estimatedGasFee,
    handleSendFormSubmitCallback: handleSendFormSubmitCallback,
    incorrectPasscodeError: incorrectPasscodeError,
    sendConfirmIsLoading: sendConfirmIsLoading
  }), currentTab === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ReceiveTab, {
    coinName: coinName,
    handleDoneButtonCallback: receiveTabHandleDoneButtonCallback,
    walletId: walletId
  }), currentTab === 2 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.TransactionHistoryTab, {
    transactionHistoryTableProps: transactionHistoryTableProps
  }))));
}
WalletFunctionality.propTypes = {
  coinAmt: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** Brand coin gas fees are paid with ETH so we must pass this to `SendTab` to verify enough funds are available for the transaction */
  ethAmt: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  coinLogo: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),
  /** This is used in this component as well as being passed to these children components: ReceiveTab */
  coinName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** This is used in this component as well as being passed to these children components: SendTab */
  coinSymbol: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** This is passed to these children components: SendTab */
  estimatedGasFee: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** This is passed to these children components: SendTab */
  incorrectPasscodeError: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** This is passed to these children components: Tabs */
  initialActiveTab: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** This is passed to these children components: SendTab */
  handleSendFormSubmitCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** This is passed to these children components: ReceiveTab */
  receiveTabHandleDoneButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** This is passed to these children components: SendTab */
  sendConfirmIsLoading: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /** This is passed to these children components: Tabs */
  tabLabels: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)),
  /** This is passed to these children components: TransactionHistoryTab
   * <br/>**Please see `Table` in the `Related Components` section above for the strucutre of this prop
   */
  transactionHistoryTableProps: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(_index__WEBPACK_IMPORTED_MODULE_1__.Table.propTypes),
  /** If a number is passed in here, it will be displayed as the USD value of the wallet coin being displayed */
  usd: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
  /** This is passed to these children components: ReceiveTab */
  walletId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired)
};

/***/ }),
/* 170 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 171 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WalletVault; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _VaultNode_VaultNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
/* harmony import */ var _walletVault_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(172);
var _excluded = ["titleText", "nodes", "buttonOneText", "buttonOneCallback", "buttonTwoText", "buttonTwoCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function WalletVault(_ref) {
  var titleText = _ref.titleText,
    nodes = _ref.nodes,
    buttonOneText = _ref.buttonOneText,
    buttonOneCallback = _ref.buttonOneCallback,
    buttonTwoText = _ref.buttonTwoText,
    buttonTwoCallback = _ref.buttonTwoCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "wallet-vault-wrapper"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-vault-wrapper__heading"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "wallet-vault-wrapper__heading--title",
    "data-core-qa": "walletVaultTitleText"
  }, titleText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-vault-wrapper__heading--button-container"
  }, buttonOneText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    className: "wallet-vault-wrapper__button",
    onClick: buttonOneCallback,
    "data-core-qa": "walletVaultButton1"
  }, buttonOneText), buttonTwoText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    "data-core-qa": "walletVaultButton2",
    className: "wallet-vault-wrapper__button-secondary",
    onClick: buttonTwoCallback,
    kind: "outlined"
  }, buttonTwoText))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-vault-wrapper__nodes-wrapper"
  }, nodes.map(function (nodeProps, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "wallet-vault-wrapper__node",
      key: nodeProps.headingText
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_VaultNode_VaultNode__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({}, nodeProps, {
      id: i
    })));
  })));
}
WalletVault.propTypes = {
  /** Section header */
  titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Array of data objects dynamically generates each `VaultNode` component. Component is passed the related node data object. <br />**Please see `VaultNodes` in the `Related Components` section above for the structure of each object in the array of this prop.*/
  nodes: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape(_VaultNode_VaultNode__WEBPACK_IMPORTED_MODULE_1__["default"].propTypes)),
  /** Optional kind=solid button, button only displays if buttonOneText is provided */
  buttonOneText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Optional kind=outlined button, button only displays if buttonTwoText is provided */
  buttonTwoText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Called onClick of button one */
  buttonOneCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Called onClick of button two */
  buttonTwoCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};

/***/ }),
/* 172 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 173 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ConfirmRecoveryPhrase; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _confirmRecoveryPhrase_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(174);
var _excluded = ["brandName", "passphrase", "completeConfirmationButtonCallback", "returnToWalletButtonCallback", "headerText", "subText", "buttonOneText", "buttonTwoText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function ConfirmRecoveryPhrase(_ref) {
  var brandName = _ref.brandName,
    passphrase = _ref.passphrase,
    completeConfirmationButtonCallback = _ref.completeConfirmationButtonCallback,
    returnToWalletButtonCallback = _ref.returnToWalletButtonCallback,
    _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? "Confirm ".concat(brandName, " Wallet Recovery Phrase") : _ref$headerText,
    _ref$subText = _ref.subText,
    subText = _ref$subText === void 0 ? 'To be certain you have the correct recovery phrase, please enter the twelve lowercase words in order.' : _ref$subText,
    _ref$buttonOneText = _ref.buttonOneText,
    buttonOneText = _ref$buttonOneText === void 0 ? 'Complete' : _ref$buttonOneText,
    _ref$buttonTwoText = _ref.buttonTwoText,
    buttonTwoText = _ref$buttonTwoText === void 0 ? 'Return To Wallet Recovery Phrase' : _ref$buttonTwoText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var initialPassphraseState = passphrase.split(' ').reduce(function (acc, phrase, index) {
    acc[index] = {
      orderIndex: index,
      displayOnly: false,
      actualPhrase: phrase,
      inputPhrase: '',
      isValid: false,
      isTouched: false
    };
    return acc;
  }, {});
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialPassphraseState),
    _useState2 = _slicedToArray(_useState, 2),
    passphraseState = _useState2[0],
    setPassphraseState = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormValid = _useState4[0],
    setIsFormValid = _useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var areAllValid = Object.values(passphraseState).every(function (phrase) {
      return phrase.isValid;
    });
    setIsFormValid(areAllValid);
  }, [passphraseState]);
  var updatePassphraseState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (orderIndex, e, actualPhrase) {
    setPassphraseState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, orderIndex, _objectSpread(_objectSpread({}, previousState[orderIndex]), {}, {
        inputPhrase: e.target.value,
        isValid: e.target.value.toLowerCase() === actualPhrase,
        isTouched: e.target.value.toLowerCase() === actualPhrase
      })));
    });
  }, [passphraseState, setPassphraseState]);
  var handlePhraseValidationOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (orderIndex) {
    setPassphraseState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, orderIndex, _objectSpread(_objectSpread({}, previousState[orderIndex]), {}, {
        isTouched: true
      })));
    });
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: "confirm-recovery-phrase"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "text-container"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "heading",
    "data-core-qa": "confirmPhraseTitleText"
  }, headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "body",
    "data-core-qa": "confirmPhraseTitleSubText"
  }, subText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "phrase-container"
  }, Object.values(passphraseState).map(function (phrase) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.RecoveryPhraseTag, {
      key: phrase.orderIndex,
      orderIndex: phrase.orderIndex,
      actualPhrase: phrase.actualPhrase,
      displayOnly: phrase.displayOnly,
      inputPhrase: phrase.inputPhrase,
      isValid: phrase.isValid,
      isTouched: phrase.isTouched,
      onChange: function onChange(e) {
        return updatePassphraseState(phrase.orderIndex, e, phrase.actualPhrase);
      },
      onBlur: function onBlur(e) {
        handlePhraseValidationOnBlur(phrase.orderIndex);
      }
    });
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    onClick: completeConfirmationButtonCallback,
    disabled: !isFormValid,
    "data-core-qa": "confirmPhraseButton1"
  }, buttonOneText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    className: "button--secondary",
    onClick: returnToWalletButtonCallback,
    "data-core-qa": "confirmPhraseButton2"
  }, buttonTwoText)));
}
ConfirmRecoveryPhrase.propTypes = {
  /** Used in the default headerText, not required if customized header text is provided. */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** 12 word mnemonic for validating the user's entry. Passphrase words should be separated by a space, no comma.  */
  passphrase: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Component heading */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** sub-text below the heading */
  subText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Left Button text */
  buttonOneText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Right button text */
  buttonTwoText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Left Button callback function onClick*/
  completeConfirmationButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** Right Button callback function onClick*/
  returnToWalletButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired)
};

/***/ }),
/* 174 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 175 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CopyLicenseID; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_nerdCoreKit_CopyIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(176);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var _PageAndLayout_Modal_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57);
/* harmony import */ var _copyLicenseID_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(177);
var _excluded = ["headerText", "subHeaderText", "displayID", "continueButtonCallback", "finishLaterButtonCallback", "areYouSureText", "areYouSureContinueButtonText", "areYouSureReturnButtonText", "showDownload", "downloadCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








function CopyLicenseID(_ref) {
  var headerText = _ref.headerText,
    subHeaderText = _ref.subHeaderText,
    displayID = _ref.displayID,
    continueButtonCallback = _ref.continueButtonCallback,
    finishLaterButtonCallback = _ref.finishLaterButtonCallback,
    _ref$areYouSureText = _ref.areYouSureText,
    areYouSureText = _ref$areYouSureText === void 0 ? "Are you sure you wrote down your Blockchain ID?" : _ref$areYouSureText,
    _ref$areYouSureContin = _ref.areYouSureContinueButtonText,
    areYouSureContinueButtonText = _ref$areYouSureContin === void 0 ? "Yes, I'd Like To Continue" : _ref$areYouSureContin,
    _ref$areYouSureReturn = _ref.areYouSureReturnButtonText,
    areYouSureReturnButtonText = _ref$areYouSureReturn === void 0 ? "No, I'd Like To Return" : _ref$areYouSureReturn,
    showDownload = _ref.showDownload,
    downloadCallback = _ref.downloadCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    areYouSureIsOpen = _useState4[0],
    setAreYouSureIsOpen = _useState4[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "blockchainID"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "header",
    "data-core-qa": "copyLicenseTitleText"
  }, headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "subHeader",
    "data-core-qa": "copyLicenseTitleSubText"
  }, subHeaderText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow idDisplay"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "id",
    "data-core-qa": "copyLicenseDisplayId"
  }, displayID), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__.CopyToClipboard, {
    text: displayID,
    onCopy: function onCopy() {
      return setCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow copyButton"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_CopyIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
    size: 20
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "text",
    "data-core-qa": "copyLicenseButtonCopy"
  }, copied ? 'Copied!' : 'Copy')))), showDownload && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "download-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "copyLicenseDownloadText"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "download-wrapper__pdf-icon-wrapper",
    onClick: downloadCallback
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: _assets_icons_nerdCoreKit_CopyIcon__WEBPACK_IMPORTED_MODULE_2__["default"],
    className: "download-wrapper__pdfDownloadIcon"
  })), ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, "Download our", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "copyLicenseButtonDownload",
    kind: "link",
    onClick: downloadCallback,
    className: "download-wrapper__downloadTextButton"
  }, ' ', "help guide"), "for step-by-step instructions."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "copyLicenseButtonContinue",
    className: "continueButton",
    onClick: function onClick() {
      return setAreYouSureIsOpen(true);
    },
    type: "submit"
  }, "Continue"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "copyLicenseButtonCancel",
    className: "finishLaterButton",
    onClick: finishLaterButtonCallback,
    kind: "outlined"
  }, "Finish Later")), areYouSureIsOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PageAndLayout_Modal_Modal__WEBPACK_IMPORTED_MODULE_4__["default"], null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "blockchainIdModal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "blockchainIdModal__text",
    "data-core-qa": "copyLicenseConfirmTitleText"
  }, areYouSureText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "copyLicenseButtonConfirmSubmit",
    className: "continueButton",
    onClick: continueButtonCallback,
    type: "button"
  }, areYouSureContinueButtonText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "copyLicenseButtonConfirmCancel",
    className: "finishLaterButton",
    onClick: function onClick() {
      return setAreYouSureIsOpen(false);
    },
    type: "submit",
    kind: "outlined"
  }, areYouSureReturnButtonText)))));
}
CopyLicenseID.propTypes = {
  /** Title line text */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** Subtext under the title */
  subHeaderText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** ID for the user to see and/or copy */
  displayID: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** Callback for the Continue button onClick */
  continueButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** Callback for the Finish later button onClick */
  finishLaterButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** Verify user wants to continue Modal text */
  areYouSureText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Left modal button text */
  areYouSureContinueButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Right modal button text */
  areYouSureReturnButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** Bool to show optional text line to download the help guide */
  showDownload: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
  /** Callback for the onClick of download button and pdf icon*/
  downloadCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};

/***/ }),
/* 176 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CopyIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["color", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function CopyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: size,
    height: size
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "Organization"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "File"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z",
    fill: color
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z",
    fill: color
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("rect", {
    id: "_Transparent_Rectangle_",
    fill: "transparent",
    "data-name": "<Transparent Rectangle>",
    className: "copyIcon"
  }))))));
}
CopyIcon.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};

/***/ }),
/* 177 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 178 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CreatePasscode; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _AuthenticationAndEnrollment_PasswordValidation_PasswordValidation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98);
/* harmony import */ var _AuthenticationAndEnrollment_PasswordTag_PasswordTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94);
/* harmony import */ var _Inputs_Input_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63);
/* harmony import */ var _assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _createPasscode_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(179);
var _excluded = ["headerText", "subHeaderText", "createPasscodeCallback", "finishLaterCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










function CreatePasscode(_ref) {
  var headerText = _ref.headerText,
    subHeaderText = _ref.subHeaderText,
    createPasscodeCallback = _ref.createPasscodeCallback,
    finishLaterCallback = _ref.finishLaterCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    passcode = _useState2[0],
    setPasscode = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    passcodeConfirmation = _useState4[0],
    setPasscodeConfirmation = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    passcodeValidationMet = _useState6[0],
    setPasscodeValidationMet = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    showPasswordWarning = _useState8[0],
    setShowPasswordWarning = _useState8[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(checkPasscodeValidation, [passcode, passcodeConfirmation]);
  function checkPasscodeValidation() {
    if (passcode && passcode === passcodeConfirmation && (0,_utils___WEBPACK_IMPORTED_MODULE_5__.getIsPasswordValid)({
      password: passcode
    })) {
      setPasscodeValidationMet(true);
    } else {
      setPasscodeValidationMet(false);
    }
  }
  var passcodeMatchesConfirmation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (passcode && passcodeConfirmation && passcode === passcodeConfirmation) {
      return true;
    }
    return false;
  }, [passcode, passcodeConfirmation]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "createPasscode"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "header",
    "data-core-qa": "createPasscodeTitleText"
  }, headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "subHeader",
    "data-core-qa": "createPasscodeTitleSubText"
  }, subHeaderText), showPasswordWarning && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow passwordWarning"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_circle_line_solid_svg__WEBPACK_IMPORTED_MODULE_6___default()),
    alt: "warning",
    width: "16",
    height: "16"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "warningText",
    "data-core-qa": "createPasscodeWarningText"
  }, "Do not make your wallet passcode the same as your account"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "closeX",
    src: (_assets_icons_fontawesome_xmark_large_solid_svg__WEBPACK_IMPORTED_MODULE_7___default()),
    alt: "close",
    onClick: function onClick() {
      return setShowPasswordWarning(false);
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow inputs"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "input"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Input_Input__WEBPACK_IMPORTED_MODULE_4__["default"], {
    "data-core-qa": "createPasscodeInputPasscode",
    type: "password",
    labelText: "Wallet Passcode",
    placeholder: "Wallet Passcode",
    value: passcode,
    onChange: function onChange(e) {
      return setPasscode(e.target.value);
    },
    onBlur: function onBlur() {}
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "passcodeVerify"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_AuthenticationAndEnrollment_PasswordValidation_PasswordValidation__WEBPACK_IMPORTED_MODULE_2__["default"], {
    password: passcode,
    showPasswordStrengthIndicator: true,
    passwordStrengthLabel: "Passcode strength:"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "input"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Input_Input__WEBPACK_IMPORTED_MODULE_4__["default"], {
    "data-core-qa": "createPasscodeInputConfirmPasscode",
    type: "password",
    labelText: "Confirm Wallet Passcode",
    placeholder: "Wallet Passcode",
    value: passcodeConfirmation,
    onChange: function onChange(e) {
      return setPasscodeConfirmation(e.target.value);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "passcodeVerify"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_AuthenticationAndEnrollment_PasswordTag_PasswordTag__WEBPACK_IMPORTED_MODULE_3__["default"], {
    confirm: passcodeMatchesConfirmation
  }, "Passcode Matches")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    "data-core-qa": "createPasscodeButtonSubmit",
    className: "createPasscodeButton",
    onClick: function onClick() {
      return createPasscodeCallback(passcode);
    },
    disabled: !passcodeValidationMet
  }, "Create Passcode"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    "data-core-qa": "createPasscodeButtonCancel",
    className: "finishLaterButton",
    onClick: finishLaterCallback,
    kind: "outlined",
    type: "button"
  }, "Finish Later")));
}
CreatePasscode.propTypes = {
  /** Heading at the top of the component */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string.isRequired),
  /** Subtext to display information or instructions to the user */
  subHeaderText: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string.isRequired),
  /** Callback function called onClick of "Create Passcode" button. Returns user passcode. Button is disabled until all validations are met. */
  createPasscodeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired),
  /** Callback function to exit the current component called on the "Finish Later" button. No data is returned or stored. */
  finishLaterCallback: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired)
};

/***/ }),
/* 179 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 180 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CreateWalletSteps; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _createWalletSteps_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(181);
var _excluded = ["children", "currentIndex", "stepIcons", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function CreateWalletSteps(_ref) {
  var children = _ref.children,
    currentIndex = _ref.currentIndex,
    stepIcons = _ref.stepIcons,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var steps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return [{
      label: 'Create Wallet Passcode'
    }, {
      label: 'Wallet Recovery Phrase'
    }, {
      label: 'Confirm Recovery Phrase'
    }];
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "createWalletSteps ".concat(className)
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "createWalletSteps__progress-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ProgressIndicator, {
    steps: steps,
    currentIndex: currentIndex,
    stepIcons: stepIcons
  })), children);
}
CreateWalletSteps.propTypes = {
  /** Content to display below the progress bar */
  children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** Passed prop to identify current progress step to `ProgressIndictor` */
  currentIndex: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  /** Oject containing specific status icons passed to `ProgressIndicator` */
  stepIcons: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    uncompletedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    currentStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    completedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
  }),
  /** Styling applied to outer div wrapper */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 181 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 182 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _displayRecoveryPhrase_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(183);
var _excluded = ["brandName", "headingText", "areYouSureText", "areYouSureContinueButtonText", "areYouSureContinueButtonCallback", "areYouSureReturnButtonText", "passphrase", "buttonText", "bodyText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DisplayRecoveryPhrase = function DisplayRecoveryPhrase(_ref) {
  var brandName = _ref.brandName,
    _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? "".concat(brandName, " Wallet Recovery Phrase") : _ref$headingText,
    _ref$areYouSureText = _ref.areYouSureText,
    areYouSureText = _ref$areYouSureText === void 0 ? "Are you sure you secured your wallet recovery phrase in at least two locations?" : _ref$areYouSureText,
    _ref$areYouSureContin = _ref.areYouSureContinueButtonText,
    areYouSureContinueButtonText = _ref$areYouSureContin === void 0 ? "Yes, I'm Sure" : _ref$areYouSureContin,
    areYouSureContinueButtonCallback = _ref.areYouSureContinueButtonCallback,
    _ref$areYouSureReturn = _ref.areYouSureReturnButtonText,
    areYouSureReturnButtonText = _ref$areYouSureReturn === void 0 ? "No, Show Me Again" : _ref$areYouSureReturn,
    passphrase = _ref.passphrase,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'I Secured My Recovery Phrase' : _ref$buttonText,
    bodyText = _ref.bodyText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCopied = _useState2[0],
    setIsCopied = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    areYouSureIsOpen = _useState4[0],
    setAreYouSureIsOpen = _useState4[1];
  var initialPassphrase = passphrase.split(' ').reduce(function (acc, phrase, index) {
    acc[index] = {
      orderIndex: index,
      actualPhrase: phrase
    };
    return acc;
  }, {});
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "display-recovery-phrase__container"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: "display-recovery-phrase"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "text-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "heading",
    "data-core-qa": "displayPhraseTitleText"
  }, headingText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "body",
    "data-core-qa": "displayPhraseTitleSubText"
  }, bodyText ? bodyText : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, "This is the only time you will be shown your wallet recovery phrase. Write down and digitally save the following", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "body body--emphasis"
  }, "twelve lowercase words"), " in the", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "body body--emphasis"
  }, "exact order"), " they appear below, in a safe location. Should you forget your private key, you will be asked to enter the following phrase to recover access to your ", brandName, ' ', "Wallet. If you cannot remember your wallet recovery phrase after forgetting your private keys, ", brandName, " does not have the ability to access your wallet and all of your funds will be lost."))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "phrase-container"
  }, Object.values(initialPassphrase).map(function (phrase) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.RecoveryPhraseTag, {
      key: phrase.orderIndex,
      displayOnly: true,
      orderIndex: phrase.orderIndex,
      actualPhrase: phrase.actualPhrase
    });
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "copy-desktop"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "copy__text-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "copy__text",
    "data-core-qa": "displayPhrasePhraseText"
  }, passphrase)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    className: "copy__button",
    text: passphrase,
    onCopy: function onCopy() {
      setIsCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "displayPhraseButtonCopy"
  }, isCopied ? 'Copied' : 'Copy'))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    className: "button copy-mobile",
    text: passphrase,
    onCopy: function onCopy() {
      setIsCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "displayPhraseButtonCopyMobile"
  }, isCopied ? 'Copied' : 'Copy Phrase')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "displayPhraseButtonSubmit",
    className: "button",
    onClick: function onClick() {
      return setAreYouSureIsOpen(true);
    },
    type: "submit"
  }, buttonText)), areYouSureIsOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Modal, {
    modalClassName: "drp-modal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "drp-modal__text",
    "data-core-qa": "displayPhraseConfirmText"
  }, areYouSureText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "drp-modal__button-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    className: "button",
    onClick: areYouSureContinueButtonCallback,
    "data-core-qa": "displayPhraseButtonContinue"
  }, areYouSureContinueButtonText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "displayPhraseButtonBack",
    className: "button button--secondary",
    onClick: function onClick() {
      return setAreYouSureIsOpen(false);
    }
  }, areYouSureReturnButtonText))));
};
DisplayRecoveryPhrase.propTypes = {
  /** Brand name to be displayed in default text values */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Component heading text */
  headingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Paragraph text below the heading to provide information about the 12 word recovery phrase. Default text is provided using the brandName prop if this is not passed in. Type node in order to allow for jsx to passed in.*/
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
  /** Main component button text */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** 12 word mnemonic in a single string separated by spaces, no commas */
  passphrase: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** After user clicks to continue a modal is opened to verify the user has secured their passphrase. This text appears on in the body of that modal  */
  areYouSureText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Text for left button within the modal  */
  areYouSureContinueButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Callback function called on the left button within the modal for the user to continue with the create wallet sequence */
  areYouSureContinueButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Text for right button within the modal */
  areYouSureReturnButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (DisplayRecoveryPhrase);

/***/ }),
/* 183 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 184 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var qrcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(127);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _Utility_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18);
/* harmony import */ var _receiveFromExternalWallet_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185);
var _excluded = ["bodyText", "bodyTitle", "coinAmt", "coinLogo", "coinName", "coinSymbol", "doneButtonCallback", "doneButtonText", "receiveTabText", "usd", "walletId"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var ReceiveFromExternalWallet = function ReceiveFromExternalWallet(_ref) {
  var bodyText = _ref.bodyText,
    bodyTitle = _ref.bodyTitle,
    coinAmt = _ref.coinAmt,
    coinLogo = _ref.coinLogo,
    coinName = _ref.coinName,
    coinSymbol = _ref.coinSymbol,
    doneButtonCallback = _ref.doneButtonCallback,
    _ref$doneButtonText = _ref.doneButtonText,
    doneButtonText = _ref$doneButtonText === void 0 ? 'Done' : _ref$doneButtonText,
    _ref$receiveTabText = _ref.receiveTabText,
    receiveTabText = _ref$receiveTabText === void 0 ? 'Receive' : _ref$receiveTabText,
    usd = _ref.usd,
    _ref$walletId = _ref.walletId,
    walletId = _ref$walletId === void 0 ? '' : _ref$walletId,
    rest = _objectWithoutProperties(_ref, _excluded);
  bodyText = bodyText || "Receive ".concat(coinName, " by either scanning the QR code or simply copying and pasting this wallet address into the send to/recipient address of a compatible wallet application. After successfully sending, please click done down below.");
  bodyTitle = bodyTitle || "Receive ".concat(coinName, " from Another Wallet");
  var theme = (0,_Utility_useTheme__WEBPACK_IMPORTED_MODULE_4__.useTheme)();
  var qrRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    qrcode__WEBPACK_IMPORTED_MODULE_1__.toCanvas(qrRef.current, walletId, function (error) {
      if (error) console.error(error);
    });
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", rest, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-coin flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: coinLogo,
    className: "receive-external-wallet-coin__logo"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-coin__name",
    "data-core-qa": "receiveCoinName"
  }, coinName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-coin__currency-labels",
    "data-core-qa": "receiveCoinDollar"
  }, usd !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "receiveCoinDollar"
  }, "$"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "receiveCoinSymbol"
  }, coinSymbol)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-coin__currency-amounts"
  }, usd !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "receiveCoinDollarAmount"
  }, usd.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "receiveCoinAmount"
  }, coinAmt.toLocaleString('en-US', {
    style: 'decimal',
    minimumFractionDigits: 10
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "receiveTabText",
    className: "receive-external-wallet-tab",
    style: {
      backgroundColor: (theme === null || theme === void 0 ? void 0 : theme.primaryColor) || '#326260'
    }
  }, receiveTabText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body__title",
    "data-core-qa": "receiveTitleText"
  }, bodyTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-body__text",
    "data-core-qa": "receiveTitleSubText"
  }, bodyText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-id-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("canvas", {
    "data-core-qa": "receiveQRCode",
    className: "receive-external-wallet-id-container__crypto-address-canvas",
    ref: qrRef
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-id-container__or",
    "data-core-qa": "receiveOrText"
  }, "OR"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-copy flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "receive-external-wallet-copy__id",
    "data-core-qa": "receiveWalletId"
  }, walletId), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    text: walletId,
    onCopy: function onCopy() {
      return setCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "receiveButtonCopy",
    kind: "solid",
    className: "receive-external-wallet-copy__btn",
    onClick: function onClick() {
      return setCopied(true);
    }
  }, copied ? 'Copied!' : 'Copy')))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "receiveButtonCancel",
    kind: "solid",
    className: "receive-external-wallet-done-btn",
    onClick: doneButtonCallback
  }, doneButtonText))));
};
ReceiveFromExternalWallet.propTypes = {
  /** Main body text. */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** The title of the component. */
  bodyTitle: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** The amount of coin to be displayed. */
  coinAmt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
  /** The image of the logo to represent the coin. */
  coinLogo: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node.isRequired),
  /** The name of the coin to be displayed. */
  coinName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** The abbreviated name of the coin. */
  coinSymbol: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** What happens when the done button is clicked. */
  doneButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** The text on the done button. */
  doneButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** What the recieve tab is labeled. */
  receiveTabText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** The displayed amount in dollars. */
  usd: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
  /** The ID of the wallet being used. */
  walletId: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["default"] = (ReceiveFromExternalWallet);

/***/ }),
/* 185 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 186 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RecoveryPhrase; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _recoveryPhrase_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(188);
var _excluded = ["type", "passphrase", "wordCount", "buttonOneText", "buttonTwoText", "buttonOneCallback", "buttonTwoCallback", "headerText", "subText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var PHRASE_TYPES = {
  display: 'display',
  enter: 'enter',
  enterValidated: 'enterValidated'
};
function RecoveryPhrase(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'enter' : _ref$type,
    passphrase = _ref.passphrase,
    _ref$wordCount = _ref.wordCount,
    wordCount = _ref$wordCount === void 0 ? 12 : _ref$wordCount,
    buttonOneText = _ref.buttonOneText,
    buttonTwoText = _ref.buttonTwoText,
    buttonOneCallback = _ref.buttonOneCallback,
    buttonTwoCallback = _ref.buttonTwoCallback,
    headerText = _ref.headerText,
    subText = _ref.subText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCopied = _useState4[0],
    setIsCopied = _useState4[1];
  var initialPhrase = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    switch (type) {
      case PHRASE_TYPES.display:
        return passphrase.split(' ').reduce(function (acc, word, index) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, index, {
            orderIndex: index,
            displayOnly: true,
            actualPhrase: word,
            inputPhrase: '',
            isValid: false,
            isTouched: false
          }));
        }, {});
      case PHRASE_TYPES.enter:
        return (0,lodash__WEBPACK_IMPORTED_MODULE_1__.times)(wordCount).reduce(function (acc, word, index) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, index, {
            orderIndex: index,
            displayOnly: false,
            actualPhrase: '',
            inputPhrase: '',
            isValid: false,
            isTouched: true,
            shouldValidate: false
          }));
        }, {});
      case PHRASE_TYPES.enterValidated:
        return passphrase.split(' ').reduce(function (acc, word, index) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, index, {
            orderIndex: index,
            displayOnly: false,
            actualPhrase: word,
            inputPhrase: '',
            isValid: false,
            isTouched: false,
            shouldValidate: true
          }));
        }, {});
    }
  }, [passphrase, type]);
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialPhrase),
    _useState6 = _slicedToArray(_useState5, 2),
    passphraseState = _useState6[0],
    setPassphraseState = _useState6[1];
  var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (_ref2) {
    var type = _ref2.type,
      orderIndex = _ref2.orderIndex,
      event = _ref2.event,
      actualPhrase = _ref2.actualPhrase;
    switch (type) {
      case PHRASE_TYPES.display:
        return;
      case PHRASE_TYPES.enterValidated:
        return setPassphraseState(function (previousState) {
          return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, orderIndex, _objectSpread(_objectSpread({}, previousState[orderIndex]), {}, {
            inputPhrase: event.target.value,
            isValid: event.target.value.toLowerCase() === actualPhrase,
            isTouched: event.target.value.toLowerCase() === actualPhrase
          })));
        });
      case PHRASE_TYPES.enter:
        return setPassphraseState(function (previousState) {
          return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, orderIndex, _objectSpread(_objectSpread({}, previousState[orderIndex]), {}, {
            inputPhrase: event.target.value,
            isValid: event.target.value.length
          })));
        });
    }
  }, [passphraseState, setPassphraseState]);
  var handleOnBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (orderIndex) {
    setPassphraseState(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, orderIndex, _objectSpread(_objectSpread({}, previousState[orderIndex]), {}, {
        isTouched: true
      })));
    });
  }, []);
  var handleButtonTwoCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (type === PHRASE_TYPES.enter) {
      var phrase = Object.values(passphraseState).map(function (word) {
        return word.inputPhrase;
      }).join(' ');
      buttonTwoCallback(phrase);
    } else {
      buttonTwoCallback();
    }
  }, [buttonTwoCallback, type, passphraseState]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var isValid = Object.values(passphraseState).every(function (phrase) {
      return phrase.isValid;
    });
    setIsFormValid(isValid);
  }, [passphraseState]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: "recovery-phrase"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "text-container"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "heading",
    "data-core-qa": "recoveryPhraseTitleText"
  }, headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "body",
    "data-core-qa": "recoveryPhraseSubText"
  }, subText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "phrase-container"
  }, Object.values(passphraseState).map(function (word) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.RecoveryPhraseTag, {
      key: word.orderIndex,
      orderIndex: word.orderIndex,
      displayOnly: word.displayOnly,
      inputPhrase: word.inputPhrase,
      actualPhrase: word.actualPhrase,
      isValid: word.isValid,
      isTouched: word.isTouched,
      onChange: function onChange(e) {
        return handleChange({
          type: type,
          orderIndex: word.orderIndex,
          event: e,
          actualPhrase: word.actualPhrase
        });
      },
      onBlur: function onBlur() {
        return handleOnBlur(word.orderIndex);
      },
      shouldValidate: word.shouldValidate
    });
  }), ' '), type === PHRASE_TYPES.display && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "copy-desktop"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "copy__text-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "copy__text",
    "data-core-qa": "recoveryPhraseText"
  }, passphrase)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    className: "copy__button",
    text: passphrase,
    onCopy: function onCopy() {
      setIsCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "recoveryPhraseButtonCopy"
  }, isCopied ? 'Copied' : 'Copy'))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
    className: "button copy-mobile",
    text: passphrase,
    onCopy: function onCopy() {
      setIsCopied(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, null, isCopied ? 'Copied' : 'Copy Phrase')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    className: "button",
    onClick: buttonOneCallback
  }, buttonOneText)), type !== PHRASE_TYPES.display && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    onClick: buttonOneCallback
  }, buttonOneText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    className: "button--secondary",
    onClick: handleButtonTwoCallback,
    disabled: !isFormValid
  }, buttonTwoText)));
}
RecoveryPhrase.propTypes = {
  /** A string with three possible options.
   * 1. display - creates a view only version that only shows the phrase
   * 2. enter - creates empyt word boxes that allow for input without validation.
   * 3. enterValidated - creates word boxes that are validated against the known mnemonic
   */
  type: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(PHRASE_TYPES)),
  /** A number defining how many text inputs to render. The default is 12. */
  wordCount: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
  /** word mnemonic for validating the user's entry. Passphrase words should be separated by a space, not a comma.  */
  passphrase: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Component heading. You can pass a string or a node if you want to use html to sytlize the text */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
  /** sub-text below the heading. You can pass a string or a node if you want to use html to sytlize the text */
  subText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
  /** Left Button text */
  buttonOneText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Right button text */
  buttonTwoText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Left Button callback function onClick*/
  buttonOneCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
  /** Right Button callback function onClick*/
  buttonTwoCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired)
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),
/* 188 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 189 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _recoveryPhraseTag_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(190);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_check_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(191);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_check_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_check_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_warning_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(192);
/* harmony import */ var _assets_icons_nerdCoreKit_circle_warning_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_circle_warning_svg__WEBPACK_IMPORTED_MODULE_4__);






var RecoveryPhraseTag = function RecoveryPhraseTag(_ref) {
  var displayOnly = _ref.displayOnly,
    orderIndex = _ref.orderIndex,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    actualPhrase = _ref.actualPhrase,
    inputPhrase = _ref.inputPhrase,
    isTouched = _ref.isTouched,
    isValid = _ref.isValid,
    _ref$shouldValidate = _ref.shouldValidate,
    shouldValidate = _ref$shouldValidate === void 0 ? true : _ref$shouldValidate;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('recovery-phrase-tag', {
      'recovery-phrase-tag--invalid': shouldValidate && !displayOnly && !isValid && isTouched,
      'recovery-phrase-tag--valid': shouldValidate && !displayOnly && isValid && isTouched,
      'recovery-phrase-tag--neutral': !shouldValidate || displayOnly
    })
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "recoveryPhraseTagNumber".concat(orderIndex + 1),
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('order-index', {
      'order-index--invalid': shouldValidate && !displayOnly && !isValid && isTouched,
      'order-index--valid': shouldValidate && !displayOnly && isValid && isTouched
    })
  }, "".concat(orderIndex + 1, ")")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    "data-core-qa": "recoveryPhraseTagInput".concat(orderIndex),
    className: "input",
    readOnly: displayOnly,
    disabled: displayOnly,
    onChange: onChange,
    onBlur: onBlur,
    value: displayOnly ? actualPhrase : inputPhrase,
    autoComplete: "off"
  }), shouldValidate && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "icon-container"
  }, !displayOnly && !isValid && isTouched && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_circle_warning_svg__WEBPACK_IMPORTED_MODULE_4___default()),
    className: "icon"
  }), !displayOnly && isValid && isTouched && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_circle_check_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "icon"
  })));
};
RecoveryPhraseTag.propTypes = {
  /** Index for that specific word in the array */
  orderIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
  /** Mnemonic word from the server */
  actualPhrase: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** User input word */
  inputPhrase: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** Boolean indicating if the mnemonic matches the user's input */
  isValid: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
  /** Boolean indicating the user input a value */
  isTouched: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
  /** Callback function used in the parent component. Please see `ConfirmRecoveryPhrase` in the Related Components above for more details. */
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
  /** Callback function used in the parent component. Please see `ConfirmRecoveryPhrase` in the Related Components above for more details. */
  onBlur: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
  /** Boolean prop used to disable the input field */
  displayOnly: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool.isRequired),
  /** Boolean that disables all green or red visual feedback. Defaults to true */
  shouldValidate: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
/* harmony default export */ __webpack_exports__["default"] = (RecoveryPhraseTag);

/***/ }),
/* 190 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 191 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' fill='green'%3e %3cpath d='m16 4c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12m0-2c-7.73 0-14 6.27-14 14s6.27 14 14 14 14-6.27 14-14-6.27-14-14-14z'/%3e %3cpolygon points='13.87 21.53 8.5 16.16 9.91 14.75 13.87 18.7 21.67 10.9 23.09 12.31'/%3e %3c/svg%3e"

/***/ }),
/* 192 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg height='32' width='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' fill='red'%3e %3cpath d='m16 4c6.62 0 12 5.38 12 12s-5.38 12-12 12-12-5.38-12-12 5.38-12 12-12m0-2c-7.73 0-14 6.27-14 14s6.27 14 14 14 14-6.27 14-14-6.27-14-14-14z'/%3e %3crect x='15.34' y='17.94' width='1.31' height='1.57'/%3e %3cpath d='M24.18,21.95H7.82L16,6.55L24.18,21.95z M10.31,20.45h11.37L16,9.75L10.31,20.45z'/%3e %3crect x='15.34' y='12.91' width='1.31' height='4.24'/%3e %3c/svg%3e"

/***/ }),
/* 193 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SetupProcessing; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_assets_images_ProcessingInfographic_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(194);
/* harmony import */ var _setupProcessing_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(195);




function SetupProcessing(_ref) {
  var _ref$imgSrc = _ref.imgSrc,
    imgSrc = _ref$imgSrc === void 0 ? _components_assets_images_ProcessingInfographic_png__WEBPACK_IMPORTED_MODULE_1__["default"] : _ref$imgSrc,
    processingText = _ref.processingText;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "setupProcessing"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "setupProcessing__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "setupProcessing__loading-img",
    src: imgSrc,
    alt: "Processing Setup",
    title: "Processing Setup"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "setupProcessing__text",
    "data-core-qa": "setupProcessingSubText"
  }, processingText)));
}
SetupProcessing.propTypes = {
  /** Value to pass into the img src attribute. A default image will be used if this prop is not provided */
  imgSrc: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** Text displayed beneath the image */
  processingText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 194 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "5ad430ebb5bc9daaf401d6610b4d3de4.png");

/***/ }),
/* 195 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 196 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _walletCoin_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(197);
/* harmony import */ var _assets_icons_nerdCoreKit_caret_right_small_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(198);
/* harmony import */ var _assets_icons_nerdCoreKit_caret_right_small_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_caret_right_small_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(199);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_3__);





var WalletCoin = function WalletCoin(_ref) {
  var coinSymbol = _ref.coinSymbol,
    clickCallback = _ref.clickCallback,
    coinLogo = _ref.coinLogo,
    coinName = _ref.coinName,
    coinAmt = _ref.coinAmt,
    usd = _ref.usd;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-setup-coinbox",
    onClick: function onClick() {
      return clickCallback(coinSymbol);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "left-coinbox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-setup-coinbox__container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: coinLogo,
    alt: "Coin Logo",
    className: "wallet-setup-coinbox__logo"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-setup-coinbox__name",
    "data-core-qa": "walletCoinName"
  }, coinName)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-setup-coinbox__currency"
  }, usd !== null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletCoinDollar"
  }, usd.toLocaleString('en-US', {
    currency: 'USD',
    style: 'currency'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "walletCoinSymbol"
  }, String(numeral__WEBPACK_IMPORTED_MODULE_3___default()(coinAmt).format('0.[00000]a')).toUpperCase(), " ", coinSymbol))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_nerdCoreKit_caret_right_small_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "wallet-setup-coinbox__right-arrow"
  }));
};
WalletCoin.propTypes = {
  /** Wallet coin symbol (eg. Etherium is ETH) */
  coinSymbol: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Callback function on click of anywhere in the div */
  clickCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Number displays to the sixth decimal point*/
  coinAmt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
  /** Logo icon set to be round and 36px*/
  coinLogo: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
  /** Wallet Coin name */
  coinName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** USD equivalent conversion amount displays $ and to 2 decimal places */
  usd: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};
/* harmony default export */ __webpack_exports__["default"] = (WalletCoin);

/***/ }),
/* 197 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 198 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cg id='icons'%3e%3cg id='Actions'%3e%3cg id='Navigation'%3e%3cg%3e%3cpolygon points='12 8 22 16 12 24 12 8'/%3e%3crect id='_Transparent_Rectangle_' class='cls-1' width='32' height='32'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e"

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 200 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _WalletCoin_WalletCoin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(196);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
/* harmony import */ var _walletSetup_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(201);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





var WalletSetup = function WalletSetup(_ref) {
  var walletName = _ref.walletName,
    isLoading = _ref.isLoading,
    setupButtonCallback = _ref.setupButtonCallback,
    clickCallback = _ref.clickCallback,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Set Up' : _ref$buttonText,
    _ref$walletItems = _ref.walletItems,
    walletItems = _ref$walletItems === void 0 ? [] : _ref$walletItems,
    hasError = _ref.hasError,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? 'Error Loading Wallet Data - Please Refresh the page' : _ref$errorMessage;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-setup flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "wallet-setup__heading",
    "data-core-qa": "walletSetupTitleText"
  }, walletName), isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "wallet-setup__button",
    "data-core-qa": "walletSetupLoadingText"
  }, "Loading...") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, hasError ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "wallet-setup__error",
    "data-core-qa": "walletSetupErrorText"
  }, errorMessage) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, (walletItems === null || walletItems === void 0 ? void 0 : walletItems.length) === 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    "data-core-qa": "walletSetupButtonSetupWallet",
    className: "wallet-setup__button",
    onClick: setupButtonCallback,
    kind: "solid"
  }, buttonText)))), (walletItems === null || walletItems === void 0 ? void 0 : walletItems.length) > 0 && !isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-coin-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet-coin-wrapper__coin-wrapper"
  }, walletItems.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_WalletCoin_WalletCoin__WEBPACK_IMPORTED_MODULE_1__["default"], _extends({
      key: item.coinName,
      clickCallback: clickCallback
    }, item));
  }))));
};
WalletSetup.propTypes = {
  /** Component heading displayed to the left side */
  walletName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Boolean state to handle pending api call */
  isLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
  /** Callback function called onClick on button shown when user has no wallet */
  setupButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Callback passed to the `WalletCoin` */
  clickCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Text displayed on the button when the user does not have wallet data */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Boolean used to show error message */
  hasError: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** Text displayed when hasError is true */
  errorMessage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Array of wallet objects passed to `WalletCoin`. Please see `WalletCoin` in Related Components for more information. */
  walletItems: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    coinSymbol: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    coinAmt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    coinLogo: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
    coinName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    usd: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  }))
};
/* harmony default export */ __webpack_exports__["default"] = (WalletSetup);

/***/ }),
/* 201 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 202 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AddMoreETH; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _addMoreETH_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(203);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
var _excluded = ["wallet", "handleDoneCallback", "headerText", "bodyText", "bodyTextSecond"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function AddMoreETH(_ref) {
  var wallet = _ref.wallet,
    handleDoneCallback = _ref.handleDoneCallback,
    headerText = _ref.headerText,
    bodyText = _ref.bodyText,
    bodyTextSecond = _ref.bodyTextSecond,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "addMoreETH"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "messageHeader",
    title: "headerText",
    "data-core-qa": "addETHTitleText"
  }, headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "messageText",
    title: "bodyText",
    "data-core-qa": "addETHTitleSubText"
  }, bodyText), bodyTextSecond && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "messageText",
    title: "bodyTextSecond",
    "data-core-qa": "addETHBodyText"
  }, bodyTextSecond), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "wallet"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Wallet, {
    wallet: wallet,
    qrCode: true
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "buttonRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    "data-core-qa": "addETHButtonConfirm",
    className: "button",
    type: "button",
    onClick: handleDoneCallback,
    kind: "solid"
  }, "Done")));
}
AddMoreETH.propTypes = {
  /** The wallet object of the user. */
  wallet: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object.isRequired),
  /** What happens when the user presses done. */
  handleDoneCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** The header text. */
  headerText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** The body text of paragraph 1.*/
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The body text of paragraph 2. */
  bodyTextSecond: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 203 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 204 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AuthorizeTransaction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _CancelOrderConfirmation_CancelOrderConfirmation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(205);
/* harmony import */ var _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(207);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var _DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _authorizeTransaction_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(213);
var _excluded = ["humanReadableTimeLimit", "timerStartDate", "timerEndDate", "brandImage", "brandName", "productList", "gasFee", "orderTotal", "cancelOrderCallback", "authorizePaymentCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







function AuthorizeTransaction(_ref) {
  var humanReadableTimeLimit = _ref.humanReadableTimeLimit,
    timerStartDate = _ref.timerStartDate,
    timerEndDate = _ref.timerEndDate,
    brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    productList = _ref.productList,
    gasFee = _ref.gasFee,
    orderTotal = _ref.orderTotal,
    cancelOrderCallback = _ref.cancelOrderCallback,
    authorizePaymentCallback = _ref.authorizePaymentCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCancelOrderConfirmation = _useState2[0],
    setShowCancelOrderConfirmation = _useState2[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "authorizeTransaction"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "authorizeTransaction__header",
    "data-core-qa": "authTransTitleText"
  }, "Authorize Transaction"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "authorizeTransaction__subHeader",
    "data-core-qa": "authTransTitleSubText"
  }, "You have ", humanReadableTimeLimit, " with your price locked in. Review your order summary below before sending funds to purchase."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "authorizeTransaction__timerWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_4__["default"], {
    timerStartDate: timerStartDate,
    timerEndDate: timerEndDate
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"], {
    brandImage: brandImage,
    brandName: brandName,
    productList: productList,
    gasFee: gasFee,
    orderTotal: orderTotal,
    className: "authorizeTransaction__productSummary"
  }), showCancelOrderConfirmation ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_CancelOrderConfirmation_CancelOrderConfirmation__WEBPACK_IMPORTED_MODULE_1__["default"], {
    dontCancelOrderCallback: function dontCancelOrderCallback() {
      return setShowCancelOrderConfirmation(false);
    },
    cancelOrderCallback: cancelOrderCallback
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "authorizeTransaction__buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "authTransButtonSubmit",
    className: "authorizeTransaction__button authorizeTransaction__submitButton",
    onClick: authorizePaymentCallback,
    type: "submit",
    kind: "solid"
  }, "Authorize Payment From Brand Wallet"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "authTransButtonCancel",
    className: "authorizeTransaction__button authorizeTransaction__cancelButton",
    onClick: function onClick() {
      return setShowCancelOrderConfirmation(true);
    },
    kind: "outlined"
  }, "Cancel Order")));
}
AuthorizeTransaction.propTypes = {
  /** A human readable time such as "10 minutes". This is used in the subtext underneath the heading */
  humanReadableTimeLimit: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** This is passed to these children components: CircleTimer */
  timerStartDate: _DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_4__["default"].propTypes.timerStartDate,
  /** This is passed to these children components: CircleTimer */
  timerEndDate: _DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_4__["default"].propTypes.timerEndDate,
  /** This is passed to these children components: ProductSummary */
  brandImage: _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.brandImage,
  /** This is passed to these children components: ProductSummary */
  brandName: _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.brandName,
  /** This is passed to these children components: ProductSummary */
  productList: _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.productList,
  /** This is passed to these children components: ProductSummary */
  gasFee: _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.gasFee,
  /** This is passed to these children components: ProductSummary */
  orderTotal: _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.orderTotal,
  /** This is passed to these children components: CancelOrderConfirmation */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** Callback function that is called when the Authorize Payment button is pressed */
  authorizePaymentCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};

/***/ }),
/* 205 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CancelOrderConfirmation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
/* harmony import */ var _cancelOrderConfirmation_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(206);
var _excluded = ["dontCancelOrderCallback", "cancelOrderCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function CancelOrderConfirmation(_ref) {
  var dontCancelOrderCallback = _ref.dontCancelOrderCallback,
    cancelOrderCallback = _ref.cancelOrderCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "cancelOrderConfirmation"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "cancelOrderHeader",
    "data-core-qa": "cancelConfTitleText"
  }, "Cancel Order"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "cancelOrderText",
    "data-core-qa": "cancelConfTitleSubText"
  }, "If you cancel your order you aren't guaranteed that your price is locked in. Do you want to cancel this order?"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    "data-core-qa": "cancelConfButtonBack",
    className: "button dontCancelOrderButton",
    onClick: dontCancelOrderCallback,
    type: "submit"
  }, "No, Don't Cancel My Order"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_1__["default"], {
    "data-core-qa": "cancelConfButtonConfirm",
    className: "button cancelOrderButton",
    onClick: cancelOrderCallback,
    type: "button",
    kind: "outlined"
  }, "Yes, Cancel My Order")));
}
CancelOrderConfirmation.propTypes = {
  /** called when don't cancel is clicked */
  dontCancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** called when yes cancel is clicked */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired)
};

/***/ }),
/* 206 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 207 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProductSummary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_nerdCoreKit_ShoppingCartPlusIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(208);
/* harmony import */ var _ProductSummaryListing_ProductSummaryListing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(209);
/* harmony import */ var _productSummary_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212);
var _excluded = ["productSummaryText", "brandImage", "brandName", "productList", "gasFee", "orderTotal", "shoppingFormText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function ProductSummary(_ref) {
  var _productList$;
  var productSummaryText = _ref.productSummaryText,
    brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    productList = _ref.productList,
    gasFee = _ref.gasFee,
    orderTotal = _ref.orderTotal,
    shoppingFormText = _ref.shoppingFormText,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "productSummary"
  }, rest), productList.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ol", {
    className: "productSummary__table productSummary__dividerBottom"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "productSummary__row productSummary__row--heading productSummary__dividerBottom"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--2",
    "data-core-qa": "productSummaryHeading1"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.descriptionHeading) || 'Description'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--3",
    "data-core-qa": "productSummaryHeading2"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.quantityHeading) || 'Quantity')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--4",
    "data-core-qa": "productSummaryHeading3"
  }, (_productList$ = productList[0]) === null || _productList$ === void 0 ? void 0 : _productList$.currencyCode, ' ', (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.currencyHeading) || 'Amount'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--5",
    "data-core-qa": "productSummaryHeading4"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.coinHeading) || 'ETH Amount'))), productList.map(function (product) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ProductSummaryListing_ProductSummaryListing__WEBPACK_IMPORTED_MODULE_2__["default"], {
      key: product.id,
      brandName: brandName,
      brandImage: brandImage,
      product: product
    });
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "productSummary__row productSummary__row--gas"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--2",
    "data-core-qa": "productSummaryTitleGas"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.feeDesc) || 'Gas Fee'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--3"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--4",
    "data-core-qa": "productSummaryGasUSD"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.denomination) || 'USD', ' ', gasFee.USD.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--5",
    "data-core-qa": "productSummaryGasCoin"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.coin) || 'ETH', " ", gasFee.ETH))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "productSummary__row productSummary__row--total"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--2",
    "data-core-qa": "productSummaryTitleTotal"
  }, "Total"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--3",
    "data-core-qa": "productSummaryTotalQty"
  }, "Qty ", orderTotal.totalQuantity.toLocaleString(), ' ')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__group productSummary__group--2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--4",
    "data-core-qa": "productSummaryTotalUSD"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.denomination) || 'USD', ' ', orderTotal.totalCurrency.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__cell productSummary__cell--5",
    "data-core-qa": "productSummaryTotalCoin"
  }, (productSummaryText === null || productSummaryText === void 0 ? void 0 : productSummaryText.coin) || 'ETH', " ", orderTotal.totalETH.toFixed(5))))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__shoppingMessageWrap"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_ShoppingCartPlusIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
    className: "productSummary__shoppingIcon"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummary__shoppingMessage",
    "data-core-qa": "productSummaryEmptyCartText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.orderCartEmptyText) || 'Looks like you have not added anything to your cart yet')));
}
ProductSummary.propTypes = {
  /** Customizable form text for order line items */
  productSummaryText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    descriptionHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    quantityHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    currencyHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    coinHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    feeDesc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    denomination: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    coin: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** This is passed to the child component `ProductSummaryListing` (See Related Components section above) */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
  /** This is passed to the child component `ProductSummaryListing` (See Related Components section above) */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** The `currencyCode` attribute of the first element in this array is used to populate the header for one of the columns, and then each product in this list is passed as a prop to the child component `ProductSummaryListing` (see Related Components section above) */
  productList: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(_ProductSummaryListing_ProductSummaryListing__WEBPACK_IMPORTED_MODULE_2__["default"].propTypes.product),
  /** These values are used to display the gas fee estimate on the form */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  }),
  /** These values are used to display the order total on the form */
  orderTotal: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    currencyCode: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** If there are not objects in the `productList` array prop, this message will show instead to indicate to the user that their cart is empty. If no message is provided, a default one will be used. */
  shoppingFormText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    orderCartEmptyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  })
};

/***/ }),
/* 208 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ShoppingCartPlusIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["color", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function ShoppingCartPlusIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    "aria-hidden": "true"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
  }));
}
ShoppingCartPlusIcon.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};

/***/ }),
/* 209 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ProductSummaryListing; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_icons_logos_nerd_logo_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(210);
/* harmony import */ var _productSummaryListing_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(211);




function ProductSummaryListing(_ref) {
  var brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    product = _ref.product;
  var logoImage = brandImage || _assets_icons_logos_nerd_logo_png__WEBPACK_IMPORTED_MODULE_1__["default"];
  var productCurrency = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _product$totalCurrenc, _product$totalUSD;
    return ((_product$totalCurrenc = product.totalCurrency) === null || _product$totalCurrenc === void 0 ? void 0 : _product$totalCurrenc.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })) || ((_product$totalUSD = product.totalUSD) === null || _product$totalUSD === void 0 ? void 0 : _product$totalUSD.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    }));
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    className: "productSummaryListing productSummaryListing__row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__cell productSummaryListing__cell--1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "productSummaryListing__brandLogo",
    src: logoImage,
    alt: "brand logo"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__group productSummaryListing__group--1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__cell productSummaryListing__cell--2",
    "data-core-qa": "prodSumListProduct"
  }, brandName, " ", product.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__cell productSummaryListing__cell--3",
    "data-core-qa": "prodSumListQuantity"
  }, "Qty ", product.purchaseQuantity)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__group productSummaryListing__group--2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__cell productSummaryListing__cell--4",
    "data-core-qa": "prodSumListUSD"
  }, product.currencyCode, " ", productCurrency), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "productSummaryListing__cell productSummaryListing__cell--5",
    "data-core-qa": "prodSumListCoin"
  }, "ETH ", product.totalETH.toFixed(5))));
}
ProductSummaryListing.propTypes = {
  /** This is the icon that will show up on the product listing. If no image is provided, this will default to the Nerd logo */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any),
  /** This shows up as part of the product name */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Details of the product */
  product: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    purchaseQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    currencyCode: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    totalUSD: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
  })
};

/***/ }),
/* 210 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "246711abbcb178df02aeb2b092c6dd7b.png");

/***/ }),
/* 211 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 212 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 213 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 214 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _checkoutSteps_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(215);
/* harmony import */ var _assets_icons_logos_brands_tokens_ethereum_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(216);
/* harmony import */ var _assets_icons_logos_brands_tokens_ethereum_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_logos_brands_tokens_ethereum_svg__WEBPACK_IMPORTED_MODULE_3__);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





var CheckoutSteps = function CheckoutSteps(_ref) {
  var brandLogo = _ref.brandLogo,
    brandName = _ref.brandName,
    cancelOrderCallback = _ref.cancelOrderCallback,
    confirmationGoToDashboardCallback = _ref.confirmationGoToDashboardCallback,
    confirmationText = _ref.confirmationText,
    etherScanData = _ref.etherScanData,
    gasFee = _ref.gasFee,
    indexProvided = _ref.indexProvided,
    invoice = _ref.invoice,
    lockInPriceBodyText = _ref.lockInPriceBodyText,
    lockInPriceImgSrc = _ref.lockInPriceImgSrc,
    lockInPriceTitleText = _ref.lockInPriceTitleText,
    orderTotal = _ref.orderTotal,
    orderSummaryText = _ref.orderSummaryText,
    processOrderText = _ref.processOrderText,
    processOrderImageSource = _ref.processOrderImageSource,
    processOrderHandleGoToDashboard = _ref.processOrderHandleGoToDashboard,
    processOrderHandleShowStatus = _ref.processOrderHandleShowStatus,
    productSummaryText = _ref.productSummaryText,
    reviewOrderBodyText = _ref.reviewOrderBodyText,
    reviewOrderContinueButtonText = _ref.reviewOrderContinueButtonText,
    reviewOrderCancelOrderButtonText = _ref.reviewOrderCancelOrderButtonText,
    reviewOrderInfoIconText = _ref.reviewOrderInfoIconText,
    reviewOrderTitleText = _ref.reviewOrderTitleText,
    stepIcons = _ref.stepIcons,
    steps = _ref.steps,
    _ref$submitOrderLoadi = _ref.submitOrderLoading,
    submitOrderLoading = _ref$submitOrderLoadi === void 0 ? false : _ref$submitOrderLoadi,
    submitOrderCallback = _ref.submitOrderCallback,
    submitOrderImgSrc = _ref.submitOrderImgSrc,
    submitOrderFormText = _ref.submitOrderFormText,
    timerEndedCancelModalBodyText = _ref.timerEndedCancelModalBodyText,
    timerEndedCancelModalButtonCallback = _ref.timerEndedCancelModalButtonCallback,
    timerEndedCancelModalButtonText = _ref.timerEndedCancelModalButtonText,
    timerEndedCancelModalTitleText = _ref.timerEndedCancelModalTitleText,
    wallet = _ref.wallet,
    wrongPassCodeError = _ref.wrongPassCodeError,
    passcodeInputOnChangeCallback = _ref.passcodeInputOnChangeCallback;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(indexProvided),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    timerStartDate = _useState4[0],
    setTimerStartDate = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    timerEndDate = _useState6[0],
    setTimerEndDate = _useState6[1];
  var progressSteps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return steps || [{
      label: 'Lock In Price'
    }, {
      label: 'Review Order'
    }, {
      label: 'Submit Order'
    }, {
      label: 'Process Order'
    }, {
      label: 'Confirmation'
    }];
  });
  function handleSubmitOrder(passCode) {
    return submitOrderCallback(passCode);
  }
  var confirmationOrderDate = etherScanData.licenseGrantedAt;
  var confirmationPaymentType = '$US/ETH';
  var confirmationWalletLogo = (_assets_icons_logos_brands_tokens_ethereum_svg__WEBPACK_IMPORTED_MODULE_3___default());
  var confirmationWalletText = "".concat(brandName, " Wallet - ETH");
  var confirmationOrderNumber = etherScanData.referenceOrderId;
  var confirmationTransactionHash = etherScanData.txnHash;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setCurrentIndex(indexProvided);
  }, [indexProvided]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var startDate = new Date(invoice.createdAt);
    var endDate = new Date(invoice.expiresAt);
    setTimerStartDate(startDate);
    setTimerEndDate(endDate);
  }, [invoice.createdAt, invoice.expiresAt]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "checkout-steps"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "checkout-steps__progress-indicator"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ProgressIndicator, {
    steps: progressSteps,
    currentIndex: currentIndex,
    stepIcons: stepIcons
  })), currentIndex === 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.LockInPrice, {
    bodyText: lockInPriceBodyText,
    imgSrc: lockInPriceImgSrc,
    titleText: lockInPriceTitleText
  }), currentIndex === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ReviewOrder, {
    bodyText: reviewOrderBodyText,
    brandLogo: brandLogo,
    brandName: brandName,
    cancelOrderButtonText: reviewOrderCancelOrderButtonText,
    cancelOrderCallback: cancelOrderCallback,
    continueButtonText: reviewOrderContinueButtonText,
    continueCallback: function continueCallback() {
      return setCurrentIndex(2);
    },
    gasFee: gasFee,
    infoIconText: reviewOrderInfoIconText,
    orderTotal: orderTotal,
    productList: invoice.lineItems,
    timerEndDate: timerEndDate,
    timerEndedCancelModalBodyText: timerEndedCancelModalBodyText,
    timerEndedCancelModalButtonCallback: timerEndedCancelModalButtonCallback,
    timerEndedCancelModalButtonText: timerEndedCancelModalButtonText,
    timerEndedCancelModalTitleText: timerEndedCancelModalTitleText,
    timerStartDate: timerStartDate,
    titleText: reviewOrderTitleText
  }), currentIndex === 2 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.SubmitOrder, {
    brandName: brandName,
    cancelOrderCallback: cancelOrderCallback,
    fromAddress: wallet.id,
    gasFee: gasFee,
    imageSrc: submitOrderImgSrc,
    submitOrderLoading: submitOrderLoading,
    submitOrderCallback: handleSubmitOrder,
    submitOrderFormText: submitOrderFormText,
    timerEndDate: timerEndDate,
    timerEndedCancelModalButtonCallback: timerEndedCancelModalButtonCallback,
    timerStartDate: timerStartDate,
    toAddress: invoice.invoiceETHAddress,
    totals: orderTotal,
    wrongPassCodeError: wrongPassCodeError,
    passcodeInputOnChangeCallback: passcodeInputOnChangeCallback
  }), currentIndex === 3 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ProcessOrder, {
    processOrderText: processOrderText,
    imageSource: processOrderImageSource,
    handleGoToDashboardCallback: processOrderHandleGoToDashboard,
    handleShowStatusCallback: processOrderHandleShowStatus
  }), currentIndex === 4 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Confirmation, {
    confirmationText: confirmationText,
    productSummaryText: productSummaryText,
    orderSummaryText: orderSummaryText,
    goToDashboardCallback: confirmationGoToDashboardCallback,
    orderDate: confirmationOrderDate,
    paymentType: confirmationPaymentType,
    walletLogo: confirmationWalletLogo,
    walletText: confirmationWalletText,
    orderNumber: confirmationOrderNumber,
    transactionHash: confirmationTransactionHash,
    brandImage: brandLogo,
    brandName: brandName,
    productList: invoice.lineItems,
    gasFee: gasFee,
    orderTotal: orderTotal,
    transactionLink: processOrderHandleShowStatus
  }));
};
CheckoutSteps.propTypes = {
  /** This is passed to these children components: ReviewOrder, Confirmation - Please see these components in the Related Components section above for more details */
  brandLogo: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
  /** This is passed to these children components: ReviewOrder, SubmitOrder, Confirmation - Please see these components in the Related Components section above for more details */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** This is passed to these children components: ReviewOrder, SubmitOrder - Please see these components in the Related Components section above for more details */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** This is passed to these children components: Confirmation - Please see these components in the Related Components section above for more details */
  confirmationGoToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Customizable text for confirmation page - Please see these components in the Related Components section above for more details */
  confirmationText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    header: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    dashboardTaskHeader: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    downloadIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    downloadText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    rewardsIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    manageRewardsText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Customizable text for headings and link - Please see these components in the Related Components section above for more details */
  orderSummaryText: {
    dateHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    walletHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    orderHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    txnHashHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    etherscanHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    etherscanLink: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  },
  /** Customizable form text for order line items - Please see these components in the Related Components section above for more details */
  productSummaryText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    descriptionHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    quantityHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    currencyHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    coinHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    feeDesc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    denomination: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    coin: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Values from this object are passed to these children components: Confirmation - Please see these components in the Related Components section above for more details */

  etherScanData: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    licenseGrantedAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    referenceOrderId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    txnHash: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired)
  }),
  /** This is passed to these children components: ReviewOrder, SubmitOrder, Confirmation - Please see these components in the Related Components section above for more details */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  }),
  /** This determines which checkout step will show. Each step shows a different part of the checkout process. This component also utilizes a local state variable to automatically move through the steps when appropriate. */
  indexProvided: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
  /** The dates in this object are used to populate the timer on the ReviewOrder screen. The `invoiceETHAddress` attribute is passed as the `toAddress` to the SubmitOrder screen. The `lineItems` array is passed to both the ReviewOrder and Confirmation pages as the `productList` prop. Please see all of those components in the Related Components section above for more details */
  invoice: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    createdAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    expiresAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    fulfilledAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    invoiceETHAddress: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    lineItems: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
      createdAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
      id: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
      invoiceId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
      productId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
      qty: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
      totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
      totalUSD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
      updatedAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
    })),
    memberId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    paidAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    referenceOrderId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    updatedAt: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Passed to the LockInPrice component as the bodyText prop. Please see that component in the Related Components section above for more details. */
  lockInPriceBodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the LockInPrice component as the imgSrc prop. Please see that component in the Related Components section above for more details. */
  lockInPriceImgSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
  /** Passed to the LockInPrice component as the titleText prop. Please see that component in the Related Components section above for more details. */
  lockInPriceTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder and Confirmation components as the orderTotal prop. Passed to the SubmitOrder component as the totals prop. Please see those components in the Related Components section above for more details. */
  orderTotal: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    currencyCode: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }).isRequired,
  /** Passed to the ProcessOrder component. Please see that component in the Related Components section above for more details. */
  processOrderText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodySubText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    goToDashboardButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Passed to the ProcessOrder component as the imageSource prop. Please see that component in the Related Components section above for more details. */
  processOrderImageSource: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
  /** Passed to the ProcessOrder component as the handleGoToDashboard prop. Please see that component in the Related Components section above for more details. */
  processOrderHandleGoToDashboard: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Passed to the ProcessOrder component as the handleShowStatus prop and to the Confirmation component as the transactionLink prop. Please see those components in the Related Components section above for more details. */
  processOrderHandleShowStatus: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Passed to the ReviewOrder component as the bodyText prop. Please see that component in the Related Components section above for more details. */
  reviewOrderBodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component as the cancelOrderButtonText prop. Please see that component in the Related Components section above for more details. */
  reviewOrderCancelOrderButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component as the continueButtonText prop. Please see that component in the Related Components section above for more details. */
  reviewOrderContinueButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component as the infoIconText prop. Please see that component in the Related Components section above for more details. */
  reviewOrderInfoIconText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component as the titleText prop. Please see that component in the Related Components section above for more details. */
  reviewOrderTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ProgressIndicator component as the stepIcons prop. Please see that component in the Related Components section above for more details. */
  stepIcons: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    uncompletedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    currentStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    completedStepIcon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
  }),
  /** Passed to the ProgressIndicator component as the steps prop. Please see the ProgressIndicator component in the Related Components section above for more details about how this is used in that component. If no value is provided for this prop, a default value will be used. */
  steps: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    label: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired)
  })),
  /** Passed to the SubmitOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  submitOrderLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** Passed to the SubmitOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  submitOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Passed to the SubmitOrder component as the ImgSrc prop. Please see that component in the Related Components section above for more details about how this is used. */
  submitOrderImgSrc: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
  //** Props to allow text customization of submit order form */
  submitOrderFormText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toolTip: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    submitButton: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    cancelButton: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Passed to the ReviewOrder & SubmitOrder components. Please see those components in the Related Components section above for more details about how this is used. */
  timerEndedCancelModalButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Passed to the ReviewOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  timerEndedCancelModalBodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  timerEndedCancelModalButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Passed to the ReviewOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  timerEndedCancelModalTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** The id from this object is passed to the SubmitOrder component as the fromAddress prop. Please see that component in the Related Components section above for more details about how this is used. */
  wallet: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalUSD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    valid: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
  }),
  /** The id from this object is passed to the SubmitOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  wrongPassCodeError: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** The id from this object is passed to the SubmitOrder component. Please see that component in the Related Components section above for more details about how this is used. */
  passcodeInputOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (CheckoutSteps);

/***/ }),
/* 215 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 216 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 225'%3e%3cimage width='225' height='225' xlink:href='data:image/png;base64,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'/%3e%3c/svg%3e"

/***/ }),
/* 217 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Confirmation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ConfirmationMessage_ConfirmationMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(218);
/* harmony import */ var _Feedback_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22);
/* harmony import */ var _ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(207);
/* harmony import */ var _confirmation_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(221);
var _excluded = ["goToDashboardCallback", "confirmationText", "orderSummaryText", "productSummaryText", "orderDate", "paymentType", "walletLogo", "walletText", "orderNumber", "transactionHash", "brandImage", "brandName", "productList", "gasFee", "orderTotal", "transactionLink"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function Confirmation(_ref) {
  var goToDashboardCallback = _ref.goToDashboardCallback,
    confirmationText = _ref.confirmationText,
    orderSummaryText = _ref.orderSummaryText,
    productSummaryText = _ref.productSummaryText,
    orderDate = _ref.orderDate,
    paymentType = _ref.paymentType,
    walletLogo = _ref.walletLogo,
    walletText = _ref.walletText,
    orderNumber = _ref.orderNumber,
    transactionHash = _ref.transactionHash,
    brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    productList = _ref.productList,
    gasFee = _ref.gasFee,
    orderTotal = _ref.orderTotal,
    transactionLink = _ref.transactionLink,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "confirmation"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ConfirmationMessage_ConfirmationMessage__WEBPACK_IMPORTED_MODULE_1__["default"], {
    confirmationText: confirmationText,
    goToDashboardCallback: goToDashboardCallback
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", {
    className: "confirmationHr"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Feedback_OrderSummary_OrderSummary__WEBPACK_IMPORTED_MODULE_2__["default"], {
    orderSummaryText: orderSummaryText,
    orderDate: orderDate,
    paymentType: paymentType,
    walletLogo: walletLogo,
    walletText: walletText,
    orderNumber: orderNumber,
    transactionHash: transactionHash,
    transactionLink: transactionLink
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ProductSummary_ProductSummary__WEBPACK_IMPORTED_MODULE_3__["default"], {
    productSummaryText: productSummaryText,
    brandImage: brandImage,
    brandName: brandName,
    productList: productList,
    gasFee: gasFee,
    orderTotal: orderTotal
  }));
}
Confirmation.propTypes = {
  /** Customizable text for confirmation page - Please see these components in the Related Components section above for more details */
  confirmationText: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    header: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    dashboardTaskHeader: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    downloadIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    downloadText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    rewardsIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    manageRewardsText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  }),
  /** Customizable text for headings and link - Please see these components in the Related Components section above for more details */
  orderSummaryText: {
    dateHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    paymentHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    walletHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    orderHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    txnHashHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    etherscanHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    etherscanLink: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  },
  /** Customizable form text for order line items - Please see these components in the Related Components section above for more details */
  productSummaryText: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    descriptionHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    quantityHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    currencyHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    coinHeading: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    feeDesc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    denomination: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    coin: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  }),
  /** This prop is passed to the `ConfirmationMessage` component, please see that component in the `Related Components` section for more details */
  goToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  orderDate: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  paymentType: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  walletLogo: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  walletText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  orderNumber: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  transactionHash: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `OrderSummary` component, please see that component in the `Related Components` section for more details */
  transactionLink: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
  /** This prop is passed to the `ProductSummary` component, please see that component in the `Related Components` section for more details */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
  /** This prop is passed to the `ProductSummary` component, please see that component in the `Related Components` section for more details */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
  /** This prop is passed to the `ProductSummary` component, please see that component in the `Related Components` section for more details */
  productList: prop_types__WEBPACK_IMPORTED_MODULE_5___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    purchaseQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    currentCode: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number)
  })),
  /** This prop is passed to the `ProductSummary` component, please see that component in the `Related Components` section for more details */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number)
  }),
  /** This prop is passed to the `ProductSummary` component, please see that component in the `Related Components` section for more details */
  orderTotal: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    currencyCode: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  })
};

/***/ }),
/* 218 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ConfirmationMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(111);
/* harmony import */ var _assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_nerdCoreKit_rewards_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(219);
/* harmony import */ var _assets_icons_nerdCoreKit_rewards_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_nerdCoreKit_rewards_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var _confirmationMessage_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);
var _excluded = ["confirmationText", "goToDashboardCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function ConfirmationMessage(_ref) {
  var confirmationText = _ref.confirmationText,
    goToDashboardCallback = _ref.goToDashboardCallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "confirmationMessage"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "confirmationMessageHeader",
    "data-core-qa": "confirmMessageTitleText"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.header) || 'Congratulations, your purchase is complete!'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "confirmationMessageText",
    "data-core-qa": "confirmMessageTitleSubText"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.message) || 'Please check your email for a confirmation of your purchase. A copy is available for your records.'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "confirmationMessageText",
    "data-core-qa": "confirmMessageDashboardText"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.dashboardTaskHeader) || 'You can now go to the dashboard to:'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow actionTextRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "iconBackground"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "icon",
    src: (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.downloadIconSrc) || (_assets_icons_fontawesome_arrow_down_to_bracket_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    alt: "download"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "confirmationMessageText",
    "data-core-qa": "confirmMessageDownloadText"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.downloadText) || 'Download your new nodes')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow actionTextRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "iconBackground"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "icon",
    src: (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.rewardsIconSrc) || (_assets_icons_nerdCoreKit_rewards_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    alt: "rewards"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "confirmationMessageText",
    "data-core-qa": "confirmMessageRewardsText"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.manageRewardsText) || 'Manage your rewards')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    className: "dashboardButton",
    type: "button",
    onClick: goToDashboardCallback,
    "data-core-qa": "confirmMessageButtonConfirm"
  }, (confirmationText === null || confirmationText === void 0 ? void 0 : confirmationText.buttonText) || 'Go To Dashboard'));
}
ConfirmationMessage.propTypes = {
  /** Customizable text for confirmation page */
  confirmationText: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    header: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    message: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    dashboardTaskHeader: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    downloadIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    downloadText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    rewardsIconSrc: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    manageRewardsText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
  }),
  /** Called when the button is clicked */
  goToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired)
};

/***/ }),
/* 219 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:%23010101;%7d.cls-2%7bfill:none;%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M16,6.52l2.76,5.58.46,1,1,.15,6.16.89L22,18.44l-.75.73.18,1,1.05,6.13-5.51-2.89L16,23l-.93.49L9.56,26.34l1-6.13.18-1L10,18.44,5.58,14.09l6.16-.89,1-.15.46-1L16,6.52M16,2l-4.55,9.22L1.28,12.69l7.36,7.18L6.9,30,16,25.22,25.1,30,23.36,19.87l7.36-7.17L20.55,11.22Z'/%3e%3crect id='_Transparent_Rectangle_' data-name='&lt;Transparent Rectangle&gt;' class='cls-2' width='32' height='32'/%3e%3c/svg%3e"

/***/ }),
/* 220 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 221 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 222 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NodeAgreementsInitialsInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _initialsAgreement_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(223);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




function NodeAgreementsInitialsInput(_ref) {
  var checkboxId = _ref.checkboxId,
    checkboxLabel = _ref.checkboxLabel,
    _ref$checkboxOnChange = _ref.checkboxOnChangeCallback,
    checkboxOnChangeCallback = _ref$checkboxOnChange === void 0 ? function () {} : _ref$checkboxOnChange,
    _ref$clearButtonText = _ref.clearButtonText,
    clearButtonText = _ref$clearButtonText === void 0 ? 'Clear' : _ref$clearButtonText,
    _ref$initialsChangedC = _ref.initialsChangedCallback,
    initialsChangedCallback = _ref$initialsChangedC === void 0 ? function () {} : _ref$initialsChangedC,
    initialsInputId = _ref.initialsInputId;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    initialsData = _useState4[0],
    setInitialsData = _useState4[1];
  var handleUpdateCheckbox = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (newValue) {
    setIsChecked(newValue);
    checkboxOnChangeCallback(newValue);
  }, [checkboxOnChangeCallback]);
  var updateInitialsData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (newValue) {
    setInitialsData(newValue);
    initialsChangedCallback(newValue);
  }, [setInitialsData, initialsChangedCallback]);
  var clearInitials = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return updateInitialsData('');
  }, [updateInitialsData]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "initials-agreement"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow initials-agreement-checkbox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Checkbox, {
    "data-core-qa": "initialsAgreementCheckbox".concat(initialsInputId),
    id: checkboxId,
    labelText: checkboxLabel,
    labelClassName: "initials-agreement-checkbox__label",
    value: isChecked,
    handleOnChangeCallback: function handleOnChangeCallback(e) {
      return handleUpdateCheckbox(e.target.checked);
    },
    title: "initialsAgreementCheckbox"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexRow initials-agreement-input"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    "data-core-qa": "initialsAgreementInput".concat(initialsInputId),
    type: "text",
    id: initialsInputId,
    title: "initialsInput",
    className: "initials-agreement-input__input",
    placeholder: "Initials *",
    value: initialsData,
    onChange: function onChange(e) {
      return updateInitialsData(e.target.value);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "initialsAgreementButtonClear".concat(initialsInputId),
    className: "initials-agreement-input__clear",
    onClick: clearInitials,
    title: "clearInitialsButton"
  }, clearButtonText)));
}
NodeAgreementsInitialsInput.propTypes = {
  /** An optional html element id to be applied to the checkbox */
  checkboxId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** Text that will show up next to the checkbox */
  checkboxLabel: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** Callback function that will be called anytime the checkbox changes */
  checkboxOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** Text that will show on the button that clears the initials input */
  clearButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Callback function that will be called anytime the initials input changes */
  initialsChangedCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** optional html element id that will be applied to the initials input */
  initialsInputId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /** optional className that will be applied to the checkbox label */
  labelClassName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 223 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 224 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lockInPrice_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(225);
/* harmony import */ var _components_assets_images_LoadingScreenGraphic_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(226);




var LockInPrice = function LockInPrice(_ref) {
  var _ref$imgSrc = _ref.imgSrc,
    imgSrc = _ref$imgSrc === void 0 ? _components_assets_images_LoadingScreenGraphic_png__WEBPACK_IMPORTED_MODULE_2__["default"] : _ref$imgSrc,
    _ref$titleText = _ref.titleText,
    titleText = _ref$titleText === void 0 ? 'Lock In Price' : _ref$titleText,
    _ref$bodyText = _ref.bodyText,
    bodyText = _ref$bodyText === void 0 ? 'Please wait a moment while we lock in your final price.' : _ref$bodyText;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "lock-in-price"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "lock-in-price__loading-img",
    src: imgSrc,
    alt: titleText,
    title: titleText
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "lock-in-price--bold",
    "data-core-qa": "lockPriceTitleText"
  }, titleText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-core-qa": "lockPriceSubText"
  }, bodyText)));
};
LockInPrice.propTypes = {
  /** Text underneath the title */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** The img tag src. A default image will be used if this prop is not provided */
  imgSrc: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** Title text underneath the image */
  titleText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (LockInPrice);

/***/ }),
/* 225 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 226 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "4f779d327f30dd12dfd9cfdc1378a963.png");

/***/ }),
/* 227 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NodeAgreements; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _InitialsAgreement_InitialsAgreement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(222);
/* harmony import */ var _SignatureAgreement_SignatureAgreement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(228);
/* harmony import */ var _ReadonlyAgreement_ReadonlyAgreement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(230);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27);
/* harmony import */ var _utils_agreements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(232);
/* harmony import */ var _nodeAgreements_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(233);
var _excluded = ["nodeAgreements", "submitButtonCallback", "cancelButtonCallback", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var acknowledgmentTypes = {
  none: 0,
  signature: 1,
  initials: 2
};
function NodeAgreements(_ref) {
  var nodeAgreements = _ref.nodeAgreements,
    submitButtonCallback = _ref.submitButtonCallback,
    cancelButtonCallback = _ref.cancelButtonCallback,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_utils_agreements__WEBPACK_IMPORTED_MODULE_5__.sortAgreements)(nodeAgreements)),
    _useState2 = _slicedToArray(_useState, 2),
    agreements = _useState2[0],
    setAgreements = _useState2[1];
  var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    submitButtonCallback(agreements);
  }, [agreements]);
  var updateAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (agreementId, updates) {
    setAgreements(function (currentAgreements) {
      return currentAgreements.map(function (agreement) {
        if (agreement.id === agreementId) {
          agreement = _objectSpread(_objectSpread({}, agreement), updates);
        }
        return agreement;
      });
    });
  }, [setAgreements]);
  var captureSignatureDataForAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, signatureData) {
    return updateAgreement(id, {
      data: signatureData
    });
  }, [updateAgreement]);
  var captureInitialsDataForAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, initialsData) {
    return updateAgreement(id, {
      data: initialsData
    });
  }, [setAgreements]);
  var captureCheckboxChangeForAgreement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (id, isChecked) {
    return updateAgreement(id, {
      checked: isChecked
    });
  }, [setAgreements]);
  var allFormsAreFilledOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return agreements.every(function (agreement) {
      if (agreement.acknowledgmentType === acknowledgmentTypes.none) {
        return true;
      }
      if (!agreement.data) {
        return false;
      }
      if (agreement.acknowledgmentType === acknowledgmentTypes.initials && !agreement.checked) {
        return false;
      }
      return true;
    });
  }, [agreements]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "nodeAgreements ".concat(className)
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "header",
    "data-core-qa": "nodeAgreementsTitleText"
  }, "Review and Sign The Following Agreements"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "subHeader",
    "data-core-qa": "nodeAgreementsTitleSubText"
  }, "Review and sign the node software terms and conditions below."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "agreementsContainer scroll"
  }, agreements.map(function (agreement) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      key: agreement.id
    }, agreement.isParent && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "agreementName"
    }, agreement.name), agreement.acknowledgmentType === acknowledgmentTypes.none && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ReadonlyAgreement_ReadonlyAgreement__WEBPACK_IMPORTED_MODULE_3__["default"], {
      content: agreement.content
    }), agreement.acknowledgmentType === acknowledgmentTypes.signature && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SignatureAgreement_SignatureAgreement__WEBPACK_IMPORTED_MODULE_2__["default"], {
      agreementText: agreement.content,
      captureSignatureData: function captureSignatureData(signatureData) {
        return captureSignatureDataForAgreement(agreement.id, signatureData);
      },
      signatureCanvasId: "".concat(agreement, "SignatureCanvas"),
      className: "signatureInput"
    }), agreement.acknowledgmentType === acknowledgmentTypes.initials && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_InitialsAgreement_InitialsAgreement__WEBPACK_IMPORTED_MODULE_1__["default"], {
      checkboxId: "".concat(agreement.id, "Checkbox"),
      checkboxLabel: agreement.content,
      checkboxOnChangeCallback: function checkboxOnChangeCallback(newValue) {
        return captureCheckboxChangeForAgreement(agreement.id, newValue);
      },
      initialsChangedCallback: function initialsChangedCallback(newValue) {
        return captureInitialsDataForAgreement(agreement.id, newValue);
      },
      initialsInputId: "".concat(agreement.id, "InitialsInput")
    }));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
    "data-core-qa": "nodeAgreementsButtonSubmit",
    className: "submitButton",
    onClick: handleSubmit,
    disabled: !allFormsAreFilledOut
  }, "Submit"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
    onClick: cancelButtonCallback,
    kind: "outlined",
    "data-core-qa": "nodeAgreementsButtonCancel"
  }, "Cancel"));
}
NodeAgreements.propTypes = {
  /** An array of objects, each of which has the following attributes:
   * <br/><br/>id: The id of the agreement. This is used to validate which agreements have been filled out
   * <br/><br/>name: name of the agreement. This shows up in the UI for parent level agreements (see isParent attribute below)
   * <br/><br/>content: This is the text of the agreement that shows up in the UI for the user to read
   * <br/><br/>acknowledgementType: An enum (0, 1, or 2) that determines which type of agreement the UI shows (ReadOnly, Signature, or Initials)
   * <br/><br/>isParent: This is a way to group agreements together. Multiple child agreements that all belong to the same parent can be thought of as a single form that the user is filling out. The parent agreement groups them all together, and the name of the parent agreement shows up in the UI
   * <br/><br/>ordinal: This determines the order the agreements show up in. The agreements will be grouped by parentId then ordered by their 'ordinal' attribute
   * <br/><br/>parentId: The id of this agreement's parent agreement. If this is a parent agreement, this should be set to 0
   */
  nodeAgreements: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.shape({
    id: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.number,
    name: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.string,
    content: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.string,
    acknowledgmentType: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.oneOf([0, 1, 2]),
    isParent: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.bool,
    ordinal: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.number,
    parentId: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.number
  })),
  /** Called when the submit button is clicked */
  submitButtonCallback: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.func,
  /** Called when the cancel button is clicked */
  cancelButtonCallback: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.func,
  /** An optional className to be applied to the outermost div of this component */
  className: prop_types__WEBPACK_IMPORTED_MODULE_7__.PropTypes.string
};

/***/ }),
/* 228 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SignatureAgreement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_signature_canvas__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _signatureAgreement_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(229);
var _excluded = ["signatureTitle", "agreementText", "captureSignatureData", "signatureCanvasId", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function SignatureAgreement(_ref) {
  var _ref$signatureTitle = _ref.signatureTitle,
    signatureTitle = _ref$signatureTitle === void 0 ? 'Signature*' : _ref$signatureTitle,
    agreementText = _ref.agreementText,
    captureSignatureData = _ref.captureSignatureData,
    signatureCanvasId = _ref.signatureCanvasId,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var signatureRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  function saveSignatureData() {
    var signatureData = signatureRef.toDataURL();
    captureSignatureData(signatureData);
  }
  function clearCanvas() {
    signatureRef.clear();
    captureSignatureData('');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "signature-agreement ".concat(className)
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "signature-agreement__title-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "signature-agreement__clear",
    onClick: clearCanvas,
    "data-core-qa": "signAgreementClear"
  }, "Clear"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "signature-agreement__title",
    "data-core-qa": "signAgreementTitleText"
  }, signatureTitle)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "signature-agreement__signature-box",
    "data-core-qa": "signAgreementBox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react_signature_canvas__WEBPACK_IMPORTED_MODULE_1___default()), {
    id: signatureCanvasId,
    canvasProps: {
      className: 'signature-agreement__canvasSignature sigCanvas'
    },
    ref: function ref(_ref2) {
      signatureRef = _ref2;
    },
    onEnd: saveSignatureData,
    clearOnResize: false
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "signature-agreement__description",
    "data-core-qa": "signAgreementAgreementText"
  }, agreementText));
}
SignatureAgreement.propTypes = {
  signatureTitle: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  agreementText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  captureSignatureData: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  signatureCanvasId: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};

/***/ }),
/* 229 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 230 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ReadonlyAgreement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _readonlyAgreement_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(231);
var _excluded = ["content", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function ReadonlyAgreement(_ref) {
  var content = _ref.content,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = _objectWithoutProperties(_ref, _excluded);
  // if the agreement has content, we display the content to the user. If not, it's invisible.
  if (!content) {
    return null;
  }
  var agreementTextLines = content.split('\n');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "readonlyAgreement scroll-small ".concat(className)
  }, rest, {
    "data-core-qa": "readOnlyAgreementDiv"
  }), agreementTextLines.map(function (lineOfText, i) {
    // empty lines should be displayed as empty lines to account for new paragraphs ("\n\n") in the content string
    if (!lineOfText) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("br", {
        key: i
      });
    }
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      key: i,
      className: "agreementText",
      "data-core-qa": "readAgreementText".concat(i)
    }, lineOfText);
  }));
}
ReadonlyAgreement.propTypes = {
  /** The text of the agreement that will be shown in the UI for the user to read */
  content: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  /** An optional className that will be applied to the outermost div */
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};

/***/ }),
/* 231 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 232 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sortAgreements": function() { return /* binding */ sortAgreements; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* 
1. agreements might come in in any order, this function sorts them. Children of a parent agreement should all be grouped together, then ordered by their 'ordinal' attribute. For example, regardless of the order they come in, we would want the sorted result to look like: 
[ parent1, parent1Child1, parent1Child2, parent2, parent2Child1, parent2Child2, etc...]

2. ordinal values can have large gaps in between them if needed to allow for future additions. For example, if a parent agreement has 3 children, instead of giving them ordinal values of 1-3, you could use 10-30 with gaps of 10 in between so that future additions could be inserted without having to re-number all of them
*/
function sortAgreements(agreements) {
  var parentAgreements = agreements.filter(function (agreement) {
    return agreement.isParent;
  });
  var parentChildMap = {};
  parentAgreements.forEach(function (agreement) {
    parentChildMap[agreement.id] = _objectSpread(_objectSpread({}, agreement), {}, {
      children: []
    });
  });
  agreements.forEach(function (agreement) {
    if (!agreement.isParent) {
      parentChildMap[agreement.parentId].children[agreement.ordinal] = agreement;
    }
  });
  var sortedAgreeements = [];
  Object.values(parentChildMap).forEach(function (parentAgreement) {
    var children = parentAgreement.children;
    delete parentAgreement.children;
    sortedAgreeements.push(parentAgreement);
    children.forEach(function (childAgreement) {
      return sortedAgreeements.push(childAgreement);
    });
  });
  return sortedAgreeements;
}

/***/ }),
/* 233 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 234 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PaymentOptions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(235);
/* harmony import */ var _assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _paymentOptions_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(236);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }





function PaymentOptions(_ref) {
  var _wallet$totalUSD, _wallet$totalETH;
  var orderTotal = _ref.orderTotal,
    user = _ref.user,
    wallet = _ref.wallet,
    handleAddETHCallback = _ref.handleAddETHCallback,
    handlePreviewOrderCallback = _ref.handlePreviewOrderCallback,
    handleSetupWalletCallback = _ref.handleSetupWalletCallback,
    handleLoginCallback = _ref.handleLoginCallback,
    walletIsLoading = _ref.walletIsLoading,
    shoppingFormText = _ref.shoppingFormText;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    errorETH = _useState2[0],
    setErrorETH = _useState2[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!walletIsLoading && user) {
      var lowFundsError = wallet && orderTotal && wallet.totalUSD < orderTotal.totalCurrency;
      setErrorETH(lowFundsError);
    }
  }, [user, wallet, orderTotal]);
  if (walletIsLoading) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
      className: "paymentOptions"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
      className: "paymentOptions__card"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "paymentOptions__loading"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: " paymentOptions__loadingText",
      title: "paymentOptionsLoadingText",
      "data-core-qa": "paymentOptionsLoadingText"
    }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentLoadingText) || 'Please wait while we get your wallet information'))));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "paymentOptions"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: !(user !== null && user !== void 0 && user.accessToken) || !(wallet !== null && wallet !== void 0 && wallet.id) ? 'paymentOptions__card--needsAttention paymentOptions__card' : errorETH ? 'paymentOptions__card--insufficientFunds paymentOptions__card' : 'paymentOptions__card'
  }, wallet !== null && wallet !== void 0 && wallet.valid ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__walletWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Wallet, {
    wallet: wallet,
    qrCode: false
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__total"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__usd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__currency",
    "data-core-qa": "paymentOptionsUSDText"
  }, (orderTotal === null || orderTotal === void 0 ? void 0 : orderTotal.currencyCode) || 'USD'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__amount",
    "data-core-qa": "paymentOptionsUSDAmount"
  }, ' ', (_wallet$totalUSD = wallet.totalUSD) === null || _wallet$totalUSD === void 0 ? void 0 : _wallet$totalUSD.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__eth"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__currency",
    "data-core-qa": "paymentOptionsCoinText"
  }, "ETH", ' '), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__amount",
    "data-core-qa": "paymentOptionsCoinAmount"
  }, (_wallet$totalETH = wallet.totalETH) === null || _wallet$totalETH === void 0 ? void 0 : _wallet$totalETH.toFixed(5)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: " paymentOptions__walletInfo"
  }, errorETH && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "paymentOptionsLowFundsText",
    className: "paymentOptions__walletWarning",
    title: "paymentOptionsNotEnoughFundsText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentLowFundsText) || 'Your wallet does not have enough ETH to complete this transaction.'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    className: "paymentOptions__button",
    onClick: handleAddETHCallback,
    "data-core-qa": "paymentOptionsButtonAddFunds"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__buttonContentWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    className: "paymentOptions__buttonIcon"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "paymentOptions__buttonText paymentOptions__buttonText--small",
    "data-core-qa": "paymentOptionsButtonAddFundsText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentAddETHText) || 'Add More ETH'))))) : user !== null && user !== void 0 && user.accessToken ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__buttonContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "paymentOptionsSetupWallet",
    onClick: handleSetupWalletCallback,
    className: "paymentOptions__button paymentOptions__button--center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__buttonContentWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    className: "paymentOptions__buttonIcon"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "paymentOptionsButtonSetupWalletText",
    className: "paymentOptions__buttonText paymentOptions__buttonText--underline",
    title: "paymentOptionsSetUpWalletText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentSetupWalletText) || 'Click here to setup your wallet')))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__buttonContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    onClick: handleLoginCallback,
    className: "paymentOptions__button",
    "data-core-qa": "paymentOptionsButtonLogin"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "paymentOptions__buttonContentWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    className: "paymentOptions__buttonIcon"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    "data-core-qa": "paymentOptionsButtonLoginText",
    className: "paymentOptions__buttonText paymentOptions__buttonText--underline",
    title: "paymentOptionsLoginText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentLoginText) || 'To continue with the checkout process, please click here to log in to your account'))))), (wallet === null || wallet === void 0 ? void 0 : wallet.valid) && orderTotal.totalQuantity > 0 && wallet.totalETH > orderTotal.totalETH && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "paymentOptions__submitWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_3__.Button, {
    "data-core-qa": "paymentOptionsButtonContinue",
    className: "paymentOptions__submitButton",
    disabled: errorETH,
    onClick: handlePreviewOrderCallback
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentButtonText) || 'Preview Order'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "paymentOptions__submitInfo",
    "data-core-qa": "paymentOptionsWalletSubText"
  }, shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentOptionButtonSubText)));
}
PaymentOptions.propTypes = {
  /** User data used to determine if a user is logged in */
  user: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    accessToken: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Wallet data:<br/>
   * icon - wallet logo<br/>
   * name - wallet name<br/>
   * id - wallet address<br/>
   * totalETH - available balance in ETH<br/>
   * totalUSD - available balance in USD<br/>
   * valid - wallet is allowed to transfer funds
   */
  wallet: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalUSD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    valid: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
  }),
  /** Order data utilized in the `useEffect` to determine if the order total has exceeded the user's available balance. Please see the `Shopping` component in the Related Components section above for more details */
  orderTotal: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
  /** Callback function to direct the user to a location/component to help them add funds their wallet */
  handleAddETHCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Callback function that returns the user's product selections and quantity */
  handlePreviewOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Callback function to direct the user to a location/component to set up their wallet */
  handleSetupWalletCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Callback function to direct the user to a location/component to log in to the application */
  handleLoginCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** Loading state boolean utilized to initiate loading view of this component */
  walletIsLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
  /** Optional text used throughout the component, defaults provided for most: <br/>
   * - `paymentHeadingText` used in the parent component `Shopping` default = 'Payment Options'
   * - `paymentLoadingText` default = 'Please wait while we get your wallet information'
   * - `paymentLowFundsText` default = 'Your wallet does not have enough ETH to complete this transaction.'
   * - `paymentAddETHText` default = 'Add More ETH'
   * - `paymentSetupWalletText` *Entire string is a link calling the `handleSetupWalletCallback` default = 'Click here to setup your wallet'
   * - `paymentLoginText` default = 'To continue with the checkout process, please click here to log in to your account'
   * - `paymentButtonText` default = 'Preview Order'
   *- `paymentOptionButtonSubText` is displayed below the button outside of the border box and has no default text.
   */
  shoppingFormText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    paymentHeadingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentLoadingText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentLowFundsText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentAddETHText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentSetupWalletText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentLoginText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    paymentOptionButtonSubText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  })
};

/***/ }),
/* 235 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3e%3c!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath d='M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z'/%3e%3c/svg%3e"

/***/ }),
/* 236 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 237 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _processOrder_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(238);
/* harmony import */ var _assets_images_ProcessOrder_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(239);
/* harmony import */ var _Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);





var ProcessOrder = function ProcessOrder(_ref) {
  var processOrderText = _ref.processOrderText,
    handleGoToDashboardCallback = _ref.handleGoToDashboardCallback,
    handleShowStatusCallback = _ref.handleShowStatusCallback,
    imageSource = _ref.imageSource;
  imageSource = imageSource || _assets_images_ProcessOrder_png__WEBPACK_IMPORTED_MODULE_2__["default"];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "process-order"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "process-order__body-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "process-order__heading",
    "data-core-qa": "processOrderTitleText"
  }, (processOrderText === null || processOrderText === void 0 ? void 0 : processOrderText.titleText) || 'Processing Your Order'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "process-order__body",
    "data-core-qa": "processOrderTitleSubText"
  }, (processOrderText === null || processOrderText === void 0 ? void 0 : processOrderText.bodyText) || 'Please wait while we finalize your order. Your payment to our wallet has been submitted as a transaction to the Ethereum Blockchain and your order will be complete when this transaction has been confirmed by the network. This usually takes less than 10 minutes. This page will update when your order is complete. ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "process-order__body process-order__body--emphasized"
  }, (processOrderText === null || processOrderText === void 0 ? void 0 : processOrderText.bodySubText) || 'Please do not close this tab.')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "process-order__button-wrapper flexRow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "processOrderButtonSeeStatus",
    type: "button",
    className: "process-order__button",
    onClick: handleShowStatusCallback
  }, (processOrderText === null || processOrderText === void 0 ? void 0 : processOrderText.buttonText) || 'View Status on Etherscan'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Inputs_Button_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
    "data-core-qa": "processOrderButtonConfirm",
    type: "button",
    className: "process-order__button",
    onClick: handleGoToDashboardCallback
  }, (processOrderText === null || processOrderText === void 0 ? void 0 : processOrderText.goToDashboardButtonText) || 'Go to Dashboard'))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "process-order__body-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "process-order__image",
    src: imageSource,
    alt: "Process order"
  })));
};
ProcessOrder.propTypes = {
  /** Customizable text used in process order */
  processOrderText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodySubText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    goToDashboardButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Callback called on secondary button onClick*/
  handleGoToDashboardCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Callback called on primary button onClick */
  handleShowStatusCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Image displayed right side of information text - will default to Nerd Platform image if not provided */
  imageSource: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)
};
/* harmony default export */ __webpack_exports__["default"] = (ProcessOrder);

/***/ }),
/* 238 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 239 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "055afe7f7eab47298c046e9ed3a193e2.png");

/***/ }),
/* 240 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductShape": function() { return /* binding */ ProductShape; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _product_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(241);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var direction = {
  increment: 'increment',
  decrement: 'decrement'
};
var nodeOptions = {
  smart: 'smart',
  lite: 'lite'
};
var Product = function Product(_ref) {
  var product = _ref.product,
    updateOrderState = _ref.updateOrderState,
    productDisabled = _ref.productDisabled;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    productQuantity = _useState2[0],
    setProductQuantity = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    maxQuantity = _useState4[0],
    setMaxQuantity = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isInvalidQuantity = _useState6[0],
    setIsInvalidQuantity = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    nodeType = _useState8[0],
    setNodeType = _useState8[1];
  var getMaxQuantity = function getMaxQuantity(product) {
    var _product$name;
    var productNameLowercase = (_product$name = product.name) === null || _product$name === void 0 ? void 0 : _product$name.toLowerCase();
    if (productNameLowercase.includes(nodeOptions.lite)) {
      setNodeType(nodeOptions.lite);
      setMaxQuantity(999);
    } else if (productNameLowercase.includes(nodeOptions.smart)) {
      setNodeType(nodeOptions.smart);
      setMaxQuantity(10);
    }
  };
  var handleQuantityChangeByButton = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (dir) {
    setProductQuantity(function (previousQuantity) {
      if (dir === direction.increment && previousQuantity <= maxQuantity) {
        return previousQuantity + 1;
      } else if (dir === direction.decrement && previousQuantity > 0) {
        return previousQuantity - 1;
      }
    });
  }, [maxQuantity]);
  var handleQuantityInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    var trimmedInt = parseInt(e.target.value, 10);
    if (e.target.value <= maxQuantity && e.target.value >= 0) {
      setProductQuantity(trimmedInt || 0);
    } else if (e.target.value > maxQuantity) {
      setIsInvalidQuantity(true);
      setProductQuantity(maxQuantity);
      setTimeout(function () {
        setIsInvalidQuantity(false);
      }, 3500);
    } else if (e.target.value < 0) {
      setIsInvalidQuantity(true);
      setProductQuantity(0);
      setTimeout(function () {
        setIsInvalidQuantity(false);
      }, 3500);
    }
  }, [maxQuantity, productQuantity]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    getMaxQuantity(product);
    updateOrderState(product, productQuantity, isInvalidQuantity);
  }, [productQuantity]);
  var errorMessage = "Limit of ".concat(maxQuantity, " ").concat(nodeType, " nodes per order. Enter a value between 1-").concat(maxQuantity, ".");
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: isInvalidQuantity ? 'product product--error' : 'product'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "product__title",
    "data-core-qa": "productNameText"
  }, product.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "product__price-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "product__price product__usd",
    "data-core-qa": "productUSDAmount"
  }, product.price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  }) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "product__price product__eth",
    "data-core-qa": "productCoinAmount"
  }, "ETH ", product.ETH || '-')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ProductCounter, {
    "data-core-qa": "productProductCounter".concat(product.name),
    productQuantity: productQuantity,
    maxQuantity: maxQuantity,
    direction: direction,
    handleQuantityInput: handleQuantityInput,
    handleQuantityChangeByButton: handleQuantityChangeByButton,
    productDisabled: productDisabled
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "product__error",
    "data-core-qa": "productErrorText"
  }, isInvalidQuantity && "".concat(errorMessage)));
};
/* harmony default export */ __webpack_exports__["default"] = (Product);
var ProductShape = {
  id: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().number), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)]),
  name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  price: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired),
  ETH: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number.isRequired)
};
Product.propTypes = {
  /** Details about the product */
  product: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(ProductShape).isRequired,
  /** Callback function that is called any time the product quantity changes. Parameters passed to the callback function are: the product prop, productQuantity, and isInvalidQuantity, which is a boolean that indicates whether the quantity listed is valid (purchase quantity is currently limited for different product types)  */
  updateOrderState: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** One product type can be purchased at a time. See the `ProductList` component above to see the handling of this state. This prop is passed into the `ProductCounter`. */
  productDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};

/***/ }),
/* 241 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 242 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_icons_fontawesome_minus_solid_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(243);
/* harmony import */ var _assets_icons_fontawesome_minus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_minus_solid_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(235);
/* harmony import */ var _assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _productCounter_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(244);





var ProductCounter = function ProductCounter(_ref) {
  var productQuantity = _ref.productQuantity,
    maxQuantity = _ref.maxQuantity,
    direction = _ref.direction,
    handleQuantityInput = _ref.handleQuantityInput,
    handleQuantityChangeByButton = _ref.handleQuantityChangeByButton,
    productDisabled = _ref.productDisabled;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "product-counter"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "productCounterButtonMinus",
    type: "button",
    title: "minusButton",
    className: "button button--left",
    disabled: productQuantity <= 0 || productDisabled,
    onClick: function onClick() {
      handleQuantityChangeByButton(direction.decrement);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_minus_solid_svg__WEBPACK_IMPORTED_MODULE_1___default()),
    className: "button__icon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    "data-core-qa": "productCounterInputAmount",
    title: "counter",
    className: "input",
    value: Number(productQuantity).toString(),
    type: "number",
    name: "productQuantity",
    onChange: function onChange(e) {
      return handleQuantityInput(e);
    },
    disabled: productDisabled
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    "data-core-qa": "productCounterButtonPlus",
    type: "button",
    title: "plusButton",
    className: "button button--right",
    disabled: productQuantity >= maxQuantity || productDisabled,
    onClick: function onClick() {
      handleQuantityChangeByButton(direction.increment);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_plus_solid_svg__WEBPACK_IMPORTED_MODULE_2___default()),
    className: "button__icon"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (ProductCounter);
ProductCounter.propTypes = {
  /** A number that is displayed that represents the quantity of products chosen. It is supplied by this components parent, the Product Component */
  productQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
  /** A number that represents the maximum allowable quantity for a particular product. (ie. smart node - 10, lite node - 999) */
  maxQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
  /** An enum that represents the direction of the change (ie. increment, decrement )*/
  direction: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    increment: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    decrement: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** A function that handles if a user inputs a specific number without using the increment or decrement buttons */
  handleQuantityInput: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** A function that handles if a user changes product quantity using the increment or decrement buttons */
  handleQuantityChangeByButton: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** A boolean value that will disable the entire increment or decrement functionality if true, and allow it if false */
  productDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
};

/***/ }),
/* 243 */
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3e%3c!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3e%3cpath d='M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z'/%3e%3c/svg%3e"

/***/ }),
/* 244 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 245 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Product_Product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(240);
/* harmony import */ var _productList_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(246);




var ProductList = function ProductList(_ref) {
  var brandName = _ref.brandName,
    brandImage = _ref.brandImage,
    order = _ref.order,
    products = _ref.products,
    updateOrderState = _ref.updateOrderState,
    shoppingFormText = _ref.shoppingFormText;
  var productsList = products.map(function (product) {
    var orderHasProductId = Object.prototype.hasOwnProperty.call(order, product.id);
    // if this product is not part of the order (i.e. the order object doesn't have a key for this productId), show the product as disabled
    var productDisabled = Object.keys(order).length > 0 && !orderHasProductId;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Product_Product__WEBPACK_IMPORTED_MODULE_1__["default"], {
      key: product.id,
      product: product,
      updateOrderState: updateOrderState,
      productDisabled: productDisabled
    });
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "productList"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "brand"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "brandImage",
    src: brandImage,
    alt: "logo"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "brandHeading",
    "data-core-qa": "productListNameText"
  }, brandName)), productsList, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.productNoticeText) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "infoBox",
    "data-core-qa": "productListInfoText"
  }, shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.productNoticeText));
};
/* harmony default export */ __webpack_exports__["default"] = (ProductList);
ProductList.propTypes = {
  /** This shows at the top of the component */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** This shows at the top of the component */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
  /** An array of objects, each of which should contain the needed attributes for the `Product` component (see the `Related Components` section above). */
  products: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape(_Product_Product__WEBPACK_IMPORTED_MODULE_1__.ProductShape)),
  /** This is passed into the `Product` component (see the `Related Components` section above) for each product in the `products` array, */
  updateOrderState: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  /** An object whose keys reference product ids. If the order has some keys, any product whose id is not a key in the order object will show as disabled */
  order: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  /** If `shoppingFormText.productNoticeText` is provided, it will show up underneath the product list */
  shoppingFormText: prop_types__WEBPACK_IMPORTED_MODULE_3___default().shape({
    productHeadingTooltipText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    productNoticeText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
  })
};

/***/ }),
/* 246 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 247 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _DataDisplay_InfoIcon_infoIcon_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _reviewOrder_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(248);
var _excluded = ["bodyText", "brandLogo", "brandName", "cancelOrderButtonText", "cancelOrderCallback", "continueButtonText", "continueCallback", "gasFee", "infoIconText", "orderTotal", "productList", "timerStartDate", "timerEndDate", "timerEndedCancelModalBodyText", "timerEndedCancelModalButtonCallback", "timerEndedCancelModalButtonText", "timerEndedCancelModalTitleText", "titleText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var ReviewOrder = function ReviewOrder(_ref) {
  var _ref$bodyText = _ref.bodyText,
    bodyText = _ref$bodyText === void 0 ? 'We have now locked in the prices of your selected nodes! You have 10 minutes to review and submit your order.' : _ref$bodyText,
    brandLogo = _ref.brandLogo,
    brandName = _ref.brandName,
    _ref$cancelOrderButto = _ref.cancelOrderButtonText,
    cancelOrderButtonText = _ref$cancelOrderButto === void 0 ? 'Cancel Order' : _ref$cancelOrderButto,
    cancelOrderCallback = _ref.cancelOrderCallback,
    _ref$continueButtonTe = _ref.continueButtonText,
    continueButtonText = _ref$continueButtonTe === void 0 ? 'Continue' : _ref$continueButtonTe,
    continueCallback = _ref.continueCallback,
    gasFee = _ref.gasFee,
    _ref$infoIconText = _ref.infoIconText,
    infoIconText = _ref$infoIconText === void 0 ? "\n  Review your order below. If you do not\n  complete these steps in time, this order will be\n  cancelled and you will be required to lock in\n  pricing again, at which time the node prices\n  may have increased. As a reminder, Smart Node\n  prices increase by $100 for every 100 sold.\n  " : _ref$infoIconText,
    orderTotal = _ref.orderTotal,
    productList = _ref.productList,
    timerStartDate = _ref.timerStartDate,
    timerEndDate = _ref.timerEndDate,
    timerEndedCancelModalBodyText = _ref.timerEndedCancelModalBodyText,
    timerEndedCancelModalButtonCallback = _ref.timerEndedCancelModalButtonCallback,
    timerEndedCancelModalButtonText = _ref.timerEndedCancelModalButtonText,
    timerEndedCancelModalTitleText = _ref.timerEndedCancelModalTitleText,
    _ref$titleText = _ref.titleText,
    titleText = _ref$titleText === void 0 ? 'Review Order' : _ref$titleText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    timerEndedModalIsOpen = _useState2[0],
    setTimerEndedModalIsOpen = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cancelButtonModalIsOpen = _useState4[0],
    setCancelButtonModalIsOpen = _useState4[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "flexColumn review-order"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "review-order__title",
    "data-core-qa": "reviewOrderTitleText"
  }, titleText, ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Tooltip, {
    "data-core-qa": "reviewOrderToolTip",
    className: "review-order__tooltip",
    popupContent: infoIconText,
    popupPosition: {
      bottom: '-10px',
      left: '50%',
      transform: 'translate(-50%, 100%)'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_InfoIcon_infoIcon_jsx__WEBPACK_IMPORTED_MODULE_2__["default"], null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "review-order__text",
    "data-core-qa": "reviewOrderBodyText"
  }, bodyText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "review-order-timer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.CircleTimer, {
    className: "circleTimer",
    timerStartDate: timerStartDate,
    timerEndDate: timerEndDate,
    radius: 80,
    timerEndedCallback: function timerEndedCallback() {
      return setTimerEndedModalIsOpen(true);
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "review-order-product-summary"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.ProductSummary, {
    brandImage: brandLogo,
    brandName: brandName,
    productList: productList,
    gasFee: gasFee,
    orderTotal: orderTotal
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "review-order-buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "reviewOrderButtonSubmit",
    onClick: continueCallback,
    className: "review-order-buttons__primary",
    type: "button"
  }, continueButtonText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "reviewOrderButtonCancel",
    onClick: function onClick() {
      return setCancelButtonModalIsOpen(true);
    },
    className: "review-order-buttons__cancel",
    type: "button",
    kind: "outlined"
  }, cancelOrderButtonText))), timerEndedModalIsOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.TimerEndedCancelModal, {
    bodyText: timerEndedCancelModalBodyText,
    buttonCallback: timerEndedCancelModalButtonCallback,
    buttonText: timerEndedCancelModalButtonText,
    titleText: timerEndedCancelModalTitleText
  }), cancelButtonModalIsOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Modal, {
    modalClassName: "review-order-cancel-button-modal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.CancelOrderConfirmation, {
    dontCancelOrderCallback: function dontCancelOrderCallback() {
      return setCancelButtonModalIsOpen(false);
    },
    cancelOrderCallback: cancelOrderCallback
  }))));
};
ReviewOrder.propTypes = {
  /** Subtext below the heading */
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Logo passed into the ProductSummary */
  brandLogo: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
  /** Brand name passed into the ProductSummary */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** Customizable text for cancel button (right)*/
  cancelOrderButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Callback function passed to the CancelOrderConfirmation component */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Customizable text for continue button (left) */
  continueButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Callback function triggered by the continue button onClick */
  continueCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Gas Fee data object passed to the ProductSummary */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  }),
  /** Customizable tooltip text */
  infoIconText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Order Total data object passed to the ProductSummary */
  orderTotal: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    currencyCode: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Product List data object passed to the ProductSummary */
  productList: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    purchaseQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    currentCode: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  })),
  /** Date passed to CircleTimer */
  timerStartDate: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Date).isRequired,
  /** Date passed to CircleTimer */
  timerEndDate: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Date).isRequired,
  /** Customizable modal text passed to TimerEndedCancelModal */
  timerEndedCancelModalBodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Callback function passed to TimerEndedCancelModal */
  timerEndedCancelModalButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** Customizable button text passed to TimerEndedCancelModal */
  timerEndedCancelModalButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Customizable heading text passed to TimerEndedCancelModal */
  timerEndedCancelModalTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
  /** Customizable heading text */
  titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (ReviewOrder);

/***/ }),
/* 248 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 249 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Shopping; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_icons_nerdCoreKit_InformationIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(250);
/* harmony import */ var _DataDisplay_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20);
/* harmony import */ var _assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44);
/* harmony import */ var _assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var _shopping_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(251);
var _excluded = ["brandImage", "brandName", "user", "wallet", "products", "handleAddETHCallback", "handlePreviewOrderCallback", "handleSetupWalletCallback", "handleLoginCallback", "gasFee", "updateDataFields", "walletIsLoading", "shoppingFormText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







function Shopping(_ref) {
  var brandImage = _ref.brandImage,
    brandName = _ref.brandName,
    user = _ref.user,
    wallet = _ref.wallet,
    products = _ref.products,
    handleAddETHCallback = _ref.handleAddETHCallback,
    _handlePreviewOrderCallback = _ref.handlePreviewOrderCallback,
    handleSetupWalletCallback = _ref.handleSetupWalletCallback,
    handleLoginCallback = _ref.handleLoginCallback,
    gasFee = _ref.gasFee,
    updateDataFields = _ref.updateDataFields,
    walletIsLoading = _ref.walletIsLoading,
    shoppingFormText = _ref.shoppingFormText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    order = _useState2[0],
    setOrderState = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isOrderSummaryExpanded = _useState4[0],
    setIsOrderSummaryExpanded = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isPaymentOptionsExpanded = _useState6[0],
    setIsPaymentOptionsExpanded = _useState6[1];
  var updateOrderState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (product, productQuantity) {
    if (productQuantity > 0) {
      updateDataFields();
      setOrderState(function (previousOrderState) {
        return _objectSpread(_objectSpread({}, previousOrderState), {}, _defineProperty({}, "".concat(product.id), _objectSpread(_objectSpread({}, product), {}, {
          purchaseQuantity: productQuantity
        })));
      });
    } else if (productQuantity === 0 && product.id in order) {
      updateDataFields();
      setOrderState(function (previousOrderState) {
        delete previousOrderState["".concat(product.id)];
        return _objectSpread({}, previousOrderState);
      });
    }
  }, [order, updateDataFields]);
  var handleToggleOrderSummaryExpand = function handleToggleOrderSummaryExpand() {
    setIsOrderSummaryExpanded(!isOrderSummaryExpanded);
  };
  var handleTogglePaymentOptionsExpand = function handleTogglePaymentOptionsExpand() {
    setIsPaymentOptionsExpanded(!isPaymentOptionsExpanded);
  };
  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
      var productList = [];
      var currentOrderTotal = {
        totalCurrency: gasFee.USD,
        totalETH: gasFee.ETH,
        totalQuantity: 0
      };
      var productsArr = Object.values(order);
      productsArr.forEach(function (product) {
        var productWithTotals = _objectSpread(_objectSpread({}, product), {}, {
          totalCurrency: product.price * product.purchaseQuantity,
          totalETH: Number((product.ETH * product.purchaseQuantity).toFixed(5))
        });
        productList.push(productWithTotals);
        currentOrderTotal.totalCurrency += productWithTotals.totalCurrency;
        currentOrderTotal.totalETH += productWithTotals.totalETH;
        currentOrderTotal.totalQuantity += productWithTotals.purchaseQuantity;
      });
      return {
        productList: productList,
        currentOrderTotal: currentOrderTotal
      };
    }, [order]),
    productList = _useMemo.productList,
    currentOrderTotal = _useMemo.currentOrderTotal;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("section", {
    className: "shopping"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "shopping__group shopping__group--product"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: "shopping__section shopping__section--productList"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__headingWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__mobileWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "shopping__heading",
    "data-core-qa": "shoppingTitleText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.productHeadingText) || 'Purchase Nodes'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_2__["default"], {
    "data-core-qa": "shoppingTooltip",
    className: "shopping__tooltip",
    popupContent: (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.productHeadingTooltipText) || 'You can purchase 10 smart nodes at a time. You can also purchase 999 lite nodes at a time.'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_InformationIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
    className: "icon",
    size: 20
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.ProductList, {
    brandImage: brandImage,
    brandName: brandName,
    products: products,
    order: order,
    updateOrderState: updateOrderState,
    shoppingFormText: shoppingFormText
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__group shopping__group--order"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__mobileBorder"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: isOrderSummaryExpanded ? "shopping__section shopping__section--orderSummary shopping__expanded" : "shopping__section shopping__section--orderSummary shopping__collapsed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__headingWrapper",
    onClick: handleToggleOrderSummaryExpand
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__mobileWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "shopping__heading",
    "data-core-qa": "shoppingOrderTitleText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.orderHeadingText) || 'Order Summary'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_2__["default"], {
    "data-core-qa": "shoppingTooltipMobile",
    className: "shopping__tooltip shopping__mobileOnly",
    popupContent: (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.shoppingMobileToolTip) || 'You can scroll vertically to view your order.',
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_InformationIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
    className: "icon",
    size: 20
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "shopping__arrowIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: isOrderSummaryExpanded ? "shopping__orderSummary--expanded" : "shopping__orderSummary--closed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.ProductSummary, {
    brandImage: brandImage,
    brandName: brandName,
    productList: productList,
    orderTotal: currentOrderTotal,
    gasFee: gasFee,
    shoppingFormText: shoppingFormText
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__lowerBorder shopping__mobileOnly"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", {
    className: isPaymentOptionsExpanded ? "shopping__section shopping__section--paymentOptions shopping__expanded" : "shopping__section shopping__section--paymentOptions shopping__collapsed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__headingWrapper",
    onClick: handleTogglePaymentOptionsExpand
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shopping__mobileWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h2", {
    className: "shopping__heading",
    "data-core-qa": "shoppingPaymentTitleText"
  }, (shoppingFormText === null || shoppingFormText === void 0 ? void 0 : shoppingFormText.paymentHeadingText) || 'Payment Options')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    src: (_assets_icons_fontawesome_angle_up_svg__WEBPACK_IMPORTED_MODULE_3___default()),
    className: "shopping__arrowIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: isPaymentOptionsExpanded ? "shopping__paymentOptions--expanded" : "shopping__paymentOptions--closed"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.PaymentOptions, {
    productList: productList,
    orderTotal: currentOrderTotal,
    user: user,
    wallet: wallet,
    handleAddETHCallback: handleAddETHCallback,
    handlePreviewOrderCallback: function handlePreviewOrderCallback() {
      return _handlePreviewOrderCallback(productList);
    },
    handleSetupWalletCallback: handleSetupWalletCallback,
    handleLoginCallback: handleLoginCallback,
    walletIsLoading: walletIsLoading,
    shoppingFormText: shoppingFormText
  })))));
}
Shopping.propTypes = {
  /** Brand logo passed to the ProductList and ProductSummary */
  brandImage: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().any),
  /** Brand name passed to the ProductList and ProductSummary */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** User wallet data object passed to the PaymentOptions */
  user: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
  /** Wallet data object passed to the PaymentOptions  */
  wallet: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
  /** Product array of objects passed to the ProductList */
  products: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array),
  /** Callback function passed to the PaymentOptions */
  handleAddETHCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
  /** Callback function passed to the PaymentOptions */
  handlePreviewOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
  /** Callback function passed to the PaymentOptions */
  handleSetupWalletCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
  /** Callback function passed to the PaymentOptions */
  handleLoginCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
  /** Gas Fee data object passed to the ProductSummary */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number)
  }),
  /** Callback function utilized in the `updateOrderState` function, returns no props. */
  updateDataFields: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** Loading state bool for PaymentOptions */
  walletIsLoading: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
  /** Text data object passed to all children to provide a level of customization */
  shoppingFormText: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    productHeadingText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    productHeadingTooltipText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    productNoticeText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    orderHeadingText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    orderCartEmptyText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentHeadingText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentLoadingText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentLowFundsText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentAddETHText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentSetupWalletText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentLoginText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    paymentOptionButtonSubText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    shoppingMobileToolTip: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
  })
};

/***/ }),
/* 250 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InformationIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["color", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function InformationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    fill: color,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    "aria-describedby": "tooltip-1"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  }));
}
InformationIcon.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};

/***/ }),
/* 251 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 252 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SubmitOrder; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _SubmitOrderForm_SubmitOrderForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(253);
/* harmony import */ var _assets_images_enter_passcode_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(255);
/* harmony import */ var _DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var _submitOrder_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(256);
var _excluded = ["brandName", "fromAddress", "toAddress", "gasFee", "totals", "passcodeInputOnChangeCallback", "submitOrderLoading", "submitOrderCallback", "submitOrderFormText", "cancelOrderCallback", "wrongPassCodeError", "timerStartDate", "timerEndDate", "timerEndedCancelModalBodyText", "timerEndedCancelModalButtonCallback", "timerEndedCancelModalButtonText", "timerEndedCancelModalTitleText", "imageSrc"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







function SubmitOrder(_ref) {
  var brandName = _ref.brandName,
    fromAddress = _ref.fromAddress,
    toAddress = _ref.toAddress,
    gasFee = _ref.gasFee,
    totals = _ref.totals,
    passcodeInputOnChangeCallback = _ref.passcodeInputOnChangeCallback,
    _ref$submitOrderLoadi = _ref.submitOrderLoading,
    submitOrderLoading = _ref$submitOrderLoadi === void 0 ? false : _ref$submitOrderLoadi,
    submitOrderCallback = _ref.submitOrderCallback,
    submitOrderFormText = _ref.submitOrderFormText,
    cancelOrderCallback = _ref.cancelOrderCallback,
    wrongPassCodeError = _ref.wrongPassCodeError,
    timerStartDate = _ref.timerStartDate,
    timerEndDate = _ref.timerEndDate,
    timerEndedCancelModalBodyText = _ref.timerEndedCancelModalBodyText,
    timerEndedCancelModalButtonCallback = _ref.timerEndedCancelModalButtonCallback,
    timerEndedCancelModalButtonText = _ref.timerEndedCancelModalButtonText,
    timerEndedCancelModalTitleText = _ref.timerEndedCancelModalTitleText,
    imageSrc = _ref.imageSrc,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    timerEndedModalIsOpen = _useState2[0],
    setTimerEndedModalIsOpen = _useState2[1];
  var submitOrderImageSrc = imageSrc || _assets_images_enter_passcode_png__WEBPACK_IMPORTED_MODULE_2__["default"];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
    className: "submitOrder"
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "submitOrder__formAndImage"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SubmitOrderForm_SubmitOrderForm__WEBPACK_IMPORTED_MODULE_1__["default"], {
    brandName: brandName,
    fromAddress: fromAddress,
    toAddress: toAddress,
    gasFee: gasFee,
    totals: totals,
    passcodeInputOnChangeCallback: passcodeInputOnChangeCallback,
    submitOrderLoading: submitOrderLoading,
    submitOrderCallback: submitOrderCallback,
    submitOrderFormText: submitOrderFormText,
    cancelOrderCallback: cancelOrderCallback,
    wrongPassCodeError: wrongPassCodeError
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "submitOrder__imageWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "submitOrder__timerWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_CircleTimer_CircleTimer__WEBPACK_IMPORTED_MODULE_3__["default"], {
    timerStartDate: timerStartDate,
    timerEndDate: timerEndDate,
    timerEndedCallback: function timerEndedCallback() {
      return setTimerEndedModalIsOpen(true);
    },
    radius: 80
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "submitOrder__formAndImage__image",
    src: submitOrderImageSrc,
    alt: "fun graphic"
  }))), timerEndedModalIsOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_4__.TimerEndedCancelModal, {
    bodyText: timerEndedCancelModalBodyText,
    buttonCallback: timerEndedCancelModalButtonCallback,
    buttonText: timerEndedCancelModalButtonText,
    titleText: timerEndedCancelModalTitleText
  }));
}
SubmitOrder.propTypes = {
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  fromAddress: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  toAddress: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string.isRequired),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number)
  }).isRequired,
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  totals: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number.isRequired)
  }).isRequired,
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  passcodeInputOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  submitOrderLoading: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  submitOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  //** Props to allow text customization of submit order form */
  submitOrderFormText: prop_types__WEBPACK_IMPORTED_MODULE_6___default().shape({
    titleText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    toolTip: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    submitButton: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    cancelButton: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
  }),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** This is passed to the child component: `SubmitOrderForm` (see Related Comopnents section above) */
  wrongPassCodeError: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
  /** This is passed to the child component: `CircleTimer` (see Related Comopnents section above) */
  timerStartDate: prop_types__WEBPACK_IMPORTED_MODULE_6___default().instanceOf(Date).isRequired,
  /** This is passed to the child component: `CircleTimer` (see Related Comopnents section above) */
  timerEndDate: prop_types__WEBPACK_IMPORTED_MODULE_6___default().instanceOf(Date).isRequired,
  /** This is passed to the child component: `TimerEndedCancelModal` (see Related Comopnents section above) */
  timerEndedCancelModalBodyText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** This is passed to the child component: `TimerEndedCancelModal` (see Related Comopnents section above) */
  timerEndedCancelModalButtonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired),
  /** This is passed to the child component: `TimerEndedCancelModal` (see Related Comopnents section above) */
  timerEndedCancelModalButtonText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** This is passed to the child component: `TimerEndedCancelModal` (see Related Comopnents section above) */
  timerEndedCancelModalTitleText: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
  /** The path/src of the image you want dispalyed in this component. If you don't provide one, a default image will be used */
  imageSrc: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
};

/***/ }),
/* 253 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SubmitOrderForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _DataDisplay_InfoIcon_infoIcon_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _submitOrderForm_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(254);
var _excluded = ["brandName", "fromAddress", "toAddress", "gasFee", "totals", "passcodeInputOnChangeCallback", "submitOrderLoading", "submitOrderCallback", "submitOrderFormText", "cancelOrderCallback", "wrongPassCodeError"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





function SubmitOrderForm(_ref) {
  var brandName = _ref.brandName,
    fromAddress = _ref.fromAddress,
    toAddress = _ref.toAddress,
    gasFee = _ref.gasFee,
    totals = _ref.totals,
    passcodeInputOnChangeCallback = _ref.passcodeInputOnChangeCallback,
    _ref$submitOrderLoadi = _ref.submitOrderLoading,
    submitOrderLoading = _ref$submitOrderLoadi === void 0 ? false : _ref$submitOrderLoadi,
    submitOrderCallback = _ref.submitOrderCallback,
    submitOrderFormText = _ref.submitOrderFormText,
    cancelOrderCallback = _ref.cancelOrderCallback,
    wrongPassCodeError = _ref.wrongPassCodeError,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    passCode = _useState2[0],
    setPassCode = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCancelOrderConfirmation = _useState4[0],
    setShowCancelOrderConfirmation = _useState4[1];
  var handlePasscodeChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    setPassCode(e.target.value);
    passcodeInputOnChangeCallback(e.target.value);
  }, []);
  var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    e.preventDefault();
    submitOrderCallback(passCode);
  }, [passCode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("form", _extends({
    className: "submitOrderForm",
    onSubmit: handleSubmit
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
    className: "heading",
    "data-core-qa": "submitOrderTitleText"
  }, (submitOrderFormText === null || submitOrderFormText === void 0 ? void 0 : submitOrderFormText.titleText) || 'Submit Order'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "description",
    "data-core-qa": "submitOrderBodyText"
  }, (submitOrderFormText === null || submitOrderFormText === void 0 ? void 0 : submitOrderFormText.bodyText) || 'You are sending your payment from your brand wallet. Please verify your passcode below.'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "submitOrderInputFromAddress",
    id: "fromAddress",
    className: "submitOrderFormInput",
    labelText: "From",
    placeholder: "Nerd wallet address",
    value: fromAddress,
    disabled: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "submitOrderInputToAddress",
    id: "toAddress",
    className: "submitOrderFormInput",
    labelText: "To",
    placeholder: "Receiving address",
    value: toAddress,
    disabled: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "grid2Rows"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow1 gridFirst2Col gasFeeText",
    "data-core-qa": "submitOrderHeadingGasFee"
  }, "Gas Fee (Estimate)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow1 gridCol3 gasFeeText",
    "data-core-qa": "submitOrderGasFeeUSD"
  }, "Price:", ' ', gasFee.USD.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow1 gridCol4 gasFeeText",
    "data-core-qa": "submitOrderGasFeeCoin"
  }, "ETH ", gasFee.ETH.toFixed(5)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow2 gridCol1 gasFeeText bold",
    "data-core-qa": "submitOrderHeadingTotal"
  }, "Total"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow2 gridCol2 gasFeeText bold",
    "data-core-qa": "submitOrderHeadingTotalQnty"
  }, "Qty: ", totals.totalQuantity), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow2 gridCol3 gasFeeText bold",
    "data-core-qa": "submitOrderHeadingTotalUSD"
  }, "Price:", ' ', totals.totalCurrency.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "gridRow2 gridCol4 gasFeeText bold",
    "data-core-qa": "submitOrderHeadingTotalCoin"
  }, "ETH ", totals.totalETH.toFixed(5))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("hr", {
    className: "gasFeeHr"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "labelTextWrapper",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "labelText",
    "data-core-qa": "submitOrderPasscodeText"
  }, brandName, " Wallet Passcode"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Tooltip, {
    "data-core-qa": "submitTooltip",
    className: "tooltip",
    popupContent: (submitOrderFormText === null || submitOrderFormText === void 0 ? void 0 : submitOrderFormText.toolTip) || 'This is your wallet passcode, not your 12 word phrase.'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_DataDisplay_InfoIcon_infoIcon_jsx__WEBPACK_IMPORTED_MODULE_1__["default"], null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Input, {
    "data-core-qa": "submitOrderInputPassword",
    type: "password",
    id: "passcode",
    className: "submitOrderFormInput",
    invalid: wrongPassCodeError,
    invalidText: "Incorrect wallet passcode",
    placeholder: "Passcode",
    labelText: "",
    value: passCode,
    onChange: handlePasscodeChange,
    onBlur: function onBlur() {}
  }), showCancelOrderConfirmation ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Modal, {
    modalClassName: "cancelModal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.CancelOrderConfirmation, {
    dontCancelOrderCallback: function dontCancelOrderCallback() {
      return setShowCancelOrderConfirmation(false);
    },
    cancelOrderCallback: cancelOrderCallback
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    "data-core-qa": "submitOrderButtonSubmit",
    className: "submitButton",
    disabled: !passCode,
    type: "submit",
    loading: submitOrderLoading
  }, (submitOrderFormText === null || submitOrderFormText === void 0 ? void 0 : submitOrderFormText.submitButton) || 'Submit Order'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_2__.Button, {
    "data-core-qa": "submitOrderButtonCancel",
    className: "cancelButton",
    onClick: function onClick() {
      return setShowCancelOrderConfirmation(true);
    },
    type: "button",
    kind: "outlined"
  }, (submitOrderFormText === null || submitOrderFormText === void 0 ? void 0 : submitOrderFormText.cancelButton) || 'Cancel')));
}
SubmitOrderForm.propTypes = {
  /** This shows up on the wallet passcode input label */
  brandName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  fromAddress: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  toAddress: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
  /** These values are used to show the gas fee estimates in the form */
  gasFee: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    USD: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    ETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
  }).isRequired,
  /** These values are used to show the order details in the form */
  totals: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    totalQuantity: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    totalCurrency: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number.isRequired)
  }).isRequired,
  /** Anytime the passcode input value changes, the new value will be passed to this callback function */
  passcodeInputOnChangeCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
  /** If this is true, the loading button will show a loading spinner */
  submitOrderLoading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
  /** Called when the form is submitted */
  submitOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  //** Props to allow text customization */
  submitOrderFormText: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
    titleText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toolTip: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    submitButton: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    cancelButton: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
  }),
  /** Called when the cancel button is clicked */
  cancelOrderCallback: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
  /** If this is true, the wallet passcode input will display an error message to the user to let them know the passcode is incorrect */
  wrongPassCodeError: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
};

/***/ }),
/* 254 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 255 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "fe2f61e3b62fdec23370d0e8d03fc6e7.png");

/***/ }),
/* 256 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 257 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _timerEndedCancelModal_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(258);




var TimerEndedCancelModal = function TimerEndedCancelModal(_ref) {
  var _ref$bodyText = _ref.bodyText,
    bodyText = _ref$bodyText === void 0 ? 'Your order was not submitted in time and has been cancelled. You are being returned to the Purchase page where you can begin to place another order' : _ref$bodyText,
    buttonCallback = _ref.buttonCallback,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Return to Purchase Page' : _ref$buttonText,
    _ref$titleText = _ref.titleText,
    titleText = _ref$titleText === void 0 ? 'Your order has been cancelled' : _ref$titleText;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Modal, {
    modalClassName: "timer-ended-cancel-modal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flexColumn timer-ended-cancel"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "timer-ended-cancel__title",
    "data-core-qa": "timerEndTitleText"
  }, titleText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "timer-ended-cancel__text",
    "data-core-qa": "timerEndTitleSubText"
  }, bodyText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "timer-ended-cancel-buttons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_index__WEBPACK_IMPORTED_MODULE_1__.Button, {
    "data-core-qa": "timerEndButtonConfirm",
    onClick: buttonCallback,
    className: "timer-ended-cancel-buttons__primary",
    type: "button"
  }, buttonText))));
};
TimerEndedCancelModal.propTypes = {
  /** Subtext/body text*/
  bodyText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Callback fired on button onClick */
  buttonCallback: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func.isRequired),
  /** Text displayed on the button */
  buttonText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  /** Heading text */
  titleText: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (TimerEndedCancelModal);

/***/ }),
/* 258 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),
/* 259 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Wallet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assets_icons_nerdCoreKit_CopyIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(176);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var qrcode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(127);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _wallet_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(260);
var _excluded = ["wallet", "qrCode"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var initialClipboardState = {
  value: '',
  copied: false
};
function Wallet(_ref) {
  var wallet = _ref.wallet,
    qrCode = _ref.qrCode,
    rest = _objectWithoutProperties(_ref, _excluded);
  var qrRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialClipboardState),
    _useState2 = _slicedToArray(_useState, 2),
    clipboard = _useState2[0],
    setClipboard = _useState2[1];
  var copyWallet = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setClipboard(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, {
        copied: true
      });
    });
    setTimeout(function () {
      setClipboard(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          copied: false
        });
      });
    }, 1600);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (qrCode && qrRef !== null && qrRef !== void 0 && qrRef.current) {
      var qrCodeOptions = {
        margin: 0,
        width: 175
      };
      qrcode__WEBPACK_IMPORTED_MODULE_2__.toCanvas(qrRef.current, wallet.id, qrCodeOptions, function (error) {
        if (error) console.error(error);
      });
    }
  }, [qrCode, qrRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("article", _extends({
    className: "shoppingWallet"
  }, rest), qrCode ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("canvas", {
    className: "shoppingWallet__qrCode",
    ref: qrRef,
    "data-core-qa": "walletQRCode"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "shoppingWallet__text--medium"
  }, "OR")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    className: "shoppingWallet__brandLogo",
    src: wallet.icon
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "shoppingWallet__walletName",
    "data-core-qa": "walletNameText"
  }, wallet.name)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shoppingWallet__id ".concat(qrCode ? 'addBorder' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "shoppingWallet__idText",
    "data-core-qa": "walletIDText"
  }, wallet.id), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "shoppingWallet__copy"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
    text: wallet.id,
    onCopy: copyWallet
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_assets_icons_nerdCoreKit_CopyIcon__WEBPACK_IMPORTED_MODULE_1__["default"], null)), clipboard.copied && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "shoppingWallet__tooltip",
    "data-core-qa": "walletButtonCopy"
  }, "Copied!"))));
}
Wallet.propTypes = {
  /** Wallet data object */
  wallet: prop_types__WEBPACK_IMPORTED_MODULE_5___default().shape({
    id: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    icon: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    totalETH: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    totalUSD: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number)
  }),
  /** Bool prop used to generate and display a qr code containing the wallet address. This is not a qr link. */
  qrCode: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};

/***/ }),
/* 260 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;